import "client-only";
import { jsx as n, jsxs as b, Fragment as ie } from "react/jsx-runtime";
import Oi, { forwardRef as C, useId as X, createContext as ae, useContext as Z, useMemo as Re, useEffect as W, Fragment as _t, useState as Q, useRef as B, useCallback as le, useImperativeHandle as pe, createElement as $t, useReducer as In, Children as Wi, isValidElement as Hi, version as Gi } from "react";
import { Content as Ui, Item as Yi, Root as Ki, Trigger as Qi } from "@radix-ui/react-accordion";
import { useFocusWithin as kn, usePopover as Rn, Overlay as Pn, DismissButton as ot, useListBox as Xi, useOption as Zi, useFilter as Ji, useComboBox as er, useButton as Et, I18nProvider as tr, useLocale as Mt, useDateField as nr, useCalendar as ir, useDialog as rr, useRangeCalendar as sr, useDateSegment as or, useCalendarGrid as ar, useCalendarCell as lr, useDatePicker as cr, useDateRangePicker as dr, useNumberField as Sn, useNumberFormatter as an, useSlider as ur, useSliderThumb as _r, useFocusRing as zn, VisuallyHidden as mr, mergeProps as $n, useSwitch as hr, usePress as fr, useKeyboard as pr } from "react-aria";
import { Slot as re, Slottable as Ft } from "@radix-ui/react-slot";
import { QuestionMarkIcon as En, CloseIcon as Mn, ArrowLeftIcon as gr, ArrowRightIcon as br, OpenInNewIcon as Fn, InfoIcon as yr, CalendarIcon as xr, ChevronLeftIcon as Dn, ChevronRightIcon as Bn, SBABLogo as wr, SuccessRingIcon as qn, ExclamationRingIcon as An, BinIcon as vr, XRingIcon as Nr, InfoRingIcon as Cr } from "@sbab-ui/icons";
import { Root as Ir, Trigger as kr, Content as Rr } from "@radix-ui/react-collapsible";
import { usePreventScroll as Pr } from "@react-aria/overlays";
import { useComboBoxState as Sr, Item as zr, useDateFieldState as $r, useCalendarState as Er, useRangeCalendarState as Mr, useDatePickerState as Fr, useDateRangePickerState as Dr, useNumberFieldState as Ln, useSliderState as Br, useToggleState as qr } from "react-stately";
import { announce as Tn, clearAnnouncer as Ar } from "@react-aria/live-announcer";
import { GregorianCalendar as Lr, endOfMonth as Tr, getWeeksInMonth as Vr, isSameMonth as jr, isSameDay as ln, parseDate as me } from "@internationalized/date";
import { tokenWithFallback as U, token as tt } from "@sbab-ui/tokens";
import * as Qe from "@radix-ui/react-popover";
import { NumericFormat as Or } from "react-number-format";
function Wr() {
  let e = 0, t, i = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (i && (i += " "), i += t);
  return i;
}
const g = Wr, Hr = "_AccordionItem_b2tal_1", Gr = "_AccordionTrigger_b2tal_14", Ur = "_AccordionContent_b2tal_62", Yr = "_AccordionContentContainer_b2tal_74", at = {
  AccordionItem: Hr,
  AccordionTrigger: Gr,
  AccordionContent: Ur,
  AccordionContentContainer: Yr
};
function Kr({ children: e, className: t, ...i }, r) {
  return /* @__PURE__ */ n(
    Ui,
    {
      ...i,
      className: g(at.AccordionContent, t),
      ref: r,
      children: /* @__PURE__ */ n("div", { className: at.AccordionContentContainer, children: e })
    }
  );
}
const Qr = /* @__PURE__ */ C(
  Kr
), Xr = /* @__PURE__ */ C(
  function({ className: t, onExpand: i, value: r, ...s }, l) {
    const a = X();
    return /* @__PURE__ */ n(
      Yi,
      {
        ...s,
        className: g(at.AccordionItem, t),
        onClick: (u) => {
          var c, d;
          const { target: h } = u;
          ((c = h.dataset) == null ? void 0 : c.accordionTrigger) === "true" && ((d = h.dataset) == null ? void 0 : d.state) === "closed" && (i == null || i());
        },
        value: r || `${a}-value`,
        ref: l
      }
    );
  }
);
function Zr({ children: e, onChange: t, ...i }, r) {
  return /* @__PURE__ */ n(
    Ki,
    {
      ...i,
      onValueChange: t,
      ref: r,
      type: "multiple",
      children: e
    }
  );
}
const Jr = /* @__PURE__ */ C(
  Zr
);
function es({ children: e, className: t, ...i }, r) {
  return /* @__PURE__ */ b(
    Qi,
    {
      ...i,
      className: g(at.AccordionTrigger, t),
      "data-accordion-trigger": "true",
      ref: r,
      children: [
        e,
        /* @__PURE__ */ b("svg", { viewBox: "0 0 24 24", width: "1.5rem", height: "1.5rem", "aria-hidden": !0, children: [
          /* @__PURE__ */ n("rect", { x: "3", y: "10.5", width: "18", height: "3" }),
          /* @__PURE__ */ n("rect", { x: "10.5", y: "3", width: "3", height: "18" })
        ] })
      ]
    }
  );
}
const ts = /* @__PURE__ */ C(
  es
), Fu = {
  Content: Qr,
  Root: Jr,
  Trigger: ts,
  Item: Xr
}, ns = "_link_14xez_1", is = "_arrow_14xez_15", je = {
  link: ns,
  arrow: is,
  "arrow--high-contrast": "_arrow--high-contrast_14xez_20"
}, rs = "_focus_5lsiw_1", ss = "_focusVisible_5lsiw_6", os = "_focusWithin_5lsiw_11", as = "_focusInside_5lsiw_16", ls = "_focusInsideVisible_5lsiw_21", cs = "_focusInsideWithin_5lsiw_26", ds = "_focusOutside_5lsiw_31", us = "_focusOutsideVisible_5lsiw_36", _s = "_focusOutsideWithin_5lsiw_41", ye = {
  focus: rs,
  focusVisible: ss,
  focusWithin: os,
  focusInside: as,
  focusInsideVisible: ls,
  focusInsideWithin: cs,
  focusOutside: ds,
  focusOutsideVisible: us,
  focusOutsideWithin: _s
}, Dt = {
  ":focus": ye.focus,
  ":focus-visible": ye.focusVisible,
  ":focus-within": ye.focusWithin,
  inside: {
    ":focus": ye.focusInside,
    ":focus-visible": ye.focusInsideVisible,
    ":focus-within": ye.focusInsideWithin
  },
  outside: {
    ":focus": ye.focusOutside,
    ":focus-visible": ye.focusOutsideVisible,
    ":focus-within": ye.focusOutsideWithin
  }
}, ms = "_gap_1ka55_39", hs = {
  gap: ms,
  "gap-x": "_gap-x_1ka55_43",
  "gap-y": "_gap-y_1ka55_47",
  "gap-sm": "_gap-sm_1ka55_52",
  "gap-x-sm": "_gap-x-sm_1ka55_55",
  "gap-y-sm": "_gap-y-sm_1ka55_58",
  "gap-md": "_gap-md_1ka55_63",
  "gap-x-md": "_gap-x-md_1ka55_66",
  "gap-y-md": "_gap-y-md_1ka55_69",
  "gap-lg": "_gap-lg_1ka55_74",
  "gap-x-lg": "_gap-x-lg_1ka55_77",
  "gap-y-lg": "_gap-y-lg_1ka55_80"
}, fs = "_m_8eu5p_39", ps = "_mx_8eu5p_43", gs = "_my_8eu5p_48", bs = "_mt_8eu5p_53", ys = "_mr_8eu5p_57", xs = "_mb_8eu5p_61", ws = "_ml_8eu5p_65", vs = {
  m: fs,
  mx: ps,
  my: gs,
  mt: bs,
  mr: ys,
  mb: xs,
  ml: ws,
  "m-sm": "_m-sm_8eu5p_70",
  "mx-sm": "_mx-sm_8eu5p_73",
  "my-sm": "_my-sm_8eu5p_77",
  "mt-sm": "_mt-sm_8eu5p_81",
  "mr-sm": "_mr-sm_8eu5p_84",
  "mb-sm": "_mb-sm_8eu5p_87",
  "ml-sm": "_ml-sm_8eu5p_90",
  "m-md": "_m-md_8eu5p_95",
  "mx-md": "_mx-md_8eu5p_98",
  "my-md": "_my-md_8eu5p_102",
  "mt-md": "_mt-md_8eu5p_106",
  "mr-md": "_mr-md_8eu5p_109",
  "mb-md": "_mb-md_8eu5p_112",
  "ml-md": "_ml-md_8eu5p_115",
  "m-lg": "_m-lg_8eu5p_120",
  "mx-lg": "_mx-lg_8eu5p_123",
  "my-lg": "_my-lg_8eu5p_127",
  "mt-lg": "_mt-lg_8eu5p_131",
  "mr-lg": "_mr-lg_8eu5p_134",
  "mb-lg": "_mb-lg_8eu5p_137",
  "ml-lg": "_ml-lg_8eu5p_140"
}, Ns = "_p_18r8z_28", Cs = "_px_18r8z_43", Is = "_py_18r8z_48", ks = "_pt_18r8z_53", Rs = "_pr_18r8z_57", Ps = "_pb_18r8z_61", Ss = "_pl_18r8z_65", zs = {
  p: Ns,
  px: Cs,
  py: Is,
  pt: ks,
  pr: Rs,
  pb: Ps,
  pl: Ss,
  "p-sm": "_p-sm_18r8z_70",
  "px-sm": "_px-sm_18r8z_73",
  "py-sm": "_py-sm_18r8z_77",
  "pt-sm": "_pt-sm_18r8z_81",
  "pr-sm": "_pr-sm_18r8z_84",
  "pb-sm": "_pb-sm_18r8z_87",
  "pl-sm": "_pl-sm_18r8z_90",
  "p-md": "_p-md_18r8z_33",
  "px-md": "_px-md_18r8z_98",
  "py-md": "_py-md_18r8z_102",
  "pt-md": "_pt-md_18r8z_106",
  "pr-md": "_pr-md_18r8z_109",
  "pb-md": "_pb-md_18r8z_112",
  "pl-md": "_pl-md_18r8z_115",
  "p-lg": "_p-lg_18r8z_120",
  "px-lg": "_px-lg_18r8z_123",
  "py-lg": "_py-lg_18r8z_127",
  "pt-lg": "_pt-lg_18r8z_131",
  "pr-lg": "_pr-lg_18r8z_134",
  "pb-lg": "_pb-lg_18r8z_137",
  "pl-lg": "_pl-lg_18r8z_140"
}, Vn = {
  styles: hs,
  props: {
    gap: {
      customProperty: "--_sbui-gap"
    },
    "gap-x": {
      customProperty: "--_sbui-gap-x"
    },
    "gap-y": {
      customProperty: "--_sbui-gap-y"
    }
  }
}, Bt = {
  styles: vs,
  props: {
    m: {
      customProperty: "--_sbui-m"
    },
    mx: {
      customProperty: "--_sbui-mx"
    },
    my: {
      customProperty: "--_sbui-my"
    },
    mt: {
      customProperty: "--_sbui-mt"
    },
    mr: {
      customProperty: "--_sbui-mr"
    },
    mb: {
      customProperty: "--_sbui-mb"
    },
    ml: {
      customProperty: "--_sbui-ml"
    }
  }
}, $s = {
  styles: zs,
  props: {
    p: {
      customProperty: "--_sbui-p"
    },
    px: {
      customProperty: "--_sbui-px"
    },
    py: {
      customProperty: "--_sbui-py"
    },
    pt: {
      customProperty: "--_sbui-pt"
    },
    pr: {
      customProperty: "--_sbui-pr"
    },
    pb: {
      customProperty: "--_sbui-pb"
    },
    pl: {
      customProperty: "--_sbui-pl"
    }
  }
};
function Ze(e, ...t) {
  const i = [];
  let r = e.style ? { ...e.style } : void 0;
  const s = { ...e };
  return t.forEach((l) => {
    const { styles: a } = l;
    Object.entries(l.props).forEach(([u, { customProperty: h }]) => {
      u in e && (delete s[u], e[u] !== void 0 && (i.push(a[u]), h && (r ?? (r = {}), r[h] = e[u])));
      for (const o of ["sm", "md", "lg"]) {
        const c = `${o}-${u}`;
        c in e && (delete s[c], e[c] !== void 0 && (i.push(a[`${u}-${o}`]), h && (r ?? (r = {}), r[`${h}-${o}`] = e[c])));
      }
    });
  }), e.className && i.push(e.className), {
    ...s,
    className: i.join(" "),
    style: r
  };
}
const Es = "_size_fydz9_39", Ms = "_height_fydz9_44", Fs = "_minHeight_fydz9_48", Ds = "_maxHeight_fydz9_52", Bs = "_width_fydz9_56", qs = "_minWidth_fydz9_60", As = "_maxWidth_fydz9_64", Ls = {
  size: Es,
  height: Ms,
  minHeight: Fs,
  maxHeight: Ds,
  width: Bs,
  minWidth: qs,
  maxWidth: As,
  "size-sm": "_size-sm_fydz9_69",
  "height-sm": "_height-sm_fydz9_73",
  "minHeight-sm": "_minHeight-sm_fydz9_76",
  "maxHeight-sm": "_maxHeight-sm_fydz9_79",
  "width-sm": "_width-sm_fydz9_82",
  "minWidth-sm": "_minWidth-sm_fydz9_85",
  "maxWidth-sm": "_maxWidth-sm_fydz9_88",
  "size-md": "_size-md_fydz9_93",
  "height-md": "_height-md_fydz9_97",
  "minHeight-md": "_minHeight-md_fydz9_100",
  "maxHeight-md": "_maxHeight-md_fydz9_103",
  "width-md": "_width-md_fydz9_106",
  "minWidth-md": "_minWidth-md_fydz9_109",
  "maxWidth-md": "_maxWidth-md_fydz9_112",
  "size-lg": "_size-lg_fydz9_117",
  "height-lg": "_height-lg_fydz9_121",
  "minHeight-lg": "_minHeight-lg_fydz9_124",
  "maxHeight-lg": "_maxHeight-lg_fydz9_127",
  "width-lg": "_width-lg_fydz9_130",
  "minWidth-lg": "_minWidth-lg_fydz9_133",
  "maxWidth-lg": "_maxWidth-lg_fydz9_136"
}, jn = {
  styles: Ls,
  props: {
    size: {
      customProperty: "--_sbui-size"
    },
    height: {
      customProperty: "--_sbui-height"
    },
    minHeight: {
      customProperty: "--_sbui-min-height"
    },
    maxHeight: {
      customProperty: "--_sbui-max-height"
    },
    width: {
      customProperty: "--_sbui-width"
    },
    minWidth: {
      customProperty: "--_sbui-min-width"
    },
    maxWidth: {
      customProperty: "--_sbui-max-width"
    }
  }
}, Ts = "_alignSelf_19ght_39", Vs = "_flexGrow_19ght_43", js = "_flexShrink_19ght_47", Os = "_flexBasis_19ght_51", Ws = "_flex_19ght_43", Hs = {
  alignSelf: Ts,
  flexGrow: Vs,
  flexShrink: js,
  flexBasis: Os,
  flex: Ws,
  "alignSelf-sm": "_alignSelf-sm_19ght_60",
  "flexGrow-sm": "_flexGrow-sm_19ght_63",
  "flexShrink-sm": "_flexShrink-sm_19ght_66",
  "flexBasis-sm": "_flexBasis-sm_19ght_69",
  "flex-sm": "_flex-sm_19ght_72",
  "alignSelf-md": "_alignSelf-md_19ght_77",
  "flexGrow-md": "_flexGrow-md_19ght_80",
  "flexShrink-md": "_flexShrink-md_19ght_83",
  "flexBasis-md": "_flexBasis-md_19ght_86",
  "flex-md": "_flex-md_19ght_89",
  "alignSelf-lg": "_alignSelf-lg_19ght_94",
  "flexGrow-lg": "_flexGrow-lg_19ght_97",
  "flexShrink-lg": "_flexShrink-lg_19ght_100",
  "flexBasis-lg": "_flexBasis-lg_19ght_103",
  "flex-lg": "_flex-lg_19ght_106"
}, Gs = {
  styles: Hs,
  props: {
    alignSelf: {
      customProperty: "--_sbui-align-self"
    },
    flexGrow: {
      customProperty: "--_sbui-flex-grow"
    },
    flexShrink: {
      customProperty: "--_sbui-flex-shrink"
    },
    flexBasis: {
      customProperty: "--_sbui-flex-basis"
    },
    flex: {
      customProperty: "--_sbui-flex"
    }
  }
}, ce = /* @__PURE__ */ C(function({ as: t = "div", asChild: i, ...r }, s) {
  const l = Ze(
    r,
    $s,
    Bt,
    jn,
    Gs
  );
  return /* @__PURE__ */ n(i ? re : t, { ...l, ref: s });
}), Us = "_flex_4q28z_39", Ys = "_align_4q28z_43", Ks = "_direction_4q28z_47", Qs = "_justify_4q28z_51", Xs = "_wrap_4q28z_55", Zs = "_grow_4q28z_106", He = {
  flex: Us,
  align: Ys,
  direction: Ks,
  justify: Qs,
  wrap: Xs,
  "align-sm": "_align-sm_4q28z_60",
  "direction-sm": "_direction-sm_4q28z_63",
  "justify-sm": "_justify-sm_4q28z_66",
  "wrap-sm": "_wrap-sm_4q28z_69",
  "align-md": "_align-md_4q28z_74",
  "direction-md": "_direction-md_4q28z_77",
  "justify-md": "_justify-md_4q28z_80",
  "wrap-md": "_wrap-md_4q28z_83",
  "align-lg": "_align-lg_4q28z_88",
  "direction-lg": "_direction-lg_4q28z_91",
  "justify-lg": "_justify-lg_4q28z_94",
  "wrap-lg": "_wrap-lg_4q28z_97",
  grow: Zs,
  "grow-md": "_grow-md_4q28z_111",
  "grow-lg": "_grow-lg_4q28z_116"
}, Js = {
  styles: He,
  props: {
    align: {
      customProperty: "--_sbui-flex-align"
    },
    direction: {
      customProperty: "--_sbui-flex-direction"
    },
    justify: {
      customProperty: "--_sbui-flex-justify"
    },
    wrap: {
      customProperty: "--_sbui-flex-wrap"
    }
  }
}, M = /* @__PURE__ */ C(function(t, i) {
  const {
    className: r,
    grow: s,
    "md-grow": l,
    "lg-grow": a,
    style: u = {},
    ...h
  } = Ze(t, Js, Vn);
  return typeof s < "u" && (u["--_sbui-flex-grow"] = s ? 1 : "initial"), typeof l < "u" && (u["--_sbui-flex-grow-md"] = l ? 1 : "initial"), typeof a < "u" && (u["--_sbui-flex-grow-lg"] = a ? 1 : "initial"), /* @__PURE__ */ n(
    ce,
    {
      ...h,
      ref: i,
      className: g(
        He.flex,
        typeof s < "u" && He.grow,
        typeof l < "u" && He["grow-md"],
        typeof a < "u" && He["grow-lg"],
        r
      ),
      style: u
    }
  );
}), On = ae({
  triggerId: "changeme"
});
function Wn() {
  return Z(On);
}
const eo = /* @__PURE__ */ C(
  function(t, i) {
    const r = X(), s = Re(() => ({ triggerId: `${r}-trigger` }), [r]);
    return /* @__PURE__ */ n(On.Provider, { value: s, children: /* @__PURE__ */ n(Ir, { ...t, ref: i }) });
  }
), to = /* @__PURE__ */ C(
  function(t, i) {
    const { triggerId: r } = Wn();
    return /* @__PURE__ */ n(
      kr,
      {
        ...t,
        id: t.id ?? r,
        ref: i
      }
    );
  }
), no = "_animated_1f5b9_1", io = {
  animated: no
}, ro = /* @__PURE__ */ C(
  function({
    animated: t,
    className: i,
    labelled: r,
    region: s,
    style: l,
    ...a
  }, u) {
    const { triggerId: h } = Wn(), o = (r || s) && !a["aria-label"];
    return /* @__PURE__ */ n(
      Rr,
      {
        ref: u,
        className: g(t && io.animated, i),
        "aria-labelledby": o ? h : void 0,
        role: s ? "region" : void 0,
        ...a,
        style: {
          "--sbui-collapsible-content-width": "var(--radix-collapsible-content-width)",
          "--sbui-collapsible-content-height": "var(--radix-collapsible-content-height)",
          ...l
        }
      }
    );
  }
), $e = {
  Root: eo,
  Trigger: to,
  Content: ro
}, so = "_description_v85hp_1", oo = {
  description: so
};
function ao({ children: e, className: t, ...i }, r) {
  return /* @__PURE__ */ n("div", { ...i, ref: r, className: g(oo.description, t), children: e });
}
const qt = /* @__PURE__ */ C(
  ao
), Hn = ae("sv");
function Du({ children: e, locale: t }) {
  return /* @__PURE__ */ n(Hn.Provider, { value: t, children: e });
}
function V() {
  return Z(Hn);
}
const lo = "_label_3w01j_43", co = "_label__secondary_3w01j_52", cn = {
  label: lo,
  label__secondary: co
};
function uo({
  children: e,
  className: t,
  secondaryLabel: i,
  secondaryLabelClassName: r,
  secondaryLabelProps: s = {},
  secondaryLabelRef: l,
  innerRef: a,
  // Prevent block prop from ending up as an attribute on underlying element
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  block: u,
  ...h
}, o) {
  return /* @__PURE__ */ b(
    "label",
    {
      ...h,
      ref: o ?? a,
      className: g(cn.label, t),
      children: [
        e,
        /* @__PURE__ */ n(
          "span",
          {
            ...s,
            className: g(cn.label__secondary, r),
            ref: l,
            children: i
          }
        )
      ]
    }
  );
}
const _o = /* @__PURE__ */ C(
  uo
), mo = "_label_1yata_1", ho = {
  label: mo
};
function fo({ block: e, ...t }, i) {
  const { children: r, className: s, secondaryLabel: l, innerRef: a, ...u } = t;
  return l ? /* @__PURE__ */ n(_o, { ...t, secondaryLabel: l }) : /* @__PURE__ */ n(
    "label",
    {
      ...u,
      ref: i ?? a,
      className: g(ho.label, s),
      children: r
    }
  );
}
const At = /* @__PURE__ */ C(fo);
function po(e) {
  return /* @__PURE__ */ b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      width: "24",
      height: "24",
      ...e,
      children: [
        /* @__PURE__ */ n("path", { d: "M0 0h24v24H0z", fill: "none" }),
        /* @__PURE__ */ n("path", { d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" })
      ]
    }
  );
}
function go(e) {
  return /* @__PURE__ */ b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      width: "24",
      height: "24",
      ...e,
      children: [
        /* @__PURE__ */ n("path", { d: "M0 0h24v24H0z", fill: "none" }),
        /* @__PURE__ */ n("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" })
      ]
    }
  );
}
function bo(e) {
  return /* @__PURE__ */ b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      width: "24",
      height: "24",
      ...e,
      children: [
        /* @__PURE__ */ n("path", { d: "M0 0h24v24H0z", fill: "none" }),
        /* @__PURE__ */ n("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" })
      ]
    }
  );
}
const yo = "_message_fkmqr_1", xo = "_message__icon_fkmqr_18", Ie = {
  message: yo,
  "message--critical": "_message--critical_fkmqr_8",
  "message--warning": "_message--warning_fkmqr_11",
  "message--positive": "_message--positive_fkmqr_14",
  message__icon: xo
};
function wo({ children: e, className: t, tone: i, innerRef: r, ...s }, l) {
  let a = null;
  return i === "critical" && (a = /* @__PURE__ */ n(
    go,
    {
      "aria-hidden": !0,
      className: g(
        Ie.message__icon,
        Ie["message__icon--critical"]
      )
    }
  )), i === "warning" && (a = /* @__PURE__ */ n(
    po,
    {
      "aria-hidden": !0,
      className: g(
        Ie.message__icon,
        Ie["message__icon--warning"]
      )
    }
  )), i === "positive" && (a = /* @__PURE__ */ n(
    bo,
    {
      "aria-hidden": !0,
      className: g(
        Ie.message__icon,
        Ie["message__icon--positive"]
      )
    }
  )), /* @__PURE__ */ b(
    "div",
    {
      ...s,
      ref: l ?? r,
      className: g(
        Ie.message,
        i && Ie[`message--${i}`],
        t
      ),
      children: [
        a,
        e
      ]
    }
  );
}
const lt = /* @__PURE__ */ C(wo);
function vo({
  label: e,
  description: t,
  validationError: i,
  message: r
}, s = {}) {
  const l = X(), a = s.id ?? l, u = s["aria-required"];
  return Re(() => {
    const o = a, c = s.descriptionId ?? `${a}-description`, d = s.labelId ?? `${a}-label`, _ = s.validationErrorId ?? `${a}-validation-error`, m = s.messageId ?? `${a}-message`, f = { id: o };
    return e && (f["aria-labelledby"] = d), t && (f["aria-describedby"] = c), r && (f["aria-describedby"] = f["aria-describedby"] ? `${f["aria-describedby"]} ${m}` : m), i && (f["aria-describedby"] = _, f["aria-invalid"] = !0), u && (f["aria-required"] = u), {
      label: {
        id: d,
        htmlFor: o
      },
      description: {
        id: c
      },
      control: f,
      validationError: {
        id: _
      },
      message: {
        id: m
      }
    };
  }, [
    a,
    e,
    t,
    i,
    r,
    u,
    s.labelId,
    s.descriptionId,
    s.messageId,
    s.validationErrorId
  ]);
}
const No = "_root_cjusp_1", Co = "_field_cjusp_23", nt = {
  root: No,
  field: Co,
  "collapsible-trigger": "_collapsible-trigger_cjusp_27",
  "collapsible-content": "_collapsible-content_cjusp_54"
};
function E({ children: e, fallback: t = null, when: i }) {
  return i ? e : t;
}
const de = /* @__PURE__ */ C(
  function({
    "aria-required": t,
    // Prevent block prop from ending up as an attribute on underlying element
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    block: i,
    children: r,
    className: s,
    description: l,
    descriptionProps: a = {},
    contextualHelp: u,
    id: h,
    label: o,
    labelClassName: c,
    labelProps: d = {},
    labelRef: _,
    message: m,
    messageClassName: f,
    messageProps: p = {},
    messageRef: y,
    messageTone: x,
    secondaryLabel: k,
    supplemental: I,
    tone: w,
    validationError: v,
    validationErrorProps: R = {},
    labelId: F,
    descriptionId: q,
    validationErrorId: N,
    messageId: $,
    ...P
  }, S) {
    const A = V(), z = X(), L = l ?? k, T = vo(
      {
        description: L,
        label: o,
        validationError: v,
        message: m && !v
      },
      {
        "aria-required": t,
        id: h,
        labelId: F,
        descriptionId: q,
        validationErrorId: N,
        messageId: $
      }
    ), G = u ? $e.Root : "div", ue = {
      ...u && {
        onOpenChange: (Y) => {
          var te;
          return Y && ((te = u.onExpand) == null ? void 0 : te.call(u));
        }
      }
    }, J = o || u || L, be = v || m;
    return /* @__PURE__ */ n(
      M,
      {
        className: nt.field,
        asChild: !0,
        ...P,
        direction: "column",
        gap: ".5rem",
        ref: S,
        children: /* @__PURE__ */ b(
          G,
          {
            className: g(nt.root, s),
            ...ue,
            children: [
              /* @__PURE__ */ n(E, { when: J, children: /* @__PURE__ */ b("div", { children: [
                /* @__PURE__ */ n(E, { when: o || u, children: /* @__PURE__ */ b(M, { align: "flex-start", justify: "space-between", gap: ".5rem", children: [
                  /* @__PURE__ */ n(
                    At,
                    {
                      ...T.label,
                      ...d,
                      className: c,
                      ref: _,
                      children: o
                    }
                  ),
                  /* @__PURE__ */ n(E, { when: u, children: /* @__PURE__ */ n($e.Trigger, { asChild: !0, children: /* @__PURE__ */ b(
                    "button",
                    {
                      "aria-label": (u == null ? void 0 : u.title) ?? (A === "en" ? o && typeof o == "string" ? `More information about ${o}` : "More information" : o && typeof o == "string" ? `Mer information om ${o}` : "Mer information"),
                      className: nt["collapsible-trigger"],
                      id: z,
                      children: [
                        /* @__PURE__ */ n(En, {}),
                        /* @__PURE__ */ n(Mn, {})
                      ]
                    }
                  ) }) })
                ] }) }),
                /* @__PURE__ */ n(E, { when: L, children: /* @__PURE__ */ n(qt, { ...T.description, ...a, children: L }) }),
                /* @__PURE__ */ n(E, { when: u, children: /* @__PURE__ */ n(
                  $e.Content,
                  {
                    animated: !0,
                    region: !0,
                    "aria-labelledby": z,
                    className: nt["collapsible-content"],
                    children: /* @__PURE__ */ n("div", { children: u == null ? void 0 : u.content })
                  }
                ) })
              ] }) }),
              I,
              /* @__PURE__ */ n("div", { children: r == null ? void 0 : r(T.control, { isInvalid: !!v }) }),
              /* @__PURE__ */ n(E, { when: be, children: /* @__PURE__ */ b("div", { children: [
                /* @__PURE__ */ n(E, { when: v, children: /* @__PURE__ */ n(
                  lt,
                  {
                    ...T.validationError,
                    ...R,
                    tone: "critical",
                    children: v
                  }
                ) }),
                /* @__PURE__ */ n(E, { when: m && !v, children: /* @__PURE__ */ n(
                  lt,
                  {
                    ...T.message,
                    ...p,
                    ref: y,
                    className: f,
                    tone: x ?? w,
                    children: m
                  }
                ) })
              ] }) })
            ]
          }
        )
      }
    );
  }
), Io = "_grid_1wiho_39", ko = "_columns_1wiho_43", Ro = "_place_1wiho_47", Gn = {
  grid: Io,
  columns: ko,
  place: Ro,
  "columns-sm": "_columns-sm_1wiho_52",
  "place-sm": "_place-sm_1wiho_55",
  "columns-md": "_columns-md_1wiho_60",
  "place-md": "_place-md_1wiho_63",
  "columns-lg": "_columns-lg_1wiho_68",
  "place-lg": "_place-lg_1wiho_71"
}, Po = {
  styles: Gn,
  props: {
    columns: {
      customProperty: "--_sbui-grid-columns"
    },
    place: {
      customProperty: "--_sbui-grid-place"
    }
  }
}, So = "_align_11729_39", zo = {
  align: So,
  "align-sm": "_align-sm_11729_44",
  "align-md": "_align-md_11729_49",
  "align-lg": "_align-lg_11729_54"
}, $o = {
  styles: zo,
  props: {
    align: {
      customProperty: "--_sbui-align"
    }
  }
}, Eo = /* @__PURE__ */ C(function(t, i) {
  const { className: r, ...s } = Ze(
    t,
    Po,
    $o,
    Vn
  );
  return /* @__PURE__ */ n(ce, { ...s, className: g(Gn.grid, r), ref: i });
}), Mo = "_spacer_871jg_43", Fo = "_hidden_871jg_47", Fe = {
  spacer: Mo,
  hidden: Fo,
  "hidden-md": "_hidden-md_871jg_52",
  "visible-md": "_visible-md_871jg_55",
  "hidden-lg": "_hidden-lg_871jg_60",
  "visible-lg": "_visible-lg_871jg_63"
};
function Bu({
  className: e,
  hidden: t,
  "md-hidden": i,
  "lg-hidden": r,
  style: s
}) {
  return /* @__PURE__ */ n(
    "div",
    {
      "aria-hidden": !0,
      className: g(
        Fe.spacer,
        t && Fe.hidden,
        i === !0 && Fe["hidden-md"],
        i === !1 && Fe["visible-md"],
        r === !0 && Fe["hidden-lg"],
        r === !1 && Fe["visible-lg"],
        e
      ),
      style: s
    }
  );
}
function Do(e) {
  return /* @__PURE__ */ n(M, { direction: "column", ...e });
}
const qu = /* @__PURE__ */ C(
  function({
    asChild: t,
    children: i,
    className: r,
    direction: s = "forward",
    highContrast: l,
    ...a
  }, u) {
    return /* @__PURE__ */ b(
      t ? re : "a",
      {
        ...a,
        className: g(je.link, Dt[":focus"], r),
        ref: u,
        children: [
          /* @__PURE__ */ n(E, { when: s === "backward", children: /* @__PURE__ */ n(
            gr,
            {
              className: g(
                je.arrow,
                l && je["arrow--high-contrast"]
              )
            }
          ) }),
          /* @__PURE__ */ n(Ft, { children: i }),
          /* @__PURE__ */ n(E, { when: s === "forward", children: /* @__PURE__ */ n(
            br,
            {
              size: "1.5em",
              className: g(
                je.arrow,
                l && je["arrow--high-contrast"]
              )
            }
          ) })
        ]
      }
    );
  }
), Bo = "_badge_mzhne_1", qo = "_icon_mzhne_36", qe = {
  badge: Bo,
  "badge--neutral": "_badge--neutral_mzhne_12",
  "badge--critical": "_badge--critical_mzhne_18",
  "badge--warning": "_badge--warning_mzhne_24",
  "badge--positive": "_badge--positive_mzhne_30",
  icon: qo
};
function Ao(e, t) {
  return Re(
    () => g(
      qe.badge,
      e === "neutral" && qe["badge--neutral"],
      e === "critical" && qe["badge--critical"],
      e === "warning" && qe["badge--warning"],
      e === "positive" && qe["badge--positive"],
      t
    ),
    [e, t]
  );
}
const Au = /* @__PURE__ */ C(
  function({ children: t, className: i, icon: r, variant: s = "neutral" }, l) {
    const a = Ao(s, i);
    return /* @__PURE__ */ b(
      "div",
      {
        className: g(a),
        role: "status",
        "aria-live": "polite",
        ref: l,
        children: [
          r && /* @__PURE__ */ n(r, { className: qe.icon, size: "1em", "aria-hidden": "true" }),
          t
        ]
      }
    );
  }
), Lo = "_spinner_1n8e2_1", To = "_spin_1n8e2_1", Vo = "_spinner__inner_1n8e2_15", jo = "_dash_1n8e2_1", pt = {
  spinner: Lo,
  spin: To,
  "spinner--small": "_spinner--small_1n8e2_5",
  "spinner--large": "_spinner--large_1n8e2_8",
  "spinner--fill": "_spinner--fill_1n8e2_11",
  spinner__inner: Vo,
  dash: jo
};
function Oo({ className: e, color: t, innerRef: i, size: r, ...s }, l) {
  return /* @__PURE__ */ n(
    "svg",
    {
      ...s,
      viewBox: "0 0 24 24",
      role: "progressbar",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      className: g(
        pt.spinner,
        r && pt[`spinner--${r}`],
        e
      ),
      ref: l ?? i,
      children: /* @__PURE__ */ n(
        "circle",
        {
          className: pt.spinner__inner,
          cx: "12",
          cy: "12",
          r: "10",
          style: t ? { stroke: t } : void 0
        }
      )
    }
  );
}
const Lt = /* @__PURE__ */ C(Oo), Wo = "_button_q6cc0_1", Ho = "_button__spinner_q6cc0_81", Go = "_disappear_q6cc0_1", Uo = "_appear_q6cc0_1", se = {
  button: Wo,
  "button--large": "_button--large_q6cc0_8",
  "button--small": "_button--small_q6cc0_14",
  "button--x-small": "_button--x-small_q6cc0_19",
  "button--disabled": "_button--disabled_q6cc0_52",
  "button--loading": "_button--loading_q6cc0_58",
  "button--primary": "_button--primary_q6cc0_71",
  button__spinner: Ho,
  "button--secondary": "_button--secondary_q6cc0_84",
  "button--tertiary": "_button--tertiary_q6cc0_95",
  "button--danger": "_button--danger_q6cc0_106",
  disappear: Go,
  appear: Uo,
  "button__icon-wrapper--leading": "_button__icon-wrapper--leading_q6cc0_131",
  "button__icon-wrapper--trailing": "_button__icon-wrapper--trailing_q6cc0_132",
  "button__icon--leading": "_button__icon--leading_q6cc0_158",
  "button__icon--trailing": "_button__icon--trailing_q6cc0_159"
}, Un = /* @__PURE__ */ C(
  function({
    asChild: t,
    children: i,
    className: r,
    disabled: s,
    innerRef: l,
    intent: a,
    loading: u,
    loadingAriaLabel: h,
    size: o,
    variant: c,
    leadingIcon: d,
    trailingIcon: _,
    ...m
  }, f) {
    const p = V();
    let y;
    typeof h == "string" && h ? y = h : typeof h > "u" && (y = p === "en" ? "Loading" : "Laddar"), W(() => {
      u && y && Tn(y, "assertive");
    }, [u, y]);
    const x = t ? re : "button", k = t ? Ft : u ? "span" : _t;
    return /* @__PURE__ */ b(
      x,
      {
        type: t ? void 0 : "button",
        ...m,
        "aria-busy": u,
        disabled: u || s,
        className: g(
          se.button,
          a && se[`button--${a}`],
          c && se[`button--${c}`],
          o && se[`button--${o}`],
          u && se["button--loading"],
          s && se["button--disabled"],
          !!_ && se["button--with-trailing-icon"],
          r
        ),
        ref: f ?? l,
        children: [
          /* @__PURE__ */ n("div", { className: se["button__icon-wrapper--leading"], children: d ? /* @__PURE__ */ n(d, { className: se["button__icon--leading"] }) : null }),
          /* @__PURE__ */ n(k, { children: i }),
          /* @__PURE__ */ n("div", { className: se["button__icon-wrapper--trailing"], children: _ ? /* @__PURE__ */ n(_, { className: se["button__icon--trailing"] }) : null }),
          /* @__PURE__ */ n(E, { when: u, children: /* @__PURE__ */ n("span", { className: se.button__spinner, children: /* @__PURE__ */ n(
            Lt,
            {
              "aria-hidden": !0,
              "aria-label": y,
              color: "currentColor",
              size: "fill"
            }
          ) }) })
        ]
      }
    );
  }
), Yo = "_plainButton_noj8v_1", Ko = {
  plainButton: Yo
}, ct = /* @__PURE__ */ C(
  function({
    asChild: t,
    children: i,
    className: r,
    focusClassName: s = Dt[":focus"],
    ...l
  }, a) {
    return /* @__PURE__ */ n(
      t ? re : "button",
      {
        className: g(Ko.plainButton, s, r),
        ref: a,
        ...l,
        "data-sbui-plainbutton": !0,
        children: i
      }
    );
  }
), Qo = "_visuallyHidden_dwm1g_1", Xo = {
  visuallyHidden: Qo
};
function Zo(e, t) {
  return /* @__PURE__ */ n("span", { ...e, className: Xo.visuallyHidden, ref: t });
}
const he = /* @__PURE__ */ C(
  Zo
);
function Yn({ en: e, sv: t }) {
  return V() === "en" ? e : t;
}
const Jo = "_link_1f36i_1", ea = "_link__icon_1f36i_18", dn = {
  link: Jo,
  link__icon: ea
};
function Kn(e, t, i) {
  return e && (i = "_blank"), i === "_blank" && !t && (t = "noreferrer noopener"), { rel: t, target: i };
}
const ta = /* @__PURE__ */ C(function({
  asChild: t,
  children: i,
  className: r,
  external: s,
  innerRef: l,
  rel: a,
  target: u,
  ...h
}, o) {
  return { rel: a, target: u } = Kn(s, a, u), /* @__PURE__ */ b(
    t ? re : "a",
    {
      ref: o ?? l,
      className: g(dn.link, r),
      rel: a,
      target: u,
      ...h,
      children: [
        /* @__PURE__ */ n(Ft, { children: i }),
        u === "_blank" && /* @__PURE__ */ b(he, { children: [
          "— ",
          /* @__PURE__ */ n(Yn, { en: "opens in new tab", sv: "öppnas i ny flik" })
        ] }),
        u === "_blank" && /* @__PURE__ */ n(Fn, { "aria-hidden": !0, className: g(dn.link__icon) })
      ]
    }
  );
}), Lu = /* @__PURE__ */ C(
  function({
    innerRef: t,
    children: i,
    className: r,
    external: s,
    intent: l,
    leadingIcon: a,
    trailingIcon: u,
    rel: h,
    size: o,
    variant: c,
    target: d,
    ..._
  }, m) {
    return { rel: h, target: d } = Kn(s, h, d), /* @__PURE__ */ n(
      Un,
      {
        asChild: !0,
        variant: c,
        intent: l,
        size: o,
        leadingIcon: a,
        trailingIcon: u ?? (d === "_blank" ? Fn : void 0),
        className: r,
        children: /* @__PURE__ */ b("a", { ..._, ref: m ?? t, rel: h, target: d, children: [
          i,
          d === "_blank" && /* @__PURE__ */ b(he, { children: [
            "(",
            /* @__PURE__ */ n(Yn, { en: "opens in new tab", sv: "öppnas i ny flik" }),
            ")"
          ] })
        ] })
      }
    );
  }
), na = "_callout_49i18_43", ia = "_callout__header_49i18_57", ra = "_callout__icon_49i18_64", sa = "_callout__title_49i18_75", oa = "_callout__content_49i18_83", xe = {
  callout: na,
  "callout--attention": "_callout--attention_49i18_50",
  "callout--informative": "_callout--informative_49i18_53",
  callout__header: ia,
  callout__icon: ra,
  "callout__icon--attention": "_callout__icon--attention_49i18_71",
  callout__title: sa,
  callout__content: oa
}, Tu = /* @__PURE__ */ C(
  function({
    children: t,
    className: i,
    innerRef: r,
    intent: s,
    title: l,
    variant: a,
    ...u
  }, h) {
    const o = a || s, c = `callout-title-${X()}`;
    return /* @__PURE__ */ b(
      "aside",
      {
        "aria-labelledby": c,
        className: g(
          xe.callout,
          o && xe[`callout--${o}`],
          i
        ),
        ref: h ?? r,
        ...u,
        children: [
          /* @__PURE__ */ b(
            "div",
            {
              className: g(
                xe.callout__header,
                o && xe[`callout__header--${o}`]
              ),
              children: [
                /* @__PURE__ */ n(
                  yr,
                  {
                    color: "#EC5409",
                    className: g(
                      xe.callout__icon,
                      o && xe[`callout__icon--${o}`]
                    )
                  }
                ),
                /* @__PURE__ */ n(
                  "p",
                  {
                    className: g(
                      xe.callout__title,
                      o && xe[`callout__title--${o}`]
                    ),
                    id: c,
                    children: l
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ n("div", { className: xe.callout__content, children: t })
        ]
      }
    );
  }
), aa = "_callout_olsir_1", la = "_callout__content_olsir_19", gt = {
  callout: aa,
  "callout--success": "_callout--success_olsir_10",
  "callout--danger": "_callout--danger_olsir_14",
  callout__content: la
};
function Vu({
  children: e,
  className: t,
  intent: i,
  variant: r,
  ...s
}) {
  return /* @__PURE__ */ n(
    "div",
    {
      className: g(
        gt.callout,
        gt[`callout--${i ?? r}`],
        t
      ),
      ...s,
      children: /* @__PURE__ */ n("div", { className: gt.callout__content, children: e })
    }
  );
}
const ca = "_card_6dcrz_1", da = {
  card: ca
}, mt = /* @__PURE__ */ C(function({
  backgroundColor: t,
  borderColor: i,
  children: r,
  className: s,
  p: l = "1rem",
  style: a,
  ...u
}, h) {
  return /* @__PURE__ */ n(
    ce,
    {
      ...u,
      "data-sbui-elevated": !0,
      p: l,
      ref: h,
      className: g(da.card, s),
      style: {
        ...a,
        "--card-background": t === !1 || t === "" ? "transparent" : t,
        "--card-border": i === !1 || t === "" ? "transparent" : i
      },
      children: r
    }
  );
}), ua = "_item_1v2my_1", _a = "_indicator_1v2my_9", ma = "_label_1v2my_26", Tt = {
  item: ua,
  indicator: _a,
  label: ma
};
function ha(e) {
  const t = B(typeof e < "u");
  return typeof e < "u" && !t.current && (t.current = !0), t.current;
}
function ge(e, t, i) {
  const r = ha(e), [s, l] = Q(t);
  let a = r ? e : s;
  return r && typeof e > "u" && (a = i), [a, l];
}
const Vt = ae({}), jt = ae({});
function Qn({
  children: e,
  defaultValue: t = [],
  disabled: i,
  name: r,
  onBlur: s,
  onChange: l,
  onFocus: a,
  value: u,
  ...h
}) {
  const [o, c] = ge(
    u,
    t ?? [],
    []
  ), d = o, _ = le(
    (p) => {
      const { checked: y, value: x } = p.target, k = y ? [...d, x] : d.filter((I) => I !== x);
      c(k), l == null || l(k);
    },
    [l, d, c]
  ), m = X(), { focusWithinProps: f } = kn({
    onBlurWithin: s,
    onFocusWithin: a
  });
  return /* @__PURE__ */ n(
    Vt.Provider,
    {
      value: {
        disabled: i,
        handleChange: _,
        name: r ?? m,
        selectedValues: d
      },
      children: /* @__PURE__ */ n("div", { ...h, ...f, role: "group", children: e })
    }
  );
}
const Ot = /* @__PURE__ */ C(
  function(t, i) {
    const { handleChange: r } = Z(Vt);
    return r ? /* @__PURE__ */ n(fa, { ...t, inputRef: i }) : /* @__PURE__ */ n(pa, { ...t, inputRef: i });
  }
);
function fa({
  disabled: e,
  value: t,
  ...i
}) {
  const {
    disabled: r,
    handleChange: s,
    name: l,
    selectedValues: a
  } = Z(Vt), u = (t ? a == null ? void 0 : a.includes(t) : !1) ?? !1;
  return /* @__PURE__ */ n(
    Xn,
    {
      ...i,
      checked: u,
      disabled: r ?? e,
      name: l,
      onChange: s,
      value: t
    }
  );
}
function pa({
  checked: e,
  defaultChecked: t = !1,
  onChange: i,
  ...r
}) {
  const [s, l] = Q(t), a = le(
    (h) => {
      l(h.target.checked), i == null || i(h.target.checked);
    },
    [i, l]
  );
  return /* @__PURE__ */ n(Xn, { ...r, checked: typeof e < "u" ? e : s, onChange: a });
}
function Xn({
  "aria-labelledby": e,
  "aria-describedby": t,
  children: i,
  className: r,
  checked: s,
  disabled: l,
  inputRef: a,
  name: u,
  onBlur: h,
  onChange: o,
  onFocus: c,
  style: d,
  value: _
}) {
  const m = X(), f = `${m}-control`, p = `${m}-label`;
  let y = p;
  return e && (y += ` ${e}`), /* @__PURE__ */ n(jt.Provider, { value: { controlId: f, isChecked: s, labelId: p, value: _ }, children: /* @__PURE__ */ b(
    "label",
    {
      "data-disabled": l,
      className: g(Tt.item, r),
      style: d,
      children: [
        /* @__PURE__ */ n(he, { children: /* @__PURE__ */ n(
          "input",
          {
            type: "checkbox",
            "aria-labelledby": y,
            "aria-describedby": t,
            checked: s,
            disabled: l,
            id: f,
            name: u,
            onBlur: h,
            onChange: o,
            onFocus: c,
            ref: a,
            value: _
          }
        ) }),
        typeof i == "function" ? i == null ? void 0 : i({ isChecked: s ?? !1, isDisabled: l }) : i
      ]
    }
  ) });
}
function Wt({ className: e }) {
  const { isChecked: t } = Z(jt);
  return /* @__PURE__ */ b(
    "svg",
    {
      "aria-hidden": !0,
      width: "1.125rem",
      height: "1.5rem",
      viewBox: "0 -3 18 24",
      className: g(Tt.indicator, e),
      children: [
        /* @__PURE__ */ n("rect", { x: 0.5, y: 0.5, width: 17, height: 17 }),
        t && /* @__PURE__ */ n(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.083 4.91699L7.83301 10.167L5.79134 8.12533L4.33301 9.58366L7.83301 13.0837L14.5413 6.37533L13.083 4.91699Z"
          }
        )
      ]
    }
  );
}
function Ht({ children: e, className: t }) {
  const { labelId: i } = Z(jt);
  return /* @__PURE__ */ n("span", { className: g(Tt.label, t), id: i, children: e });
}
const bt = {
  "standalone-root": "_standalone-root_o673o_1",
  "standalone-indicator": "_standalone-indicator_o673o_4",
  "standalone-label": "_standalone-label_o673o_8"
}, ga = /* @__PURE__ */ C(
  function({ label: t, className: i, ...r }, s) {
    return /* @__PURE__ */ n(
      Ot,
      {
        ...r,
        className: g(bt["standalone-root"], i),
        ref: s,
        children: /* @__PURE__ */ b(M, { align: "flex-start", gap: ".5rem", children: [
          /* @__PURE__ */ n(Wt, { className: bt["standalone-indicator"] }),
          /* @__PURE__ */ n(Ht, { className: bt["standalone-label"], children: t })
        ] })
      }
    );
  }
), yt = {
  "standard-item": "_standard-item_or1jw_1",
  "standard-indicator": "_standard-indicator_or1jw_4",
  "standard-label": "_standard-label_or1jw_8"
}, ba = /* @__PURE__ */ C(function({
  className: t,
  defaultValue: i,
  disabled: r,
  name: s,
  onBlur: l,
  onChange: a,
  onFocus: u,
  options: h,
  value: o,
  ...c
}, d) {
  return /* @__PURE__ */ n(de, { ...c, className: t, children: (_) => /* @__PURE__ */ n(
    Qn,
    {
      ..._,
      defaultValue: i,
      disabled: r,
      name: s,
      onBlur: l,
      onChange: a,
      onFocus: u,
      value: o,
      children: /* @__PURE__ */ n(M, { direction: "column", gap: ".3125rem", children: h.map((m, f) => /* @__PURE__ */ n(
        Ot,
        {
          className: yt["standard-item"],
          value: m.value,
          ref: f ? void 0 : d,
          children: /* @__PURE__ */ b(M, { align: "flex-start", gap: ".5rem", children: [
            /* @__PURE__ */ n(Wt, { className: yt["standard-indicator"] }),
            /* @__PURE__ */ n(Ht, { className: yt["standard-label"], children: m.label })
          ] })
        },
        m.value
      )) })
    }
  ) });
}), ya = "_checkbox__input_z4h0h_43", xa = "_checkbox__label_z4h0h_48", un = {
  checkbox__input: ya,
  checkbox__label: xa
}, Zn = ae(null), wa = /* @__PURE__ */ C(
  function({
    checked: t,
    className: i,
    defaultChecked: r,
    disabled: s = !1,
    id: l,
    innerRef: a,
    inputClassName: u,
    inputProps: h = {},
    inputRef: o,
    label: c,
    labelClassName: d,
    labelProps: _ = {},
    labelRef: m,
    name: f,
    onBlur: p,
    onChange: y,
    onFocus: x,
    value: k,
    ...I
  }, w) {
    var $;
    const v = Z(Zn), R = le(
      (P) => {
        y && y(P), v != null && v.onChange && v.onChange(P);
      },
      [y, v == null ? void 0 : v.onChange]
    ), F = `checkbox-${X()}`, q = l ?? F;
    let N = t;
    return v != null && v.values && (N = (($ = v.values) == null ? void 0 : $.indexOf(k)) > -1), /* @__PURE__ */ b(
      "div",
      {
        ...I,
        ref: w ?? a,
        className: i,
        onClick: (P) => {
          P.target.localName === "input" && P.target.focus(), typeof I.onClick == "function" && I.onClick(P);
        },
        children: [
          /* @__PURE__ */ n(
            "input",
            {
              ...h,
              checked: N,
              className: g(un.checkbox__input, u),
              defaultChecked: r,
              disabled: s,
              id: q,
              name: f ?? (v == null ? void 0 : v.name),
              onBlur: p,
              onChange: R,
              onFocus: x,
              ref: o,
              type: "checkbox",
              value: k
            }
          ),
          /* @__PURE__ */ n(
            "label",
            {
              ..._,
              htmlFor: q,
              ref: m,
              className: g(un.checkbox__label, d),
              children: c
            }
          )
        ]
      }
    );
  }
), _n = {
  "checkbox-group--row": "_checkbox-group--row_e7s4j_1"
};
function va({
  children: e,
  description: t,
  label: i,
  message: r,
  name: s,
  onChange: l,
  row: a,
  secondaryLabel: u,
  supplemental: h,
  tone: o,
  values: c = [],
  ...d
}) {
  const _ = X(), m = `label-${_}`, f = `description-${_}`, p = `message-${_}`, y = le(
    (I) => {
      if (l) {
        const { value: w } = I.currentTarget, v = c.indexOf(w);
        v > -1 ? l(c.filter((R, F) => F !== v)) : l([...c, w]);
      }
    },
    [l, c]
  ), x = Re(
    () => ({
      name: s,
      onChange: y,
      values: c ?? []
    }),
    [s, y, c]
  );
  let k;
  return (r || t) && (k = [t && f, r && p].filter(Boolean).join(" ")), /* @__PURE__ */ b(M, { ...d, direction: "column", gap: "0.5rem", children: [
    i && /* @__PURE__ */ b("div", { children: [
      /* @__PURE__ */ n(
        At,
        {
          id: m,
          secondaryLabel: t ? void 0 : u,
          children: i
        }
      ),
      typeof t < "u" && /* @__PURE__ */ n(qt, { id: f, children: t })
    ] }),
    h,
    /* @__PURE__ */ n(Zn.Provider, { value: x, children: /* @__PURE__ */ n(
      "div",
      {
        role: "group",
        "aria-labelledby": m,
        "aria-describedby": k,
        "aria-invalid": o === "critical",
        className: g(
          _n["checkbox-group"],
          a && _n["checkbox-group--row"]
        ),
        children: e
      }
    ) }),
    r && /* @__PURE__ */ n(lt, { id: p, tone: o, children: r })
  ] });
}
const ht = wa;
ht.Root = Ot;
ht.Indicator = Wt;
ht.Label = Ht;
ht.Standalone = ga;
const Jn = va;
Jn.Root = Qn;
Jn.Standard = ba;
function Na() {
  return typeof window.ResizeObserver < "u";
}
function Ca(e) {
  const { ref: t, box: i, onResize: r } = e;
  W(() => {
    const s = t == null ? void 0 : t.current;
    if (s)
      if (Na()) {
        const l = new window.ResizeObserver((a) => {
          a.length && r();
        });
        return l.observe(s, { box: i }), () => {
          s && l.unobserve(s);
        };
      } else
        return window.addEventListener("resize", r, !1), () => {
          window.removeEventListener("resize", r, !1);
        };
  }, [r, t, i]);
}
const Ia = "_combobox_1bd1q_1", ka = "_control_1bd1q_5", Ra = "_input_1bd1q_18", Pa = "_trigger_1bd1q_31", Sa = "_popover_1bd1q_45", De = {
  combobox: Ia,
  control: ka,
  "control--invalid": "_control--invalid_1bd1q_14",
  input: Ra,
  trigger: Pa,
  popover: Sa
}, za = "_listbox_dklt7_1", $a = "_option_dklt7_9", Ea = "_optionStates_dklt7_19", kt = {
  listbox: za,
  option: $a,
  optionStates: Ea
};
function Ma({
  children: e,
  className: t,
  popoverRef: i,
  preventPageScroll: r,
  state: s,
  ...l
}) {
  const a = B(null), u = V(), h = i ?? a, { popoverProps: o, underlayProps: c } = Rn(
    {
      ...l,
      popoverRef: h
    },
    s
  ), d = u === "sv" ? "Stäng listan av alternativ" : "Dismiss list of options";
  return /* @__PURE__ */ b(Pn, { children: [
    /* @__PURE__ */ n(E, { when: r, children: /* @__PURE__ */ n("div", { ...c, style: { position: "fixed", inset: 0 } }) }),
    /* @__PURE__ */ b(
      "div",
      {
        ...o,
        ref: h,
        className: t,
        children: [
          /* @__PURE__ */ n(ot, { "aria-label": d, onDismiss: s.close }),
          e,
          /* @__PURE__ */ n(ot, { "aria-label": d, onDismiss: s.close })
        ]
      }
    )
  ] });
}
function Fa(e) {
  const t = B(null), { className: i, listBoxRef: r = t, optionClassName: s, state: l, style: a } = e, { listBoxProps: u } = Xi(e, l, r);
  return /* @__PURE__ */ n(
    "ul",
    {
      ...u,
      ref: r,
      className: g(kt.listbox, i),
      style: a,
      children: [...l.collection].map((h) => /* @__PURE__ */ n(
        Da,
        {
          item: h,
          state: l,
          className: s
        },
        h.key
      ))
    }
  );
}
function Da({ className: e, item: t, state: i }) {
  const r = B(null), { optionProps: s, isSelected: l, isFocused: a } = Zi(
    { key: t.key },
    i,
    r
  );
  let u;
  const h = typeof e == "function" ? e({ isFocused: a, isSelected: l }) : e;
  return typeof e != "function" && (l ? u = "selected" : a && (u = "focused")), /* @__PURE__ */ n(
    "li",
    {
      ...s,
      ref: r,
      className: g(
        kt.option,
        typeof e != "function" && kt.optionStates,
        h
      ),
      "data-state": u,
      children: t.rendered
    }
  );
}
const Ba = /* @__PURE__ */ C(
  function({
    "aria-label": t,
    "aria-labelledby": i,
    "aria-describedby": r,
    "aria-required": s,
    defaultValue: l,
    filter: a = "contains",
    id: u,
    invalid: h,
    name: o,
    noTrigger: c,
    onBlur: d,
    onChange: _,
    onFocus: m,
    onInputValue: f,
    options: p,
    renderItem: y,
    value: x,
    inputProps: k
  }, I) {
    const w = V(), [v, R] = ge(
      x,
      l ?? null,
      null
    ), { contains: F, startsWith: q } = Ji({ sensitivity: "base" });
    let N = a === "none" ? void 0 : F;
    a === "startsWith" && (N = q);
    const S = Sr({
      children: (O) => /* @__PURE__ */ n(zr, { textValue: O.label, children: typeof y == "function" ? y(O) : O.label }, O.value),
      defaultItems: a !== "none" ? p : void 0,
      defaultSelectedKey: l,
      defaultFilter: N,
      items: a === "none" ? p : void 0,
      onInputChange(O) {
        f == null || f(O);
      },
      onSelectionChange(O) {
        R(O), _ == null || _(O || void 0);
      },
      selectedKey: v
    }), A = B(null), z = B(null), L = B(null), T = B(null);
    pe(I, () => z.current);
    const {
      buttonProps: G,
      inputProps: ue,
      listBoxProps: J
    } = er(
      {
        "aria-label": t,
        "aria-labelledby": i,
        "aria-describedby": r,
        id: u,
        onBlur: d,
        onFocus: m,
        buttonRef: A,
        inputRef: z,
        listBoxRef: L,
        popoverRef: T
      },
      S
    ), { buttonProps: be } = Et(G, A), [Y, te] = Q(null), j = le(() => {
      var O;
      if (z.current) {
        const ne = (O = A.current) == null ? void 0 : O.getBoundingClientRect(), _e = z.current.getBoundingClientRect(), Pe = ne ? Math.min(ne.left, _e.left) : _e.left, K = ne ? Math.max(ne.right, _e.right) : _e.right;
        te(K - Pe + "px");
      }
    }, [A, z, te]);
    return Ca({
      ref: z,
      onResize: j
    }), /* @__PURE__ */ b("div", { className: De.combobox, children: [
      /* @__PURE__ */ b(
        "div",
        {
          className: g(De.control, h && De["control--invalid"]),
          children: [
            /* @__PURE__ */ n(
              "input",
              {
                ...ue,
                ...k,
                ref: z,
                className: g(De.input, k == null ? void 0 : k.className),
                "aria-required": s
              }
            ),
            /* @__PURE__ */ n(E, { when: c !== !0, children: /* @__PURE__ */ b("button", { ...be, ref: A, className: De.trigger, children: [
              /* @__PURE__ */ n(he, { children: w === "en" ? "Open list" : "Öppna lista" }),
              /* @__PURE__ */ n(
                "svg",
                {
                  "aria-hidden": !0,
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: /* @__PURE__ */ n(
                    "path",
                    {
                      d: "M18 9L12 15L6 9",
                      stroke: "currentColor",
                      strokeWidth: "2"
                    }
                  )
                }
              )
            ] }) })
          ]
        }
      ),
      S.isOpen && /* @__PURE__ */ n(
        Ma,
        {
          state: S,
          triggerRef: z,
          popoverRef: T,
          isNonModal: !0,
          placement: "bottom start",
          crossOffset: -1,
          className: De.popover,
          children: /* @__PURE__ */ n(
            "div",
            {
              style: {
                width: Y ?? void 0
              },
              children: /* @__PURE__ */ n(
                Fa,
                {
                  ...J,
                  listBoxRef: L,
                  state: S
                }
              )
            }
          )
        }
      ),
      /* @__PURE__ */ n(E, { when: o, children: /* @__PURE__ */ n("input", { type: "hidden", name: o, value: v ?? "" }) })
    ] });
  }
), ju = /* @__PURE__ */ C(
  function({
    className: t,
    contextualHelp: i,
    description: r,
    descriptionId: s,
    descriptionProps: l,
    label: a,
    labelClassName: u,
    labelId: h,
    labelProps: o,
    labelRef: c,
    message: d,
    messageClassName: _,
    messageId: m,
    messageProps: f,
    messageRef: p,
    messageTone: y,
    style: x,
    validationError: k,
    validationErrorId: I,
    validationErrorProps: w,
    ...v
  }, R) {
    return /* @__PURE__ */ n(
      de,
      {
        className: t,
        contextualHelp: i,
        description: r,
        descriptionId: s,
        descriptionProps: l,
        label: a,
        labelClassName: u,
        labelId: h,
        labelProps: o,
        labelRef: c,
        message: d,
        messageClassName: _,
        messageId: m,
        messageProps: f,
        messageRef: p,
        messageTone: y,
        style: x,
        validationError: k,
        validationErrorId: I,
        validationErrorProps: w,
        children: (F, q) => /* @__PURE__ */ n(
          Ba,
          {
            ...v,
            ...F,
            invalid: q.isInvalid,
            ref: R
          }
        )
      }
    );
  }
), ei = ae(null), qa = ({
  interval: e = 1e3,
  duration: t = 6e4,
  autoStart: i = !0,
  onUpdate: r,
  onTimeout: s,
  getNow: l = () => performance.now(),
  children: a
}) => {
  const [u, h] = Q(t), [o, c] = Q(() => i), d = B(l()), _ = B(null), m = B(null), f = () => {
    _.current && (clearInterval(_.current), _.current = null);
  }, p = le(() => {
    const v = l(), R = v - d.current, F = Math.max(Math.round(R / e) * e, e);
    h(
      (q) => Math.max(0, q - F)
    ), d.current = v;
  }, [e, l]);
  W(() => {
    r == null || r(u), u <= 0 && (f(), c(!1), s == null || s());
  }, [s, r, u]), W(() => (o && u > 0 && (d.current = l(), _.current = window.setInterval(() => p(), e)), f), [o, e, p, u, l]);
  const y = () => {
    c(!1), f();
  }, x = () => {
    u > 0 && c(!0);
  }, k = () => {
    m.current !== null && (cancelAnimationFrame(m.current), m.current = null);
  }, I = (v) => {
    f(), c(!1), k(), m.current = requestAnimationFrame(() => {
      h(v ?? t), d.current = l(), c(!0), m.current = null;
    });
  };
  W(() => () => {
    f(), k();
  }, []);
  const w = {
    remaining: u,
    isActive: o,
    interval: e,
    duration: t,
    pause: y,
    resume: x,
    reset: I
  };
  return /* @__PURE__ */ n(ei.Provider, { value: w, children: typeof a == "function" ? a(w) : a });
}, Aa = () => {
  const e = Z(ei);
  if (!e)
    throw new Error("useCountdown must be used within a Countdown.Root");
  return e;
}, xt = /* @__PURE__ */ new Map();
function ti(e) {
  const t = V();
  return Re(() => La(t, e), [t, e]);
}
function La(e, t) {
  const i = e + (t ? Object.entries(t).sort((s, l) => s[0] < l[0] ? -1 : 1).join() : "");
  if (xt.has(i))
    return xt.get(i);
  const r = new Intl.NumberFormat(e, t);
  return xt.set(i, r), r;
}
function Ge(e) {
  if (e === 0) return "0 B";
  const t = ["B", "kB", "MB", "GB", "TB"], i = 1e3, r = Math.min(
    Math.floor(Math.log(e) / Math.log(i)),
    t.length - 1
  ), s = e / Math.pow(i, r), l = t[r];
  if (r <= 1)
    return `${Math.round(s)} ${l}`;
  if (r === 2) {
    const a = Math.round(s * 10) / 10;
    return `${a % 1 === 0 ? Math.round(a) : a} ${l}`;
  } else {
    const a = Math.round(s * 100) / 100;
    return `${a % 1 === 0 ? Math.round(a) : a} ${l}`;
  }
}
function Ta(e) {
  const t = Math.floor(e / 1e3), r = {
    style: "unit",
    unitDisplay: "long",
    unit: t > 60 ? "minute" : "second"
  }, s = ti(r);
  if (t <= 60)
    return s.format(t);
  const l = Math.ceil(t / 60);
  return s.format(l);
}
const Va = "_countdown_190jl_1", ja = {
  countdown: Va
}, Oa = /* @__PURE__ */ C(function({
  as: t = "div",
  asChild: i,
  children: r,
  ["aria-live"]: s,
  className: l,
  ...a
}, u) {
  const h = V(), { remaining: o, interval: c } = Aa(), d = Ta(o), _ = o % 1e4 === 0 || o > c && (o - c) % 1e4 === 0, m = o >= 6e4 || o < 6e4 && _ ? "polite" : "off", f = `${d} ${h === "en" ? "remaining" : "kvar"}`;
  return /* @__PURE__ */ n(
    i ? re : t,
    {
      ref: u,
      role: "timer",
      "aria-live": s ?? m,
      className: g(ja.countdown, l),
      ...a,
      children: /* @__PURE__ */ n(E, { when: !!r, fallback: /* @__PURE__ */ n(ie, { children: f }), children: typeof r == "function" ? r({
        remaining: o,
        "aria-live": m,
        ariaMessage: f
      }) : r })
    }
  );
});
var mn;
((e) => {
  e.Root = qa, e.Timer = Oa;
})(mn || (mn = {}));
const Gt = {
  style: "currency",
  currency: "SEK",
  minimumFractionDigits: 0
};
function Ut(e, t) {
  const i = ti(t);
  return e == null || Number.isNaN(e) ? null : i.format(e);
}
function hn({ options: e = Gt, value: t }) {
  const i = Ut(t, e);
  return i == null ? null : /* @__PURE__ */ n(ie, { children: i });
}
((e) => {
  e.Monthly = Wa, e.Yearly = Ha;
})(hn || (hn = {}));
function Wa({ options: e = Gt, value: t }) {
  const i = V(), r = Ut(t, e);
  return r == null ? null : /* @__PURE__ */ b(ie, { children: [
    r,
    " ",
    i === "en" ? "per month" : "per månad"
  ] });
}
function Ha({ options: e = Gt, value: t }) {
  const i = V(), r = Ut(t, e);
  return r == null ? null : /* @__PURE__ */ b(ie, { children: [
    r,
    " ",
    i === "en" ? "per year" : "per år"
  ] });
}
function Yt({ children: e }) {
  const t = V();
  return /* @__PURE__ */ n(tr, { locale: ft(t), children: e });
}
function ft(e) {
  return e === "en" ? "en-GB" : "sv-SE";
}
const Ga = "_group_1g7mg_43", Ua = "_field_1g7mg_98", Ya = "_segments_1g7mg_117", Ka = "_segment_1g7mg_117", Qa = "_dialog_1g7mg_143", Xa = "_popover_1g7mg_157", Za = "_calendar_1g7mg_61", D = {
  group: Ga,
  "calendar-trigger-button": "_calendar-trigger-button_1g7mg_61",
  "single-field-wrapper": "_single-field-wrapper_1g7mg_87",
  "range-field-wrapper": "_range-field-wrapper_1g7mg_88",
  field: Ua,
  "range-separator--empty": "_range-separator--empty_1g7mg_105",
  segments: Ya,
  segment: Ka,
  dialog: Qa,
  popover: Xa,
  calendar: Za,
  "calendar--inline": "_calendar--inline_1g7mg_166",
  "calendar-header": "_calendar-header_1g7mg_171",
  "calendar-title": "_calendar-title_1g7mg_179",
  "calendar-direction-button": "_calendar-direction-button_1g7mg_185",
  "calendar-grids": "_calendar-grids_1g7mg_207",
  "calendar-grid": "_calendar-grid_1g7mg_207",
  "calendar-cell": "_calendar-cell_1g7mg_251",
  "calendar-cell--within-selection": "_calendar-cell--within-selection_1g7mg_276",
  "calendar-cell--selection-start": "_calendar-cell--selection-start_1g7mg_279",
  "calendar-cell--selection-end": "_calendar-cell--selection-end_1g7mg_283",
  "calendar-cell-button": "_calendar-cell-button_1g7mg_300",
  "calendar-cell-button--selectable": "_calendar-cell-button--selectable_1g7mg_313",
  "calendar-cell-button--highlighted": "_calendar-cell-button--highlighted_1g7mg_320",
  "calendar-cell-button--outside-visible-range": "_calendar-cell-button--outside-visible-range_1g7mg_324",
  "calendar-cell-button--unavailable": "_calendar-cell-button--unavailable_1g7mg_327",
  "calendar-cell-button--disabled": "_calendar-cell-button--disabled_1g7mg_327"
};
function Kt(e) {
  switch (e) {
    case "gregory":
      return new Lr();
    default:
      throw new Error(`Unsupported calendar: ${e}`);
  }
}
function Rt({ isRange: e, ...t }) {
  const { locale: i } = Mt(), [r, s] = Q(""), l = $r({
    ...t,
    locale: i,
    createCalendar: Kt
  }), a = B(null), { fieldProps: u } = nr(t, l, a), h = l.value;
  return W(() => {
    if (h) {
      const o = h.year.toString().padStart(4, "0"), c = h.month.toString().padStart(2, "0"), d = h.day.toString().padStart(2, "0");
      s(`${o}-${c}-${d}`);
    } else
      s("");
  }, [h, s]), /* @__PURE__ */ b("div", { className: D.field, children: [
    /* @__PURE__ */ n(
      "div",
      {
        ...u,
        ref: a,
        className: g(D.segments, e && D["segments--range"]),
        children: l.segments.map((o, c) => /* @__PURE__ */ n(Ja, { segment: o, state: l }, c))
      }
    ),
    /* @__PURE__ */ n("input", { type: "hidden", name: t.name, readOnly: !0, value: r })
  ] });
}
function Ja({ segment: e, state: t }) {
  const i = B(null), { segmentProps: r } = or(e, t, i);
  return /* @__PURE__ */ n(
    "div",
    {
      ...r,
      autoCapitalize: "none",
      ref: i,
      className: D.segment,
      children: e.text
    }
  );
}
function ni({ className: e, ...t }) {
  const i = B(null), { buttonProps: r } = Et(t, i);
  return /* @__PURE__ */ n("button", { ...r, className: e, ref: i, children: t.children });
}
function ii(e) {
  return /* @__PURE__ */ n(ni, { ...e, className: D["calendar-trigger-button"], children: /* @__PURE__ */ n(xr, {}) });
}
function ri({ children: e, state: t, ...i }) {
  const r = B(null), s = V(), { popoverProps: l, underlayProps: a } = Rn(
    {
      ...i,
      popoverRef: r
    },
    t
  ), u = s === "sv" ? "Stäng kalendern" : "Dismiss calendar";
  return /* @__PURE__ */ b(Pn, { children: [
    /* @__PURE__ */ n("div", { ...a, style: { position: "fixed", inset: 0 } }),
    /* @__PURE__ */ b("div", { ...l, ref: r, className: D.popover, children: [
      /* @__PURE__ */ n(ot, { "aria-label": u, onDismiss: t.close }),
      e,
      /* @__PURE__ */ n(ot, { "aria-label": u, onDismiss: t.close })
    ] })
  ] });
}
function si({ title: e, children: t, ...i }) {
  const r = B(null), { dialogProps: s, titleProps: l } = rr(i, r);
  return /* @__PURE__ */ b("div", { ...s, ref: r, className: D.dialog, children: [
    /* @__PURE__ */ n(E, { when: e, children: /* @__PURE__ */ n("h3", { ...l, style: { marginTop: 0 }, children: e }) }),
    t
  ] });
}
function dt(e) {
  return /* @__PURE__ */ n(
    ni,
    {
      ...e,
      className: D["calendar-direction-button"]
    }
  );
}
function fn({ inline: e, ...t }) {
  const [i, r] = Q(
    t.value
  ), { locale: s } = Mt(), l = Er({
    ...t,
    locale: s,
    createCalendar: Kt,
    focusedValue: e ? i : t.focusedValue,
    onFocusChange: e ? r : t.onFocusChange
  }), { calendarProps: a, prevButtonProps: u, nextButtonProps: h, title: o } = ir(t, l);
  return W(() => {
    !e || !l.value || r(l.value);
  }, [e, l.value, r]), /* @__PURE__ */ b(
    "div",
    {
      ...a,
      className: g(D.calendar, e && D["calendar--inline"]),
      children: [
        /* @__PURE__ */ b("div", { className: D["calendar-header"], children: [
          /* @__PURE__ */ n(dt, { ...u, children: /* @__PURE__ */ n(Dn, { size: "1rem" }) }),
          /* @__PURE__ */ n("h2", { className: D["calendar-title"], children: o }),
          /* @__PURE__ */ n(dt, { ...h, children: /* @__PURE__ */ n(Bn, { size: "1rem" }) })
        ] }),
        /* @__PURE__ */ n(oi, { locale: s, state: l, weekdayStyle: "short" })
      ]
    }
  );
}
function pn({
  inline: e,
  visibleMonthCount: t = 1,
  ...i
}) {
  var _;
  const [r, s] = Q(
    (_ = i.value) == null ? void 0 : _.start
  ), { locale: l } = Mt(), a = Mr({
    ...i,
    locale: l,
    createCalendar: Kt,
    visibleDuration: { months: t },
    onFocusChange: e ? s : i.onFocusChange,
    focusedValue: e ? r : i.focusedValue
  }), u = B(null), { calendarProps: h, prevButtonProps: o, nextButtonProps: c, title: d } = sr(i, a, u);
  return W(() => {
    !e || !a.value || s(a.value.start);
  }, [e, a.value, s]), /* @__PURE__ */ b(
    "div",
    {
      ...h,
      className: g(D.calendar, e && D["calendar--inline"]),
      children: [
        /* @__PURE__ */ b("div", { className: D["calendar-header"], children: [
          /* @__PURE__ */ n(dt, { ...o, children: /* @__PURE__ */ n(Dn, { size: "1rem" }) }),
          /* @__PURE__ */ n("h2", { className: D["calendar-title"], children: d }),
          /* @__PURE__ */ n(dt, { ...c, children: /* @__PURE__ */ n(Bn, { size: "1rem" }) })
        ] }),
        /* @__PURE__ */ n("div", { className: D["calendar-grids"], children: Array.from({ length: t }).map((m, f) => /* @__PURE__ */ n(
          oi,
          {
            locale: l,
            state: a,
            weekdayStyle: "short",
            offset: f ? { months: f } : void 0
          },
          f
        )) })
      ]
    }
  );
}
function oi({
  locale: e,
  offset: t = {},
  state: i,
  ...r
}) {
  const s = i.visibleRange.start.add(t), l = Tr(s), { gridProps: a, headerProps: u, weekDays: h } = ar(
    {
      ...r,
      startDate: s,
      endDate: l
    },
    i
  ), o = Vr(s, e);
  return /* @__PURE__ */ b("table", { ...a, cellPadding: 0, className: D["calendar-grid"], children: [
    /* @__PURE__ */ n("thead", { ...u, children: /* @__PURE__ */ n("tr", { children: h.map((c, d) => /* @__PURE__ */ n("th", { children: c }, d)) }) }),
    /* @__PURE__ */ n("tbody", { children: Array.from({ length: o }).map((c, d) => /* @__PURE__ */ n("tr", { children: i.getDatesInWeek(d, s).map(
      (_, m) => _ ? /* @__PURE__ */ n(
        el,
        {
          date: _,
          state: i,
          currentMonth: s
        },
        m
      ) : /* @__PURE__ */ n("td", {}, m)
    ) }, d)) })
  ] });
}
function el({ currentMonth: e, date: t, state: i }) {
  const r = B(null), {
    cellProps: s,
    buttonProps: l,
    isSelected: a,
    isOutsideVisibleRange: u,
    isDisabled: h,
    isUnavailable: o,
    formattedDate: c
  } = lr({ date: t }, i, r), d = !jr(e, t), _ = !h && !u && !o && !d;
  let m = a, f = !1, p = !1, y = !1;
  return "highlightedRange" in i && i.highlightedRange && (f = ln(t, i.highlightedRange.start), p = ln(t, i.highlightedRange.end), y = a && !d, y && !(f || p) && (m = !1)), /* @__PURE__ */ n(
    "td",
    {
      ...s,
      className: g(
        D["calendar-cell"],
        y && D["calendar-cell--within-selection"],
        f && D["calendar-cell--selection-start"],
        p && D["calendar-cell--selection-end"]
      ),
      children: /* @__PURE__ */ n(
        "div",
        {
          ...l,
          ref: r,
          className: g(
            D["calendar-cell-button"],
            m && D["calendar-cell-button--highlighted"],
            (u || d) && D["calendar-cell-button--outside-visible-range"],
            h && D["calendar-cell-button--disabled"],
            o && D["calendar-cell-button--unavailable"],
            _ && D["calendar-cell-button--selectable"]
          ),
          children: c
        }
      )
    }
  );
}
const Ou = /* @__PURE__ */ C(
  function({
    "aria-label": t,
    "aria-required": i,
    defaultValue: r,
    description: s,
    descriptionProps: l = {},
    isDateAvailable: a,
    label: u,
    labelProps: h = {},
    message: o,
    messageProps: c,
    messageTone: d,
    min: _,
    max: m,
    name: f,
    onBlur: p,
    onChange: y,
    validationError: x,
    validationErrorProps: k,
    value: I,
    inline: w,
    ...v
  }, R) {
    const F = r ? me(r) : void 0, q = I ? me(I) : void 0, [N, $] = ge(
      q,
      F ?? null,
      null
    ), P = _ ? me(_) : void 0, S = m ? me(m) : void 0, A = Fr({
      isInvalid: !!x || d === "critical",
      minValue: P,
      maxValue: S,
      onChange: (j) => {
        j ? ($(j), y == null || y(j == null ? void 0 : j.toString())) : ($(null), y == null || y(void 0));
      },
      shouldCloseOnSelect: !w,
      value: N
    }), z = B(null), {
      groupProps: L,
      labelProps: T,
      descriptionProps: G,
      fieldProps: ue,
      buttonProps: J,
      dialogProps: be,
      calendarProps: Y
    } = cr(
      {
        "aria-label": t,
        isDateUnavailable: a ? (j) => !a(j) : void 0,
        isRequired: i === !0 || i === "true" ? !0 : void 0,
        validationBehavior: "aria",
        minValue: P,
        maxValue: S,
        description: x ?? o,
        onBlur: p,
        label: u,
        name: f
      },
      A,
      z
    );
    pe(
      R,
      () => ({
        // `ref.focus()` is used by form libraries like `react-hook-form`
        // in order to focus an element upon validation errors etc.
        focus() {
          var j;
          z.current && ((j = z.current.querySelector(
            '[role="spinbutton"]'
          )) == null || j.focus());
        }
      }),
      []
    );
    let te;
    return w && (te = `${J.id}-collapsible`), /* @__PURE__ */ n(Yt, { children: /* @__PURE__ */ n(
      de,
      {
        ...v,
        label: u,
        labelProps: { ...h, ...T },
        labelId: T.id,
        description: s,
        descriptionProps: { ...l, ...G },
        descriptionId: G.id,
        message: o,
        messageProps: c,
        messageTone: d,
        validationError: x,
        validationErrorProps: k,
        children: (j) => /* @__PURE__ */ b(ie, { children: [
          /* @__PURE__ */ b(
            "div",
            {
              ...L,
              ...j,
              ref: z,
              className: D.group,
              "data-invalid": A.isInvalid ? "true" : void 0,
              children: [
                /* @__PURE__ */ n("div", { className: D["single-field-wrapper"], children: /* @__PURE__ */ n(Rt, { ...ue }) }),
                /* @__PURE__ */ n(
                  ii,
                  {
                    ...J,
                    "aria-controls": w ? te : J["aria-controls"],
                    "aria-haspopup": w ? void 0 : J["aria-haspopup"],
                    onPress: (O) => {
                      var ne;
                      (ne = J.onPress) == null || ne.call(J, O), w && A.isOpen && A.setOpen(!1);
                    }
                  }
                )
              ]
            }
          ),
          w ? /* @__PURE__ */ n($e.Root, { open: A.isOpen, children: /* @__PURE__ */ n($e.Content, { animated: !0, id: te, children: /* @__PURE__ */ n(fn, { inline: !0, ...Y }) }) }) : /* @__PURE__ */ n(E, { when: A.isOpen, children: /* @__PURE__ */ n(
            ri,
            {
              state: A,
              triggerRef: z,
              placement: "bottom start",
              offset: 8,
              children: /* @__PURE__ */ n(si, { ...be, children: /* @__PURE__ */ n(fn, { ...Y }) })
            }
          ) })
        ] })
      }
    ) });
  }
), Wu = /* @__PURE__ */ C(
  function({
    "aria-label": t,
    "aria-required": i,
    defaultValue: r,
    description: s,
    descriptionProps: l = {},
    label: a,
    labelProps: u = {},
    message: h,
    messageProps: o,
    messageTone: c,
    min: d,
    max: _,
    startName: m,
    endName: f,
    onBlur: p,
    onChange: y,
    validationError: x,
    validationErrorProps: k,
    value: I,
    visibleMonthCount: w,
    inline: v,
    ...R
  }, F) {
    var _e, Pe;
    const q = r ? {
      start: me(r.start),
      end: me(r.end)
    } : void 0, N = I ? {
      start: me(I.start),
      end: me(I.end)
    } : void 0, [$, P] = ge(
      N,
      q ?? null,
      null
    ), S = d ? me(d) : void 0, A = _ ? me(_) : void 0, z = Dr({
      isInvalid: !!x || c === "critical",
      minValue: S,
      maxValue: A,
      onChange: (K) => {
        K ? (P(K), y == null || y({
          start: K.start.toString(),
          end: K.end.toString()
        })) : (P(null), y == null || y(void 0));
      },
      shouldCloseOnSelect: !v,
      value: $
    }), L = B(null), {
      groupProps: T,
      labelProps: G,
      descriptionProps: ue,
      startFieldProps: J,
      endFieldProps: be,
      buttonProps: Y,
      dialogProps: te,
      calendarProps: j
    } = dr(
      {
        "aria-label": t,
        isRequired: i === !0 || i === "true" ? !0 : void 0,
        validationBehavior: "aria",
        minValue: S,
        maxValue: A,
        description: x ?? h,
        onBlur: p,
        label: a,
        startName: m,
        endName: f
      },
      z,
      L
    );
    pe(
      F,
      () => ({
        // `ref.focus()` is used by form libraries like `react-hook-form`
        // in order to focus an element upon validation errors etc.
        focus() {
          var K;
          L.current && ((K = L.current.querySelector(
            '[role="spinbutton"]'
          )) == null || K.focus());
        }
      }),
      []
    );
    const O = !!((_e = z.value) != null && _e.start || (Pe = z.value) != null && Pe.end);
    let ne;
    return v && (ne = `${Y.id}-collapsible`), /* @__PURE__ */ n(Yt, { children: /* @__PURE__ */ n(
      de,
      {
        ...R,
        label: a,
        labelProps: { ...u, ...G },
        labelId: G.id,
        description: s,
        descriptionProps: { ...l, ...ue },
        descriptionId: ue.id,
        message: h,
        messageProps: o,
        messageTone: c,
        validationError: x,
        validationErrorProps: k,
        children: (K) => /* @__PURE__ */ b(ie, { children: [
          /* @__PURE__ */ b(
            "div",
            {
              ...T,
              ...K,
              ref: L,
              className: D.group,
              "data-invalid": z.isInvalid ? "true" : void 0,
              children: [
                /* @__PURE__ */ b("div", { className: D["range-field-wrapper"], children: [
                  /* @__PURE__ */ n(Rt, { ...J, isRange: !0 }),
                  /* @__PURE__ */ n(
                    "span",
                    {
                      className: g(
                        D["range-separator"],
                        !O && D["range-separator--empty"]
                      ),
                      children: "–"
                    }
                  ),
                  /* @__PURE__ */ n(Rt, { ...be, isRange: !0 })
                ] }),
                /* @__PURE__ */ n(
                  ii,
                  {
                    ...Y,
                    "aria-controls": v ? ne : Y["aria-controls"],
                    "aria-haspopup": v ? void 0 : Y["aria-haspopup"],
                    onPress: (et) => {
                      var Te;
                      (Te = Y.onPress) == null || Te.call(Y, et), v && z.isOpen && z.setOpen(!1);
                    }
                  }
                )
              ]
            }
          ),
          v ? /* @__PURE__ */ n($e.Root, { open: z.isOpen, children: /* @__PURE__ */ n($e.Content, { animated: !0, id: ne, children: /* @__PURE__ */ n(
            pn,
            {
              ...j,
              inline: !0,
              visibleMonthCount: w
            }
          ) }) }) : /* @__PURE__ */ n(E, { when: z.isOpen, children: /* @__PURE__ */ n(
            ri,
            {
              state: z,
              triggerRef: L,
              placement: "bottom start",
              offset: 8,
              children: /* @__PURE__ */ n(si, { ...te, children: /* @__PURE__ */ n(
                pn,
                {
                  ...j,
                  visibleMonthCount: w
                }
              ) })
            }
          ) })
        ] })
      }
    ) });
  }
), tl = "_prose_1vzo1_1", nl = {
  prose: tl
};
function Hu({ as: e = "div", className: t, ...i }) {
  return $t(e, {
    ...i,
    className: g(nl.prose, t)
  });
}
const il = "_text_85fqn_44", we = {
  text: il,
  "text--truncate": "_text--truncate_85fqn_53",
  "text--display": "_text--display_85fqn_60",
  "text--h1": "_text--h1_85fqn_71",
  "text--h2": "_text--h2_85fqn_82",
  "text--h3": "_text--h3_85fqn_93",
  "text--paragraph": "_text--paragraph_85fqn_104",
  "text--base": "_text--base_85fqn_110",
  "text--heading-screen": "_text--heading-screen_85fqn_117",
  "text--heading-section": "_text--heading-section_85fqn_130",
  "text--heading-subsection": "_text--heading-subsection_85fqn_143",
  "text--heading-body": "_text--heading-body_85fqn_156",
  "text--lead": "_text--lead_85fqn_169",
  "text--body": "_text--body_85fqn_175",
  "text--caption": "_text--caption_85fqn_181",
  "text--fineprint": "_text--fineprint_85fqn_187",
  "text--12": "_text--12_85fqn_194",
  "text--11": "_text--11_85fqn_200",
  "text--10": "_text--10_85fqn_206",
  "text--09": "_text--09_85fqn_212",
  "text--08": "_text--08_85fqn_218",
  "text--07": "_text--07_85fqn_224",
  "text--06": "_text--06_85fqn_230",
  "text--05": "_text--05_85fqn_236",
  "text--04": "_text--04_85fqn_242",
  "text--03": "_text--03_85fqn_248",
  "text--02": "_text--02_85fqn_254",
  "text--01": "_text--01_85fqn_260",
  "text--mb": "_text--mb_85fqn_266",
  "text--mt": "_text--mt_85fqn_270",
  "text--mb-0x": "_text--mb-0x_85fqn_274",
  "text--mb-0.5x": "_text--mb-0.5x_85fqn_278",
  "text--mb-1x": "_text--mb-1x_85fqn_282",
  "text--mb-2x": "_text--mb-2x_85fqn_286",
  "text--mb-3x": "_text--mb-3x_85fqn_290",
  "text--mb-4x": "_text--mb-4x_85fqn_294",
  "text--mb-6x": "_text--mb-6x_85fqn_298",
  "text--mb-8x": "_text--mb-8x_85fqn_302",
  "text--mb-10x": "_text--mb-10x_85fqn_306",
  "text--mt-0x": "_text--mt-0x_85fqn_310",
  "text--mt-0.5x": "_text--mt-0.5x_85fqn_314",
  "text--mt-1x": "_text--mt-1x_85fqn_318",
  "text--mt-2x": "_text--mt-2x_85fqn_322",
  "text--mt-3x": "_text--mt-3x_85fqn_326",
  "text--mt-4x": "_text--mt-4x_85fqn_330",
  "text--mt-6x": "_text--mt-6x_85fqn_334",
  "text--mt-8x": "_text--mt-8x_85fqn_338",
  "text--mt-10x": "_text--mt-10x_85fqn_342",
  "text--wrap-balance": "_text--wrap-balance_85fqn_346",
  "text--wrap-nowrap": "_text--wrap-nowrap_85fqn_350",
  "text--wrap-pretty": "_text--wrap-pretty_85fqn_354",
  "text--wrap-stable": "_text--wrap-stable_85fqn_358",
  "text--wrap-wrap": "_text--wrap-wrap_85fqn_362",
  "text--weight-regular": "_text--weight-regular_85fqn_366",
  "text--weight-display": "_text--weight-display_85fqn_370",
  "text--weight-bold": "_text--weight-bold_85fqn_374"
}, rl = {
  h1: "heading-screen",
  h2: "heading-section",
  h3: "heading-subsection"
};
function sl({
  as: e = "p",
  asChild: t,
  children: i,
  mb: r,
  mt: s,
  size: l = rl[e],
  truncate: a,
  wrap: u,
  weight: h,
  ...o
}, c) {
  const d = { ...o }, _ = gn(r), m = gn(s);
  _ || (d.mb = r), m || (d.mt = s);
  const { className: f, ...p } = Ze(
    d,
    Bt
  );
  return $t(
    t ? re : e,
    {
      ref: c,
      className: g(
        we.text,
        l && we[`text--${l}`],
        a && we["text--truncate"],
        u && we[`text--wrap-${u}`],
        h && we[`text--weight-${h}`],
        _ && we["text--mb"],
        _ && we[`text--mb-${r}`],
        m && we["text--mt"],
        m && we[`text--mt-${s}`],
        f
      ),
      ...p
    },
    i
  );
}
const H = /* @__PURE__ */ C(
  sl
);
function gn(e) {
  switch (e) {
    case "0x":
    case "0.5x":
    case "1x":
    case "2x":
    case "3x":
    case "4x":
    case "6x":
    case "8x":
    case "10x":
      return !0;
    default:
      return !1;
  }
}
function ee(e, t, i, r) {
  function s(l) {
    return /* @__PURE__ */ n(H, { as: e, size: t, wrap: r, ...l });
  }
  return s.displayName = i, s;
}
const Gu = /* @__PURE__ */ ee(
  "h1",
  "heading-screen",
  "HeadingScreen",
  "balance"
), Uu = /* @__PURE__ */ ee(
  "h2",
  "heading-section",
  "HeadingSection",
  "balance"
), Yu = /* @__PURE__ */ ee(
  "h3",
  "heading-subsection",
  "HeadingSubsection",
  "balance"
), Ku = /* @__PURE__ */ ee(
  "h4",
  "heading-body",
  "HeadingBody",
  "balance"
), Qu = /* @__PURE__ */ ee("p", "lead", "Lead", "pretty"), Xu = /* @__PURE__ */ ee("p", "body", "Body", "pretty"), Zu = /* @__PURE__ */ ee(
  "p",
  "caption",
  "Caption",
  "pretty"
), Ju = /* @__PURE__ */ ee(
  "p",
  "fineprint",
  "Fineprint",
  "pretty"
), e_ = /* @__PURE__ */ ee("h1", "display", "Display"), t_ = /* @__PURE__ */ ee("h1", "h1", "H1"), n_ = /* @__PURE__ */ ee("h2", "h2", "H2"), i_ = /* @__PURE__ */ ee("h3", "h3", "H3"), r_ = /* @__PURE__ */ ee(
  "p",
  "paragraph",
  "Paragraph"
), s_ = /* @__PURE__ */ ee("p", "base", "Base"), ol = "_item_171xs_1", al = "_standard_171xs_6", ll = "_condensed_171xs_13", cl = "_vertical_171xs_17", Le = {
  item: ol,
  standard: al,
  condensed: ll,
  vertical: cl
}, dl = "_content_g82ka_1", ul = {
  content: dl
}, _l = (e) => /* @__PURE__ */ n(Qe.Popover, { ...e }), ml = (e) => /* @__PURE__ */ n(Qe.Trigger, { ...e }), hl = ({
  className: e,
  sideOffset: t = 6,
  ...i
}) => /* @__PURE__ */ n(Qe.Portal, { children: /* @__PURE__ */ n(
  Qe.Content,
  {
    className: g(ul.content, e),
    sideOffset: t,
    ...i
  }
) }), fl = (e) => /* @__PURE__ */ n(Qe.Close, { ...e });
var Ue;
((e) => {
  e.Root = _l, e.Trigger = ml, e.Content = hl, e.Close = fl;
})(Ue || (Ue = {}));
const pl = "_dialog_xqei5_1", gl = "_centered_xqei5_23", bl = "_header_xqei5_34", yl = "_body_xqei5_44", xl = "_footer_xqei5_49", Xe = {
  dialog: pl,
  centered: gl,
  header: bl,
  body: yl,
  footer: xl
}, wl = ({ children: e, className: t }) => /* @__PURE__ */ n("div", { className: g(Xe.body, t), children: e }), ai = ae({
  dialogRef: { current: null },
  focusRef: { current: null },
  modalContentId: "changeme",
  modalDescriptionId: "changeme",
  modalTitleId: "changeme",
  open: !1,
  onOpenChange: () => {
  }
}), Je = () => Z(ai), li = ae(!1), vl = () => Z(li), ci = ({ asChild: e, ...t }) => {
  const { onOpenChange: i } = Je();
  return /* @__PURE__ */ n(e ? re : "button", { onClick: (l) => {
    l.defaultPrevented || i(!1);
  }, type: "button", ...t });
};
function Nl(e, t) {
  const i = t.getBoundingClientRect();
  return e.clientX >= i.left && e.clientX <= i.right && e.clientY >= i.top && e.clientY <= i.bottom;
}
const Cl = ({
  alwaysCentered: e,
  children: t,
  className: i,
  closeOnBackdropClick: r = !1
}) => {
  const {
    dialogRef: s,
    modalContentId: l,
    modalDescriptionId: a,
    modalTitleId: u,
    open: h,
    onOpenChange: o
  } = Je();
  Pr({
    isDisabled: !h
  });
  const c = le(
    (d) => {
      d.target === s.current && (!r || !s.current || Nl(d, s.current) || o(!1));
    },
    [s, r, o]
  );
  return (
    // ESLint might complain about the `role` attribute being redundant,
    // but when omitting it certain browsers fail to announce the dialog
    // as an actual dialog, so we'll keep it until we confirm that it is
    // no longer needed.
    // TODO: Make sure that we don't have to follow any of the disabled eslint rules.
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/no-redundant-roles
    /* @__PURE__ */ n(
      "dialog",
      {
        ref: s,
        id: l,
        "aria-labelledby": u,
        "aria-describedby": a,
        "aria-modal": "true",
        role: "dialog",
        className: g(
          Xe.dialog,
          e && Xe.centered,
          i
        ),
        onClick: c,
        onKeyDown: (d) => {
          d.key === "Escape" && !d.defaultPrevented && (d.preventDefault(), o(!1));
        },
        children: /* @__PURE__ */ n(li.Provider, { value: !0, children: t })
      }
    )
  );
}, Il = ({ children: e, className: t }) => /* @__PURE__ */ n("div", { className: g(Xe.footer, t), children: e }), di = ({ asChild: e, ...t }) => {
  const { modalTitleId: i } = Je();
  return e ? /* @__PURE__ */ n(re, { ...t, id: i, tabIndex: -1 }) : /* @__PURE__ */ n(H, { ...t, as: "h2", id: i, tabIndex: -1 });
}, kl = "_button_14xxd_1", Rl = "_icon_14xxd_15", bn = {
  button: kl,
  icon: Rl
}, Pl = (e) => /* @__PURE__ */ n(ci, { ...e, className: g(bn.button, e.className), children: /* @__PURE__ */ n(M, { asChild: !0, align: "center", gap: ".25rem", children: /* @__PURE__ */ b("span", { children: [
  /* @__PURE__ */ n(H, { as: "span", size: "lead", children: e.children }),
  /* @__PURE__ */ n(Mn, { className: bn.icon, "aria-hidden": !0 })
] }) }) }), Sl = ({
  children: e,
  closeButtonLabel: t
}) => {
  const i = V(), r = t || (i === "en" ? "Close" : "Stäng");
  return /* @__PURE__ */ b(
    M,
    {
      justify: "space-between",
      align: "center",
      wrap: "wrap",
      gap: ".5rem",
      className: g(Xe.header),
      children: [
        /* @__PURE__ */ n(ce, { flex: 1, asChild: !0, children: e ? /* @__PURE__ */ n(di, { asChild: !0, children: /* @__PURE__ */ n(H, { as: "h2", size: "lead", children: e }) }) : /* @__PURE__ */ n(wr, { width: "5rem", height: "auto" }) }),
        /* @__PURE__ */ n(ce, { flexShrink: 0, asChild: !0, children: /* @__PURE__ */ n(Pl, { children: r }) })
      ]
    }
  );
};
function zl(e, t) {
  W(() => {
    if (!t)
      return;
    const i = e.current, r = () => {
      var s;
      if (typeof t == "string") {
        (s = document.getElementById(t)) == null || s.focus();
        return;
      }
      if (t.current) {
        t.current.focus();
        return;
      }
    };
    return i == null || i.addEventListener("close", r), () => {
      i == null || i.removeEventListener("close", r);
    };
  }, [t, e]);
}
function $l(e, t) {
  W(() => {
    const i = (s) => {
      s.preventDefault(), t(!1);
    }, r = e.current;
    return r == null || r.addEventListener("cancel", i), () => {
      r == null || r.removeEventListener("cancel", i);
    };
  }, [t, e]);
}
function El(e, t, i) {
  W(() => {
    var r, s, l, a;
    i ? ((r = e.current) == null || r.showModal(), t.current ? (s = t.current) == null || s.focus() : (l = e.current) == null || l.focus()) : (a = e.current) == null || a.close();
  }, [i, e, t]);
}
const Ml = ({ focusOnClose: e, ...t }) => {
  const i = B(null), [r, s] = Q(!1), l = X(), a = t.open ?? r, u = t.onOpenChange ?? s, h = Re(() => ({
    dialogRef: i,
    focusRef: { current: null },
    modalContentId: `${l}-content`,
    modalDescriptionId: `${l}-description`,
    modalTitleId: `${l}-title`,
    open: a,
    onOpenChange: u
  }), [l, a, u]);
  return zl(i, e), $l(i, u), El(i, h.focusRef, a), /* @__PURE__ */ n(ai.Provider, { value: h, children: t.children });
}, Fl = ({ asChild: e, ...t }) => {
  const { modalContentId: i, open: r, onOpenChange: s } = Je();
  return /* @__PURE__ */ n(
    e ? re : "button",
    {
      ...t,
      tabIndex: 0,
      "aria-controls": i,
      "aria-expanded": r,
      "aria-haspopup": "dialog",
      onClick: (u) => {
        u.defaultPrevented || s(!0);
      }
    }
  );
}, Ne = {
  Body: wl,
  Close: ci,
  Content: Cl,
  Footer: Il,
  Header: Sl,
  Root: Ml,
  Title: di,
  Trigger: Fl
};
function o_({
  className: e,
  items: t,
  renderItem: i,
  keyExtractor: r = (u, h) => (u == null ? void 0 : u.key) || (u == null ? void 0 : u.id) || h,
  variant: s = "standard",
  children: l,
  ...a
}) {
  return /* @__PURE__ */ n(Do, { asChild: !0, m: "0", children: /* @__PURE__ */ n(
    mt,
    {
      asChild: !0,
      p: "0",
      backgroundColor: `color-mix(in srgb, transparent, ${U("color-modifier-increase")} 4%)`,
      borderColor: !1,
      children: /* @__PURE__ */ n(
        "dl",
        {
          className: g(
            s === "standard" && Le.standard,
            s === "condensed" && Le.condensed,
            s === "vertical" && Le.vertical,
            e
          ),
          ...a,
          children: l || (t == null ? void 0 : t.map((u, h) => {
            const o = i(u, h);
            return o ? /* @__PURE__ */ n(_t, { children: o }, r(u, h)) : null;
          }))
        }
      )
    }
  ) });
}
const a_ = ({
  term: e,
  details: t,
  contextualHelp: i,
  className: r,
  ...s
}) => {
  const l = typeof e == "string" && !!i;
  return /* @__PURE__ */ b(
    Eo,
    {
      columns: 2,
      className: g(Le.item, r),
      "gap-x": ".5rem",
      ...s,
      children: [
        /* @__PURE__ */ n(
          H,
          {
            asChild: !0,
            size: "02",
            weight: "display",
            style: { color: U("color-muted") },
            children: /* @__PURE__ */ b("dt", { className: Le.term, children: [
              /* @__PURE__ */ n(ce, { as: "span", mr: l ? ".5em" : void 0, children: e }),
              l && /* @__PURE__ */ n(
                Dl,
                {
                  type: i.type,
                  title: i.title,
                  term: typeof e == "string" ? e : void 0,
                  content: i.content
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ n(ce, { asChild: !0, m: "0", children: /* @__PURE__ */ n(
          H,
          {
            asChild: !0,
            size: "02",
            weight: "display",
            style: { color: U("color-default-foreground") },
            children: /* @__PURE__ */ n("dd", { className: Le.details, children: t })
          }
        ) })
      ]
    }
  );
}, yn = () => /* @__PURE__ */ n(
  En,
  {
    size: "1.25em",
    style: {
      display: "inline-block",
      color: U("color-default-foreground"),
      verticalAlign: "-0.3em"
    }
  }
), Dl = ({
  content: e,
  term: t,
  title: i,
  type: r
}) => {
  const s = V();
  let l = s === "en" ? "More information" : "Mer information";
  return t && (l = s === "en" ? `More information about ${t}` : `Mer information om ${t}`), i && (l = i), r === "popover" ? /* @__PURE__ */ b(Ue.Root, { children: [
    /* @__PURE__ */ n(Ue.Trigger, { asChild: !0, children: /* @__PURE__ */ n(
      ct,
      {
        style: { borderRadius: ".5rem", width: "auto" },
        "aria-label": l,
        children: /* @__PURE__ */ n(yn, {})
      }
    ) }),
    /* @__PURE__ */ n(Ue.Content, { children: e })
  ] }) : r === "modal" ? /* @__PURE__ */ b(Ne.Root, { children: [
    /* @__PURE__ */ n(Ne.Trigger, { asChild: !0, children: /* @__PURE__ */ n(
      ct,
      {
        style: { borderRadius: ".5rem", width: "auto" },
        "aria-label": l,
        children: /* @__PURE__ */ n(yn, { "aria-label": l })
      }
    ) }),
    /* @__PURE__ */ b(Ne.Content, { closeOnBackdropClick: !0, children: [
      /* @__PURE__ */ n(E, { when: i || t, children: /* @__PURE__ */ n(Ne.Header, { children: i || t }) }),
      /* @__PURE__ */ n(Ne.Body, { children: e })
    ] })
  ] }) : null;
}, Bl = "_icon_fjdhq_1", ql = {
  icon: Bl
}, l_ = ({
  className: e,
  date: t,
  size: i = "3rem",
  ...r
}) => {
  const s = V(), l = new Intl.DateTimeFormat(ft(s), {
    month: "short"
  }).format(t).toUpperCase().replace(".", "").slice(0, 3), a = t.getDate();
  return /* @__PURE__ */ b(
    "svg",
    {
      className: g(ql.icon, e),
      width: i,
      height: i,
      viewBox: "0 0 48 48",
      "aria-hidden": !0,
      ...r,
      children: [
        /* @__PURE__ */ n(
          "text",
          {
            x: "50%",
            y: "15",
            textAnchor: "middle",
            dominantBaseline: "middle",
            style: {
              fill: U("color-accent-accessible"),
              fontSize: "10px",
              fontWeight: "500",
              lineHeight: "18px",
              letterSpacing: "1px",
              textTransform: "uppercase"
            },
            children: l
          }
        ),
        /* @__PURE__ */ n(
          "text",
          {
            x: "50%",
            y: "33",
            textAnchor: "middle",
            dominantBaseline: "middle",
            style: {
              fill: U("color-secondary-foreground"),
              fontSize: "18px",
              fontWeight: "500",
              fontVariantNumeric: "tabular-nums",
              lineHeight: "24px",
              letterSpacing: "1px"
            },
            children: a
          }
        )
      ]
    }
  );
}, Al = "_exclamationSpinner_1jmct_1", Ll = "_exclamationSpinnerCircle_1jmct_6", Tl = "_exclamationSpinnerRect_1jmct_13", wt = {
  exclamationSpinner: Al,
  exclamationSpinnerCircle: Ll,
  exclamationSpinnerRect: Tl
};
function Vl({ className: e, ...t }, i) {
  return /* @__PURE__ */ b(
    "svg",
    {
      ...t,
      role: "progressbar",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      className: g(wt.exclamationSpinner, e),
      viewBox: "100 100 300 300",
      xmlns: "http://www.w3.org/2000/svg",
      ref: i,
      children: [
        /* @__PURE__ */ n(
          "rect",
          {
            className: wt.exclamationSpinnerRect,
            x: "220",
            y: "200",
            width: "50",
            height: "190"
          }
        ),
        /* @__PURE__ */ n(
          "circle",
          {
            className: wt.exclamationSpinnerCircle,
            cx: "245",
            cy: "140",
            r: "30"
          }
        )
      ]
    }
  );
}
const c_ = /* @__PURE__ */ C(
  Vl
);
function jl(e) {
  const t = [
    "block",
    "description",
    "descriptionProps",
    "contextualHelp",
    "label",
    "message",
    "messageTone",
    "secondaryLabel",
    "supplemental",
    "validationError",
    "validationErrorProps",
    "labelId",
    "descriptionId",
    "validationErrorId",
    "messageId",
    "labelClassName",
    "labelProps",
    "labelRef",
    "messageClassName",
    "messageProps",
    "messageRef",
    "tone"
  ], i = {}, r = {};
  return Object.entries(e).forEach(([s, l]) => {
    t.includes(s) ? i[s] = l : r[s] = l;
  }), [i, r];
}
const Ol = "_committedFiles_1zfcj_1", Wl = "_file_1zfcj_7", Hl = "_success_1zfcj_13", Gl = "_error_1zfcj_16", Ul = "_fileName_1zfcj_20", Yl = "_message_1zfcj_25", Kl = "_messageIcon_1zfcj_31", Ql = "_fileSize_1zfcj_35", Xl = "_dismissButton_1zfcj_39", Zl = "_removing_1zfcj_57", ve = {
  committedFiles: Ol,
  file: Wl,
  success: Hl,
  error: Gl,
  fileName: Ul,
  message: Yl,
  messageIcon: Kl,
  fileSize: Ql,
  dismissButton: Xl,
  removing: Zl
};
class Jl extends Error {
  /**
   * Used to control what message is displayed in the dropzone component when
   * the file drop operation encounters an error.
   */
  constructor(t) {
    super(t), this.name = "FileUploaderDropError";
  }
}
class ui extends Error {
  /**
   * Used to control what message is displayed in the error modal when the
   * `onRemove` callback throws an error.
   */
  constructor(t) {
    super(t), this.name = "FileUploaderRemoveError";
  }
}
function _i() {
  const e = V(), [t, i] = Q(!1);
  return W(() => {
    const { matches: r } = window.matchMedia("(min-width: 768px)");
    i(r);
  }, []), W(() => {
    const r = (s) => {
      const { matches: l } = window.matchMedia("(min-width: 768px)");
      l && !t && i(!0), !l && t && i(!1);
    };
    return window.addEventListener("resize", r), () => {
      window.removeEventListener("resize", r);
    };
  }, [t]), (r) => {
    var s, l;
    return t && Oe[r] ? Oe[r][e] : ((s = vt == null ? void 0 : vt[r]) == null ? void 0 : s[e]) || ((l = Oe == null ? void 0 : Oe[r]) == null ? void 0 : l[e]);
  };
}
const vt = {
  loading: {
    en: "Uploading...",
    sv: "Laddar upp..."
  },
  idle: {
    en: "Press to upload",
    sv: "Tryck för att ladda upp"
  },
  errorTitle: {
    en: "Error",
    sv: "Fel"
  },
  errorMessage: {
    en: "An error occurred while processing your file. Please try again later.",
    sv: "Ett fel uppstod när filen skulle behandlas. Vänligen försök igen senare."
  },
  errorDismiss: {
    en: "Dismiss",
    sv: "Stäng"
  }
}, Oe = {
  drop: {
    en: "Drop here",
    sv: "Släpp här"
  },
  idle: {
    en: "Drag and drop files here, or click to select files",
    sv: "Dra och släpp filer här, eller klicka för att välja filer"
  }
}, ec = ({ dissmiss: e, error: t }) => {
  const i = _i();
  let r;
  return t instanceof ui && (r = t.message), /* @__PURE__ */ n(Ne.Root, { open: !!t, children: /* @__PURE__ */ n(Ne.Content, { children: /* @__PURE__ */ n(Ne.Body, { children: /* @__PURE__ */ b(M, { direction: "column", gap: "1rem", children: [
    /* @__PURE__ */ n(H, { children: r ?? i("errorMessage") }),
    /* @__PURE__ */ n(Ne.Close, { asChild: !0, children: /* @__PURE__ */ n(
      Un,
      {
        style: {
          alignSelf: "start"
        },
        onClick: e,
        children: i("errorDismiss")
      }
    ) })
  ] }) }) }) });
}, mi = ({ className: e, children: t, ...i }) => /* @__PURE__ */ n(M, { asChild: !0, direction: "column", gap: "1rem", children: /* @__PURE__ */ n("ul", { className: g(ve.committedFiles, e), ...i, children: t }) }), hi = ({
  id: e,
  name: t,
  size: i,
  onRemove: r,
  message: s,
  variant: l
}) => {
  const [a, u] = Q(!1), [h, o] = Q(!1), c = l === "success", d = async (_) => {
    o(!0);
    try {
      await r(_);
    } catch (m) {
      m instanceof ui ? u(m) : u(!0);
    } finally {
      o(!1);
    }
  };
  return /* @__PURE__ */ b(ie, { children: [
    /* @__PURE__ */ b("li", { className: g(ve.file, ve[l]), children: [
      /* @__PURE__ */ b(
        M,
        {
          direction: "column",
          gap: ".15rem",
          style: { minWidth: "0", width: "100%" },
          children: [
            /* @__PURE__ */ b(
              M,
              {
                justify: "space-between",
                "md-justify": "flex-start",
                align: "center",
                gap: ".5rem",
                children: [
                  /* @__PURE__ */ n(H, { size: "caption", title: t, className: ve.fileName, children: t }),
                  i ? /* @__PURE__ */ b(
                    H,
                    {
                      size: "fineprint",
                      wrap: "nowrap",
                      style: {
                        color: U("color-muted")
                      },
                      children: [
                        "(",
                        Ge(i),
                        ")"
                      ]
                    }
                  ) : null
                ]
              }
            ),
            /* @__PURE__ */ b(
              M,
              {
                align: "center",
                gap: ".25rem",
                style: {
                  color: U(
                    c ? "color-positive" : "color-critical"
                  )
                },
                children: [
                  c ? /* @__PURE__ */ n(qn, { size: "1rem", className: ve.messageIcon }) : /* @__PURE__ */ n(An, { size: "1rem", className: ve.messageIcon }),
                  s && /* @__PURE__ */ n(H, { size: "fineprint", title: s, className: ve.message, children: s })
                ]
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ n(M, { align: "center", justify: "center", children: /* @__PURE__ */ n(
        "button",
        {
          className: ve.dismissButton,
          onClick: () => {
            d(e);
          },
          "aria-label": `Remove file with name ${t}`,
          type: "button",
          children: h ? /* @__PURE__ */ n(
            Lt,
            {
              className: ve.removing,
              color: U("color-default-foreground")
            }
          ) : /* @__PURE__ */ n(vr, { size: "1rem" })
        }
      ) })
    ] }),
    /* @__PURE__ */ n(ec, { error: a, dissmiss: () => u(!1) })
  ] });
}, tc = ({
  defaultMessage: e,
  files: t,
  onDismiss: i,
  className: r
}) => !t || !t.length ? null : /* @__PURE__ */ n(mi, { className: r, children: t.map(({ id: s, file: l, message: a }) => /* @__PURE__ */ n(
  hi,
  {
    id: s,
    name: l.name,
    size: l.size,
    onRemove: i,
    variant: "error",
    message: a ?? e
  },
  s
)) }), nc = {
  acceptedItems: [],
  isDragActive: !1,
  isLoading: !1,
  rejectedItems: [],
  error: null
};
function ic(e, t) {
  switch (t.type) {
    case "HANDLE_FILES_START":
      return {
        ...e,
        error: null,
        isLoading: !0
      };
    case "HANDLE_FILES_END":
      return {
        ...e,
        isDragActive: !1,
        isLoading: !1
      };
    case "HANDLE_FILES_SUCCESS":
      return {
        ...e,
        acceptedItems: [
          ...e.acceptedItems,
          ...t.payload.acceptedItems
        ],
        // Here we effectively clear the rejected files state when the user is done adding more files, might be fine, might be shite.
        rejectedItems: t.payload.rejectedItems
      };
    case "SET_FILES":
      return { ...e, acceptedItems: t.payload };
    case "SET_DRAG_ACTIVE":
      return { ...e, isDragActive: t.payload };
    case "SET_REJECTED_FILES":
      return { ...e, rejectedItems: t.payload };
    case "REMOVE_REJECTED_FILE":
      return {
        ...e,
        rejectedItems: t.payload.rejectedItems
      };
    case "REMOVE_FILE":
      return {
        ...e,
        error: null,
        acceptedItems: t.payload.acceptedItems
      };
    case "SET_ERROR":
      return { ...e, error: t.payload };
    default:
      return e;
  }
}
const rc = (e) => {
  const [t, i] = In(ic, {
    ...nc,
    acceptedItems: e
  });
  return [t, {
    setError(s) {
      i({ type: "SET_ERROR", payload: s });
    },
    handleFilesStart() {
      i({ type: "HANDLE_FILES_START" });
    },
    handleFilesSuccess(s) {
      i({
        type: "HANDLE_FILES_SUCCESS",
        payload: s
      });
    },
    handleFilesEnd() {
      i({ type: "HANDLE_FILES_END" });
    },
    setDragActive(s) {
      i({ type: "SET_DRAG_ACTIVE", payload: s });
    },
    removeRejectedFile(s) {
      i({ type: "REMOVE_REJECTED_FILE", payload: s });
    },
    removeFile(s) {
      i({ type: "REMOVE_FILE", payload: s });
    }
  }];
};
function sc(e) {
  return {
    id: crypto.randomUUID(),
    file: e
  };
}
const oc = ({
  accept: e,
  byline: t,
  defaultAcceptedMessage: i,
  defaultRejectedMessage: r,
  maxSize: s,
  multiple: l,
  onBlur: a,
  onFocus: u,
  onChange: h,
  onDrop: o,
  onRemove: c,
  onDismiss: d,
  name: _,
  value: m,
  defaultItems: f = []
} = {}) => {
  const p = V(), y = B(null);
  let [
    { acceptedItems: x, error: k, isDragActive: I, isLoading: w, rejectedItems: v },
    R
  ] = rc(f);
  m && (x = m.acceptedItems, v = m.rejectedItems), W(() => {
    const N = y.current;
    if (!N)
      return;
    const $ = new DataTransfer();
    return x.forEach((P) => {
      $.items.add(P.file);
    }), N.files = $.files, () => {
      N.files = new DataTransfer().files;
    };
  }, [x]);
  const F = le(
    (N) => {
      if (!(e != null && e.length) && !s)
        return { acceptedItems: N, rejectedItems: [] };
      const $ = [], P = [];
      return N.forEach((S) => {
        if (s && S.file.size > s) {
          P.push({
            ...S,
            message: p === "sv" ? `Filstorleken (${Ge(S.file.size)}) överskrider maximal tillåten storlek på ${Ge(s)}` : `File size (${Ge(S.file.size)}) exceeds maximum allowed size of ${Ge(s)}`
          });
          return;
        }
        !(e != null && e.length) || e.some((z) => {
          if (z.endsWith("/*")) {
            const L = z.slice(0, -2);
            return S.file.type.startsWith(L);
          }
          return z.startsWith(".") ? S.file.name.endsWith(z) : S.file.type === z;
        }) ? $.push(S) : P.push({
          ...S,
          message: p === "sv" ? `Filtypen ${S.file.type || "okänd"} accepteras inte. Tillåtna typer: ${e.join(", ")}` : `File type ${S.file.type || "unknown"} is not accepted. Allowed types: ${e.join(", ")}`
        });
      }), { acceptedItems: $, rejectedItems: P };
    },
    [e, s, p]
  ), q = async (N) => {
    R.handleFilesStart();
    try {
      const $ = x.length + N.length;
      if (!l && $ > 1) {
        R.setError(
          p === "sv" ? "Endast en fil är tillåten" : "Only one file allowed"
        );
        return;
      }
      const P = N.filter((L) => L.type !== "").map(sc), S = F(P), z = await (o == null ? void 0 : o(S)) || S;
      h == null || h({
        acceptedItems: [...x, ...z.acceptedItems],
        rejectedItems: [...v, ...z.rejectedItems]
      }), R.handleFilesSuccess(z);
    } catch ($) {
      let P = p === "sv" ? "Ett fel uppstod när filerna skulle läggas till." : "An error occurred when adding the files.";
      $ instanceof Jl && (P = $.message), R.setError(P);
    } finally {
      R.handleFilesEnd();
    }
  };
  return {
    dropzoneProps: {
      error: k,
      isDragActive: I,
      isLoading: w,
      multiple: l,
      byline: t,
      onBlur: a,
      onFocus: u,
      onClick: () => {
        var N;
        (N = y.current) == null || N.click();
      },
      onDrop: async (N) => {
        N.preventDefault();
        const $ = N.dataTransfer.items.length ? Array.from(N.dataTransfer.items).filter((P) => P.kind === "file").map((P) => P.getAsFile()).filter((P) => P !== null) : Array.from(N.dataTransfer.files);
        await q($);
      },
      onDragOver: (N) => {
        N.preventDefault(), I || R.setDragActive(!0);
      },
      onDragLeave: () => {
        I && R.setDragActive(!1);
      }
    },
    inputProps: {
      ref: y,
      name: _,
      type: "file",
      style: { display: "none" },
      onChange: async (N) => {
        if (N.target && N.target.files && N.target.files.length > 0) {
          const $ = Array.from(N.target.files);
          await q($);
        }
      },
      multiple: l,
      accept: e == null ? void 0 : e.toString()
    },
    rejectedFilesProps: {
      defaultMessage: r,
      files: v,
      onDismiss: (N) => {
        d == null || d(N);
        const $ = {
          acceptedItems: x,
          rejectedItems: v.filter((P) => P.id !== N)
        };
        R.removeRejectedFile($), h == null || h($);
      }
    },
    acceptedFilesProps: {
      defaultMessage: i,
      files: x,
      onRemove: async (N) => {
        await (c == null ? void 0 : c(N));
        const $ = {
          acceptedItems: x.filter((P) => P.id !== N),
          rejectedItems: v
        };
        R.removeFile($), h == null || h($);
      }
    }
  };
}, ac = ({
  defaultMessage: e,
  files: t,
  onRemove: i,
  className: r
}) => !t || !t.length ? null : /* @__PURE__ */ n(mi, { className: r, children: t.map(({ id: s, file: l, message: a }) => /* @__PURE__ */ n(
  hi,
  {
    id: s,
    name: l.name,
    size: l.size,
    onRemove: i,
    variant: "success",
    message: a ?? e
  },
  s
)) }), lc = ({ className: e }) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "70",
    height: "70",
    viewBox: "0 0 18 19",
    fill: "none",
    style: { display: "inline" },
    className: e,
    children: /* @__PURE__ */ n(
      "path",
      {
        d: "M13.2875 9.37797C12.8908 7.43734 11.1233 5.98047 9 5.98047C7.31417 5.98047 5.85 6.90297 5.12083 8.25297C3.365 8.43297 2 9.86734 2 11.6055C2 13.4673 3.56917 14.9805 5.5 14.9805H13.0833C14.6933 14.9805 16 13.7205 16 12.168C16 10.683 14.8042 9.47922 13.2875 9.37797ZM10.1667 11.043V13.293H7.83333V11.043H6.08333L9 8.23047L11.9167 11.043H10.1667Z",
        fill: U("color-primary")
      }
    )
  }
), cc = "_dropZone_hkwi1_1", dc = "_isDragActive_hkwi1_14", uc = "_hasError_hkwi1_17", _c = "_spinner_hkwi1_25", mc = "_icon_hkwi1_30", Ye = {
  dropZone: cc,
  isDragActive: dc,
  hasError: uc,
  spinner: _c,
  icon: mc
}, fi = C(
  ({ isDragActive: e, error: t, isLoading: i, multiple: r, className: s, byline: l, ...a }, u) => /* @__PURE__ */ n(
    "button",
    {
      ref: u,
      className: g(
        Ye.dropZone,
        e && Ye.isDragActive,
        t && Ye.hasError,
        s
      ),
      type: "button",
      ...a,
      children: /* @__PURE__ */ n(
        hc,
        {
          isLoading: i,
          isDragActive: e,
          error: t,
          multiple: r,
          byline: l
        }
      )
    }
  )
);
fi.displayName = "Dropzone";
const hc = ({
  isLoading: e,
  isDragActive: t,
  error: i,
  byline: r
}) => {
  const s = _i();
  return /* @__PURE__ */ b("div", { style: { pointerEvents: "none" }, children: [
    e ? /* @__PURE__ */ n(Lt, { className: Ye.spinner }) : /* @__PURE__ */ n(lc, { className: Ye.icon }),
    e ? /* @__PURE__ */ n(Nt, { children: s("loading") }) : t ? /* @__PURE__ */ n(Nt, { children: s("drop") }) : i ? /* @__PURE__ */ n(fc, { children: i }) : /* @__PURE__ */ b(M, { direction: "column", gap: ".25rem", children: [
      /* @__PURE__ */ n(Nt, { children: s("idle") }),
      r && /* @__PURE__ */ n(
        H,
        {
          as: "span",
          size: "caption",
          style: { color: U("color-muted") },
          children: r
        }
      )
    ] })
  ] });
}, Nt = ({ children: e }) => /* @__PURE__ */ n(H, { as: "div", size: "lead", children: e }), fc = ({ children: e }) => /* @__PURE__ */ n(
  H,
  {
    as: "div",
    size: "lead",
    style: { color: U("color-critical") },
    children: e
  }
), pc = /* @__PURE__ */ C((e, t) => {
  const [i, r] = jl(e), { dropzoneProps: s, inputProps: l, rejectedFilesProps: a, acceptedFilesProps: u } = oc(r);
  return /* @__PURE__ */ n(de, { ...i, children: ({ id: h, ...o }) => /* @__PURE__ */ b(M, { direction: "column", gap: ".5rem", children: [
    /* @__PURE__ */ n(fi, { ...o, ...s, ref: t }),
    /* @__PURE__ */ n("input", { id: h, ...l }),
    /* @__PURE__ */ n(tc, { ...a }),
    /* @__PURE__ */ n(ac, { ...u })
  ] }) });
});
pc.displayName = "FileUploader";
class d_ {
  constructor(t) {
    if ("name" in t && t.name)
      this.file = new File([], t.name);
    else if ("file" in t && t.file)
      this.file = t.file;
    else
      throw new Error("Either file or name must be provided");
    this.id = t.id, this.message = t.message;
  }
}
function u_({ active: e = !0, children: t }) {
  const i = B(null), { focusRef: r, open: s } = Je(), l = vl();
  let a = e;
  return l && s === !1 && (a = !1), W(() => {
    var h;
    const u = i.current;
    return typeof (u == null ? void 0 : u.focus) == "function" && (!((h = u.hasAttribute) != null && h.call(u, "tabindex")) && u.tabIndex < 0 && u.setAttribute("tabIndex", "-1"), u.focus()), l && (r.current = u), () => {
      r.current === u && (r.current = null);
    };
  }, [l, r]), a ? /* @__PURE__ */ n(re, { ref: i, children: t }) : Wi.only(t);
}
const gc = "_link_13w04_1", bc = {
  link: gc
};
function yc({
  asChild: e,
  children: t,
  className: i,
  focusClassName: r = Dt[":focus"],
  ...s
}) {
  return /* @__PURE__ */ n(
    e ? re : "a",
    {
      className: g(i, r, bc.link),
      ...s,
      "data-sbui-plainlink": !0,
      children: t
    }
  );
}
const xc = "_informationCard_1nqgg_1", wc = "_title_1nqgg_27", vc = "_body_1nqgg_31", Nc = "_footer_1nqgg_34", We = {
  informationCard: xc,
  "informationCard--information": "_informationCard--information_1nqgg_15",
  "informationCard--warning": "_informationCard--warning_1nqgg_18",
  "informationCard--positive": "_informationCard--positive_1nqgg_21",
  "informationCard--critical": "_informationCard--critical_1nqgg_24",
  title: wc,
  body: vc,
  footer: Nc
}, Cc = {
  information: Cr,
  warning: An,
  positive: qn,
  critical: Nr
}, Ic = (e) => /* @__PURE__ */ n(ta, { external: e.external, href: e.href, children: e.label }, e.key), kc = /* @__PURE__ */ C(
  ({
    "aria-labelledby": e,
    children: t,
    className: i,
    footerLinks: r,
    renderFooterLink: s = Ic,
    role: l,
    title: a,
    variant: u = "information",
    ...h
  }, o) => {
    const c = Cc[u], d = X();
    let _ = e;
    return l && a && !_ && (_ = d), /* @__PURE__ */ b(
      mt,
      {
        ...h,
        "aria-labelledby": _,
        backgroundColor: U(`color-muted-${u}`),
        borderColor: U(`color-muted-${u}-stroke`),
        className: g(
          We.informationCard,
          u && We[`informationCard--${u}`],
          i
        ),
        ref: o,
        role: l,
        children: [
          c && /* @__PURE__ */ n(c, { size: "1.5em", "aria-hidden": "true" }),
          /* @__PURE__ */ b(M, { flex: "1", direction: "column", gap: "0.25rem", children: [
            a && /* @__PURE__ */ n("span", { className: We.title, id: d, children: a }),
            /* @__PURE__ */ n("div", { className: We.body, children: t }),
            r && /* @__PURE__ */ n("div", { className: We.footer, children: r.map(
              (m, f, p) => s({ ...m, key: m.href }, f, p)
            ) })
          ] })
        ]
      }
    );
  }
);
kc.displayName = "InformationCard";
const Rc = "_input_j84sq_1", Ee = {
  input: Rc,
  "input--invalid": "_input--invalid_j84sq_28",
  "input--large": "_input--large_j84sq_31",
  "input--small": "_input--small_j84sq_36"
};
function Pc({
  className: e,
  invalid: t = !1,
  innerRef: i,
  type: r = "text",
  size: s,
  // Prevent block prop from ending up as an attribute on underlying element
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  block: l,
  ...a
}, u) {
  return /* @__PURE__ */ n(
    "input",
    {
      ...a,
      "aria-invalid": t ? !0 : void 0,
      type: r,
      ref: u ?? i,
      className: g(
        Ee.input,
        s && Ee[`input--${s}`],
        t && Ee["input--invalid"],
        e
      )
    }
  );
}
const Sc = /* @__PURE__ */ C(Pc);
function zc({
  "aria-label": e,
  "aria-labelledby": t,
  "aria-describedby": i,
  "aria-required": r,
  className: s,
  defaultValue: l,
  disabled: a,
  formatOptions: u,
  id: h,
  invalid: o,
  inputMode: c,
  inputRef: d,
  min: _,
  max: m,
  maxLength: f,
  name: p,
  onBlur: y,
  onChange: x,
  onFocus: k,
  onInput: I,
  onKeyDown: w,
  placeholder: v,
  readOnly: R,
  step: F,
  value: q,
  ...N
}) {
  const $ = V(), [P, S] = ge(
    q,
    l ?? NaN,
    NaN
  ), A = (G) => {
    S(G), x == null || x(Number.isNaN(G) ? void 0 : G);
  }, z = Ln({
    formatOptions: u,
    isDisabled: a,
    isInvalid: o,
    locale: ft($),
    minValue: _,
    maxValue: m,
    onBlur: y,
    onChange: A,
    onFocus: k,
    placeholder: v,
    step: F,
    value: P
  }), L = B(null);
  pe(d, () => L.current);
  const { inputProps: T } = Sn(
    {
      "aria-label": e,
      "aria-labelledby": t,
      "aria-describedby": i,
      formatOptions: u,
      id: h,
      isDisabled: a,
      isInvalid: o,
      isReadOnly: R,
      minValue: _,
      maxValue: m,
      onBlur: y,
      onChange: A,
      onFocus: k,
      onInput: I,
      onKeyDown: w,
      placeholder: v,
      step: F,
      value: P
    },
    z,
    L
  );
  return /* @__PURE__ */ b(ie, { children: [
    /* @__PURE__ */ n(
      "input",
      {
        ...N,
        ...T,
        maxLength: f ?? T.maxLength,
        inputMode: c ?? T.inputMode,
        "aria-required": r,
        ref: L,
        className: g(
          Ee.input,
          o && Ee["input--invalid"],
          s
        )
      }
    ),
    /* @__PURE__ */ n(E, { when: p, children: /* @__PURE__ */ n(
      "input",
      {
        type: "hidden",
        name: p,
        value: isNaN(z.numberValue) ? "" : z.numberValue
      }
    ) })
  ] });
}
function $c(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) == null ? void 0 : t.brands.some(
    (i) => e.test(i.brand)
  )) || e.test(window.navigator.userAgent);
}
function Ec(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(
    ((t = window.navigator.userAgentData) == null ? void 0 : t.platform) || window.navigator.platform
  ) : !1;
}
function pi(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
const Mc = pi(function() {
  return Ec(/^iPhone/i);
}), Fc = pi(function() {
  return $c(/Android/i);
});
function Dc({
  className: e,
  defaultValue: t,
  formatOptions: i,
  inputRef: r,
  invalid: s,
  max: l,
  min: a,
  name: u,
  onChange: h,
  onKeyDown: o,
  readOnly: c,
  step: d = 1,
  value: _,
  ...m
}) {
  const [f, p] = ge(
    _,
    t ?? NaN,
    NaN
  ), y = B(null);
  pe(r, () => y.current);
  const x = (N) => {
    N.floatValue !== f && (p(N.floatValue), h == null || h(Number.isNaN(N.floatValue) ? void 0 : N.floatValue));
  }, k = (N) => {
    var $;
    if (N.key === "ArrowUp" || N.key === "PageUp" || N.key === "ArrowDown" || N.key === "PageDown") {
      N.preventDefault();
      const P = N.key === "ArrowUp" || N.key === "PageUp" ? d : -d;
      let S = (f ?? 0) + P;
      typeof l == "number" && S > l && (S = Math.min(l, S)), typeof a == "number" && S < a && (S = Math.max(a, S)), Number.isNaN(S) && (S = a ?? 0), S !== f && x({ floatValue: S });
    }
    N.key === "Home" && typeof a == "number" && !Number.isNaN(a) && (N.preventDefault(), f !== a && x({ floatValue: a })), N.key === "End" && typeof l == "number" && !Number.isNaN(l) && (N.preventDefault(), f !== l && x({ floatValue: l })), N.isDefaultPrevented() && (($ = y.current) == null || $.setSelectionRange(
      y.current.value.length,
      y.current.value.length
    )), o == null || o(N);
  }, I = V();
  let w = I === "sv" ? " " : ",", v = I === "sv" ? "," : ".", R = (i == null ? void 0 : i.maximumFractionDigits) ?? 0;
  const F = a === void 0 || isNaN(a) || a < 0;
  (i == null ? void 0 : i.useGrouping) === !1 && (w = "");
  const q = typeof f < "u" && !Number.isNaN(f) ? String(f).replace("-", "−") : I === "sv" ? "Tomt" : "Empty";
  return W(() => {
    y.current === document.activeElement && (Ar("assertive"), Tn(q, "assertive"));
  }, [q]), /* @__PURE__ */ b(ie, { children: [
    /* @__PURE__ */ n(
      Or,
      {
        autoComplete: "off",
        autoCorrect: "off",
        spellCheck: !1,
        ...m,
        allowNegative: F,
        inputMode: m.inputMode ?? Bc(a, i),
        "aria-readonly": c,
        readOnly: c,
        getInputRef: y,
        onValueChange: x,
        onKeyDown: k,
        thousandSeparator: w,
        decimalSeparator: v,
        decimalScale: R,
        value: f,
        className: g(
          Ee.input,
          s && Ee["input--invalid"],
          e
        )
      }
    ),
    /* @__PURE__ */ n(E, { when: u, children: /* @__PURE__ */ n(
      "input",
      {
        type: "hidden",
        name: u,
        value: Number.isNaN(f) ? "" : f
      }
    ) })
  ] });
}
function Bc(e, t) {
  let i = "numeric";
  const r = e === void 0 || isNaN(e) || e < 0, s = ((t == null ? void 0 : t.maximumFractionDigits) ?? 0) > 0;
  return Mc() ? r ? i = "text" : s && (i = "decimal") : Fc() && (r ? i = "numeric" : s && (i = "decimal")), i;
}
const qc = /* @__PURE__ */ C(
  function({ behavior: t = "onBlur", ...i }, r) {
    return t === "onBlur" ? /* @__PURE__ */ n(zc, { ...i, inputRef: r }) : /* @__PURE__ */ n(Dc, { ...i, inputRef: r });
  }
), Pt = {
  "input-group": "_input-group_s9m9j_1",
  "input-group__label": "_input-group__label_s9m9j_10",
  "input-group--disabled": "_input-group--disabled_s9m9j_28"
};
function gi({
  children: e,
  className: t,
  disabled: i = !1,
  // Prevent block prop from ending up as an attribute on underlying element
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  block: r,
  ...s
}) {
  return /* @__PURE__ */ n(
    "div",
    {
      className: g(
        Pt["input-group"],
        i && Pt["input-group--disabled"],
        t
      ),
      ...s,
      children: e
    }
  );
}
function ut({ className: e, ...t }) {
  return /* @__PURE__ */ n(
    "div",
    {
      "aria-hidden": !0,
      ...t,
      className: g(Pt["input-group__label"], e)
    }
  );
}
const Ac = "_root_1fqca_16", Lc = {
  root: Ac
}, Tc = ({
  as: e,
  className: t,
  children: i,
  ref: r,
  ...s
}) => {
  const l = e || "ul", a = g(t, Lc.root);
  return $t(
    l,
    {
      ref: r,
      className: a,
      ...s
    },
    i
  );
}, Vc = ({
  className: e,
  children: t,
  ...i
}) => /* @__PURE__ */ n("li", { className: e, ...i, children: t });
function xn({
  className: e,
  items: t,
  renderItem: i,
  keyExtractor: r = (c, d) => (c == null ? void 0 : c.key) || (c == null ? void 0 : c.id) || d,
  ref: s,
  gap: l = ".5rem",
  "sm-gap": a,
  "md-gap": u,
  "lg-gap": h,
  ...o
}) {
  return /* @__PURE__ */ n(
    M,
    {
      direction: "column",
      gap: l,
      "sm-gap": a,
      "md-gap": u,
      "lg-gap": h,
      asChild: !0,
      children: /* @__PURE__ */ n(Tc, { ref: s, className: e, ...o, children: t.map((c, d) => {
        const _ = i(c, d);
        return _ ? /* @__PURE__ */ n(Vc, { children: _ }, r(c, d)) : null;
      }) })
    }
  );
}
((e) => {
  e.Button = jc, e.Link = Oc;
})(xn || (xn = {}));
function jc(e) {
  return /* @__PURE__ */ n(ct, { ...e, "data-sbui-listitembutton": !0 });
}
function Oc(e) {
  return /* @__PURE__ */ n(yc, { ...e, "data-sbui-listitemlink": !0 });
}
const Wc = ({
  highlighted: e,
  ...t
}) => {
  const i = V();
  let r;
  return e && (typeof e == "string" ? r = e : r = i === "sv" ? "Detta listobjekt är visuellt framhävt." : "This item is visually highlighted."), /* @__PURE__ */ n(
    "svg",
    {
      ...t,
      width: 24,
      height: 24,
      fill: "none",
      role: "presentation",
      "aria-roledescription": i === "sv" ? "Statusindikator" : "Status indicator",
      viewBox: "0 0 24 24",
      "aria-label": r,
      visibility: e ? "visible" : "hidden",
      children: /* @__PURE__ */ n("circle", { cx: "12", cy: "12", r: "4", fill: U("color-accent") })
    }
  );
}, Hc = ({
  children: e,
  className: t,
  ...i
}) => /* @__PURE__ */ n(
  M,
  {
    as: "span",
    "md-justify": "center",
    direction: "column",
    className: t,
    minWidth: 0,
    ...i,
    children: e
  }
), Gc = ({
  className: e,
  children: t,
  truncate: i
}) => /* @__PURE__ */ n(
  H,
  {
    as: "span",
    size: "03",
    weight: "display",
    className: e,
    truncate: i,
    children: t
  }
), Uc = ({ className: e, children: t }) => /* @__PURE__ */ n(
  H,
  {
    as: "span",
    size: "02",
    weight: "regular",
    style: {
      color: U("color-muted")
    },
    className: e,
    children: t
  }
), Yc = ({
  children: e,
  className: t,
  ...i
}) => /* @__PURE__ */ n(M, { as: "span", direction: "column", className: t, ...i, children: e }), Kc = ({ className: e, children: t }) => /* @__PURE__ */ n(H, { as: "span", size: "03", weight: "regular", className: e, children: t }), Qc = ({ className: e, children: t }) => /* @__PURE__ */ n(
  H,
  {
    as: "span",
    size: "02",
    style: {
      color: U("color-muted")
    },
    weight: "regular",
    className: e,
    children: t
  }
), Xc = ({
  children: e,
  ...t
}) => /* @__PURE__ */ n(M, { as: "span", ...t, children: e }), Zc = ({
  children: e,
  ...t
}) => /* @__PURE__ */ n(M, { as: "span", ...t, children: e }), Jc = "_layout_1t6fd_39", ed = "_secondary_1t6fd_67", td = "_decorationBackground_1t6fd_76", nd = "_leadingDecoration_1t6fd_81", st = {
  layout: Jc,
  secondary: ed,
  decorationBackground: td,
  leadingDecoration: nd
};
function St({
  className: e,
  highlighted: t,
  leadingDecoration: i,
  primary: r,
  secondary: s,
  trailingDecoration: l,
  ...a
}) {
  const u = !!i, h = (r == null ? void 0 : r.truncate) === "text";
  return /* @__PURE__ */ b(
    M,
    {
      ...a,
      "data-sbui-elevated": !0,
      "md-align": "center",
      className: g(st.layout, e),
      gap: "1rem",
      p: "1rem",
      wrap: "wrap",
      children: [
        /* @__PURE__ */ n(E, { when: u, children: /* @__PURE__ */ n(
          Xc,
          {
            className: st.leadingDecoration,
            flexShrink: 0,
            children: i
          }
        ) }),
        /* @__PURE__ */ b(
          M,
          {
            as: "span",
            direction: "column",
            "md-direction": "row",
            justify: "center",
            "md-justify": "space-between",
            "md-gap": "1rem",
            flex: 1,
            minWidth: h ? "5rem" : void 0,
            children: [
              /* @__PURE__ */ n(E, { when: r, children: /* @__PURE__ */ b(Hc, { children: [
                /* @__PURE__ */ n(E, { when: r == null ? void 0 : r.meta, children: /* @__PURE__ */ n(Uc, { children: r == null ? void 0 : r.meta }) }),
                /* @__PURE__ */ n(E, { when: r == null ? void 0 : r.text, children: /* @__PURE__ */ n(Gc, { truncate: h, children: r == null ? void 0 : r.text }) })
              ] }) }),
              !!s && (Oi.isValidElement(s) ? /* @__PURE__ */ n(M, { as: "span", mt: ".5rem", "md-mt": "0", align: "center", children: s }) : /* @__PURE__ */ b(Yc, { className: st.secondary, children: [
                "meta" in s && /* @__PURE__ */ n(Qc, { children: s.meta }),
                "text" in s && /* @__PURE__ */ n(Kc, { children: s.text })
              ] }))
            ]
          }
        ),
        /* @__PURE__ */ b(
          M,
          {
            align: u ? "flex-start" : "center",
            height: u ? "3rem" : void 0,
            children: [
              /* @__PURE__ */ n(ce, { asChild: !0, alignSelf: "center", flexShrink: 0, children: /* @__PURE__ */ n(Wc, { highlighted: t }) }),
              /* @__PURE__ */ n(E, { when: l, children: /* @__PURE__ */ n(Zc, { alignSelf: "center", flexShrink: 0, children: l }) })
            ]
          }
        )
      ]
    }
  );
}
((e) => {
  e.DecorationBackground = id;
})(St || (St = {}));
function id({
  children: e,
  className: t
}) {
  return /* @__PURE__ */ n("div", { className: g(st.decorationBackground, t), children: e });
}
const rd = "_skeleton_1b9ws_15", sd = {
  skeleton: rd
}, od = parseFloat(Gi) >= 19 || "";
function it({
  children: e,
  loading: t = !0,
  ...i
}) {
  if (!t) return e;
  const { className: r, ...s } = Ze(
    i,
    jn,
    Bt
  ), l = Hi(e);
  return /* @__PURE__ */ n(
    l ? re : "span",
    {
      "aria-hidden": !0,
      inert: od,
      className: g(sd.skeleton, r),
      "data-skeleton-inline": l ? void 0 : !0,
      tabIndex: -1,
      ...s,
      children: e
    }
  );
}
function __({
  className: e
}) {
  return /* @__PURE__ */ n(
    St,
    {
      className: e,
      leadingDecoration: /* @__PURE__ */ n(it, { size: "3rem" }),
      trailingDecoration: /* @__PURE__ */ n(it, { size: "1.5rem" }),
      primary: {
        meta: /* @__PURE__ */ n(it, { children: "Primary meta" }),
        text: /* @__PURE__ */ n(it, { children: "This is the primary text" })
      }
    }
  );
}
function ad({
  "aria-label": e,
  behavior: t,
  defaultValue: i,
  disabled: r,
  formatOptions: s,
  inputMode: l,
  inputProps: a,
  label: u,
  maxLength: h,
  min: o,
  max: c,
  name: d,
  onBlur: _,
  onChange: m,
  onFocus: f,
  onKeyDown: p,
  prefix: y,
  prefixAriaLabel: x,
  readOnly: k,
  step: I,
  suffix: w,
  suffixAriaLabel: v,
  value: R,
  ...F
}, q) {
  let N = {}, $ = _t;
  (y || w) && (N = { disabled: r }, $ = gi);
  let P = u;
  return u && (x || v) && (P = /* @__PURE__ */ b(ie, { children: [
    u,
    /* @__PURE__ */ n(E, { when: x, children: /* @__PURE__ */ n(he, { children: x }) }),
    /* @__PURE__ */ n(E, { when: v, children: /* @__PURE__ */ n(he, { children: v }) })
  ] })), /* @__PURE__ */ n(de, { ...F, label: P, children: (S, A) => /* @__PURE__ */ b($, { ...N, children: [
    /* @__PURE__ */ n(E, { when: y, children: /* @__PURE__ */ n(ut, { children: y }) }),
    /* @__PURE__ */ n(
      qc,
      {
        ...a,
        ...S,
        behavior: t,
        ref: q,
        "aria-label": e,
        invalid: A.isInvalid,
        defaultValue: i,
        disabled: r,
        formatOptions: s,
        inputMode: l,
        maxLength: h,
        min: o,
        max: c,
        name: d,
        onBlur: _,
        onChange: m,
        onFocus: f,
        onKeyDown: p,
        readOnly: k,
        step: I,
        value: R
      }
    ),
    /* @__PURE__ */ n(E, { when: w, children: /* @__PURE__ */ n(ut, { children: w }) })
  ] }) });
}
const m_ = /* @__PURE__ */ C(
  ad
), ld = "_group_mauv6_1", cd = "_button_mauv6_19", dd = "_input_mauv6_53", zt = {
  group: ld,
  button: cd,
  input: dd
};
function wn(e) {
  const t = B(null), { buttonProps: i } = Et(e, t);
  return /* @__PURE__ */ n("button", { ...i, ref: t, className: zt.button, children: e.children });
}
const h_ = /* @__PURE__ */ C(
  function({
    "aria-label": t,
    "aria-labelledby": i,
    "aria-describedby": r,
    "aria-required": s,
    decrementAriaLabel: l,
    defaultValue: a,
    description: u,
    descriptionProps: h = {},
    disabled: o,
    incrementAriaLabel: c,
    inputClassName: d,
    inputMode: _,
    inputProps: m,
    inputRef: f,
    label: p,
    labelProps: y = {},
    maxLength: x,
    max: k,
    min: I,
    message: w,
    messageProps: v,
    messageTone: R,
    name: F,
    validationError: q,
    validationErrorProps: N,
    onBlur: $,
    onChange: P,
    onFocus: S,
    readOnly: A,
    step: z,
    value: L,
    ...T
  }, G) {
    const [ue, J] = ge(
      L,
      a ?? NaN,
      NaN
    ), be = !!(q || R === "critical"), Y = {
      "aria-label": p ? void 0 : t,
      "aria-labelledby": p ? void 0 : i,
      "aria-describedby": u ? void 0 : r,
      minValue: I,
      maxValue: k,
      label: p,
      description: u,
      isDisabled: o,
      isReadOnly: A,
      onBlur: $,
      onChange(Ve) {
        J(Ve), P == null || P(Number.isNaN(Ve) ? void 0 : Ve);
      },
      onFocus: S,
      defaultValue: a === null ? NaN : a,
      step: z,
      value: ue,
      id: T.id
    }, te = V(), j = Ln({
      ...Y,
      isInvalid: be,
      locale: ft(te)
    }), O = B(null);
    pe(f, () => O.current);
    const {
      groupProps: ne,
      labelProps: _e,
      descriptionProps: Pe,
      inputProps: K,
      incrementButtonProps: et,
      decrementButtonProps: Te
    } = Sn(Y, j, O);
    return l && (Te["aria-label"] = l), c && (et["aria-label"] = c), /* @__PURE__ */ n(
      de,
      {
        ...T,
        "aria-required": s,
        label: p,
        labelProps: { ...y, ..._e },
        labelId: _e.id,
        description: u,
        descriptionProps: { ...h, ...Pe },
        descriptionId: Pe.id,
        message: w,
        messageProps: v,
        messageTone: R,
        validationError: q,
        validationErrorProps: N,
        ref: G,
        children: (Ve) => /* @__PURE__ */ b(ie, { children: [
          /* @__PURE__ */ b("div", { ...ne, className: zt.group, children: [
            /* @__PURE__ */ n(wn, { ...Te, children: /* @__PURE__ */ n("svg", { viewBox: "0 0 24 24", width: "24", height: "24", "aria-hidden": !0, children: /* @__PURE__ */ n(
              "rect",
              {
                fill: "currentColor",
                x: "5",
                y: "11",
                width: "14",
                height: "2"
              }
            ) }) }),
            /* @__PURE__ */ n(
              "input",
              {
                ...K,
                ...m,
                ...Ve,
                maxLength: x,
                inputMode: _ ?? (K == null ? void 0 : K.inputMode),
                id: K.id,
                ref: O,
                className: g(zt.input, d)
              }
            ),
            /* @__PURE__ */ n(wn, { ...et, children: /* @__PURE__ */ b("svg", { viewBox: "0 0 24 24", width: "24", height: "24", "aria-hidden": !0, children: [
              /* @__PURE__ */ n(
                "rect",
                {
                  fill: "currentColor",
                  x: "5",
                  y: "11",
                  width: "14",
                  height: "2"
                }
              ),
              /* @__PURE__ */ n(
                "rect",
                {
                  fill: "currentColor",
                  x: "11",
                  y: "5",
                  width: "2",
                  height: "14"
                }
              )
            ] }) })
          ] }),
          F && /* @__PURE__ */ n(
            "input",
            {
              type: "hidden",
              name: F,
              value: isNaN(j.numberValue) ? "" : j.numberValue
            }
          )
        ] })
      }
    );
  }
), Ae = {
  "qr-code": "_qr-code_1iesq_1",
  "qr-code__box": "_qr-code__box_1iesq_5",
  "qr-code__button": "_qr-code__button_1iesq_9",
  "qr-code__button--hide-cursor": "_qr-code__button--hide-cursor_1iesq_21",
  "qr-code__svg": "_qr-code__svg_1iesq_24",
  "fullscreen-container": "_fullscreen-container_1iesq_29"
};
function ud(e, t) {
  const i = B(void 0), r = () => {
    window.clearTimeout(i.current);
  }, s = () => {
    r(), i.current = window.setTimeout(e, t);
  };
  return s.cancel = r, s;
}
function _d(e) {
  const t = le(() => document.fullscreenElement !== null && document.fullscreenElement === e.current, [e]), [i, r] = Q(!1), s = () => {
    var l;
    t() ? document.exitFullscreen() : (l = e.current) == null || l.requestFullscreen();
  };
  return W(() => {
    const l = e.current, a = () => {
      r(t());
    };
    return l == null || l.addEventListener("fullscreenchange", a), () => {
      l && l.removeEventListener(
        "fullscreenchange",
        a
      );
    };
  }, [t, e]), { isFullscreen: i, toggleFullscreen: s };
}
function md(e) {
  const [t, i] = Q(!1);
  return W(() => {
    const r = e.current, s = new IntersectionObserver(
      (l) => {
        for (const a of l)
          i(a.isIntersecting);
      },
      { threshold: 1 }
    );
    return r && s.observe(r), () => {
      r && s.unobserve(r);
    };
  }, [e]), t;
}
var Me;
((e) => {
  const a = class a {
    /*-- Constructor (low level) and fields --*/
    // Creates a new QR Code with the given version number,
    // error correction level, data codeword bytes, and mask number.
    // This is a low-level API that most users should not use directly.
    // A mid-level API is the encodeSegments() function.
    constructor(o, c, d, _) {
      if (this.version = o, this.errorCorrectionLevel = c, this.modules = [], this.isFunction = [], o < a.MIN_VERSION || o > a.MAX_VERSION)
        throw new RangeError("Version value out of range");
      if (_ < -1 || _ > 7) throw new RangeError("Mask value out of range");
      this.size = o * 4 + 17;
      let m = [];
      for (let p = 0; p < this.size; p++) m.push(!1);
      for (let p = 0; p < this.size; p++)
        this.modules.push(m.slice()), this.isFunction.push(m.slice());
      this.drawFunctionPatterns();
      const f = this.addEccAndInterleave(d);
      if (this.drawCodewords(f), _ == -1) {
        let p = 1e9;
        for (let y = 0; y < 8; y++) {
          this.applyMask(y), this.drawFormatBits(y);
          const x = this.getPenaltyScore();
          x < p && (_ = y, p = x), this.applyMask(y);
        }
      }
      s(0 <= _ && _ <= 7), this.mask = _, this.applyMask(_), this.drawFormatBits(_), this.isFunction = [];
    }
    /*-- Static factory functions (high level) --*/
    // Returns a QR Code representing the given Unicode text string at the given error correction level.
    // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
    // Unicode code points (not UTF-16 code units) if the low error correction level is used. The smallest possible
    // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
    // ecl argument if it can be done without increasing the version.
    static encodeText(o, c) {
      const d = e.QrSegment.makeSegments(o);
      return a.encodeSegments(d, c);
    }
    // Returns a QR Code representing the given binary data at the given error correction level.
    // This function always encodes using the binary segment mode, not any text mode. The maximum number of
    // bytes allowed is 2953. The smallest possible QR Code version is automatically chosen for the output.
    // The ECC level of the result may be higher than the ecl argument if it can be done without increasing the version.
    static encodeBinary(o, c) {
      const d = e.QrSegment.makeBytes(o);
      return a.encodeSegments([d], c);
    }
    /*-- Static factory functions (mid level) --*/
    // Returns a QR Code representing the given segments with the given encoding parameters.
    // The smallest possible QR Code version within the given range is automatically
    // chosen for the output. Iff boostEcl is true, then the ECC level of the result
    // may be higher than the ecl argument if it can be done without increasing the
    // version. The mask number is either between 0 to 7 (inclusive) to force that
    // mask, or -1 to automatically choose an appropriate mask (which may be slow).
    // This function allows the user to create a custom sequence of segments that switches
    // between modes (such as alphanumeric and byte) to encode text in less space.
    // This is a mid-level API; the high-level API is encodeText() and encodeBinary().
    static encodeSegments(o, c, d = 1, _ = 40, m = -1, f = !0) {
      if (!(a.MIN_VERSION <= d && d <= _ && _ <= a.MAX_VERSION) || m < -1 || m > 7)
        throw new RangeError("Invalid value");
      let p, y;
      for (p = d; ; p++) {
        const w = a.getNumDataCodewords(p, c) * 8, v = l.getTotalBits(o, p);
        if (v <= w) {
          y = v;
          break;
        }
        if (p >= _)
          throw new RangeError("Data too long");
      }
      for (const w of [
        a.Ecc.MEDIUM,
        a.Ecc.QUARTILE,
        a.Ecc.HIGH
      ])
        f && y <= a.getNumDataCodewords(p, w) * 8 && (c = w);
      let x = [];
      for (const w of o) {
        i(w.mode.modeBits, 4, x), i(w.numChars, w.mode.numCharCountBits(p), x);
        for (const v of w.getData()) x.push(v);
      }
      s(x.length == y);
      const k = a.getNumDataCodewords(p, c) * 8;
      s(x.length <= k), i(0, Math.min(4, k - x.length), x), i(0, (8 - x.length % 8) % 8, x), s(x.length % 8 == 0);
      for (let w = 236; x.length < k; w ^= 253)
        i(w, 8, x);
      let I = [];
      for (; I.length * 8 < x.length; ) I.push(0);
      return x.forEach(
        (w, v) => I[v >>> 3] |= w << 7 - (v & 7)
      ), new a(p, c, I, m);
    }
    /*-- Accessor methods --*/
    // Returns the color of the module (pixel) at the given coordinates, which is false
    // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
    // If the given coordinates are out of bounds, then false (light) is returned.
    getModule(o, c) {
      return 0 <= o && o < this.size && 0 <= c && c < this.size && this.modules[c][o];
    }
    /*-- Private helper methods for constructor: Drawing function modules --*/
    // Reads this object's version field, and draws and marks all function modules.
    drawFunctionPatterns() {
      for (let d = 0; d < this.size; d++)
        this.setFunctionModule(6, d, d % 2 == 0), this.setFunctionModule(d, 6, d % 2 == 0);
      this.drawFinderPattern(3, 3), this.drawFinderPattern(this.size - 4, 3), this.drawFinderPattern(3, this.size - 4);
      const o = this.getAlignmentPatternPositions(), c = o.length;
      for (let d = 0; d < c; d++)
        for (let _ = 0; _ < c; _++)
          d == 0 && _ == 0 || d == 0 && _ == c - 1 || d == c - 1 && _ == 0 || this.drawAlignmentPattern(o[d], o[_]);
      this.drawFormatBits(0), this.drawVersion();
    }
    // Draws two copies of the format bits (with its own error correction code)
    // based on the given mask and this object's error correction level field.
    drawFormatBits(o) {
      const c = this.errorCorrectionLevel.formatBits << 3 | o;
      let d = c;
      for (let m = 0; m < 10; m++) d = d << 1 ^ (d >>> 9) * 1335;
      const _ = (c << 10 | d) ^ 21522;
      s(_ >>> 15 == 0);
      for (let m = 0; m <= 5; m++)
        this.setFunctionModule(8, m, r(_, m));
      this.setFunctionModule(8, 7, r(_, 6)), this.setFunctionModule(8, 8, r(_, 7)), this.setFunctionModule(7, 8, r(_, 8));
      for (let m = 9; m < 15; m++)
        this.setFunctionModule(14 - m, 8, r(_, m));
      for (let m = 0; m < 8; m++)
        this.setFunctionModule(this.size - 1 - m, 8, r(_, m));
      for (let m = 8; m < 15; m++)
        this.setFunctionModule(8, this.size - 15 + m, r(_, m));
      this.setFunctionModule(8, this.size - 8, !0);
    }
    // Draws two copies of the version bits (with its own error correction code),
    // based on this object's version field, iff 7 <= version <= 40.
    drawVersion() {
      if (this.version < 7) return;
      let o = this.version;
      for (let d = 0; d < 12; d++) o = o << 1 ^ (o >>> 11) * 7973;
      const c = this.version << 12 | o;
      s(c >>> 18 == 0);
      for (let d = 0; d < 18; d++) {
        const _ = r(c, d), m = this.size - 11 + d % 3, f = Math.floor(d / 3);
        this.setFunctionModule(m, f, _), this.setFunctionModule(f, m, _);
      }
    }
    // Draws a 9*9 finder pattern including the border separator,
    // with the center module at (x, y). Modules can be out of bounds.
    drawFinderPattern(o, c) {
      for (let d = -4; d <= 4; d++)
        for (let _ = -4; _ <= 4; _++) {
          const m = Math.max(Math.abs(_), Math.abs(d)), f = o + _, p = c + d;
          0 <= f && f < this.size && 0 <= p && p < this.size && this.setFunctionModule(f, p, m != 2 && m != 4);
        }
    }
    // Draws a 5*5 alignment pattern, with the center module
    // at (x, y). All modules must be in bounds.
    drawAlignmentPattern(o, c) {
      for (let d = -2; d <= 2; d++)
        for (let _ = -2; _ <= 2; _++)
          this.setFunctionModule(
            o + _,
            c + d,
            Math.max(Math.abs(_), Math.abs(d)) != 1
          );
    }
    // Sets the color of a module and marks it as a function module.
    // Only used by the constructor. Coordinates must be in bounds.
    setFunctionModule(o, c, d) {
      this.modules[c][o] = d, this.isFunction[c][o] = !0;
    }
    /*-- Private helper methods for constructor: Codewords and masking --*/
    // Returns a new byte string representing the given data with the appropriate error correction
    // codewords appended to it, based on this object's version and error correction level.
    addEccAndInterleave(o) {
      const c = this.version, d = this.errorCorrectionLevel;
      if (o.length != a.getNumDataCodewords(c, d))
        throw new RangeError("Invalid argument");
      const _ = a.NUM_ERROR_CORRECTION_BLOCKS[d.ordinal][c], m = a.ECC_CODEWORDS_PER_BLOCK[d.ordinal][c], f = Math.floor(
        a.getNumRawDataModules(c) / 8
      ), p = _ - f % _, y = Math.floor(f / _);
      let x = [];
      const k = a.reedSolomonComputeDivisor(m);
      for (let w = 0, v = 0; w < _; w++) {
        let R = o.slice(
          v,
          v + y - m + (w < p ? 0 : 1)
        );
        v += R.length;
        const F = a.reedSolomonComputeRemainder(R, k);
        w < p && R.push(0), x.push(R.concat(F));
      }
      let I = [];
      for (let w = 0; w < x[0].length; w++)
        x.forEach((v, R) => {
          (w != y - m || R >= p) && I.push(v[w]);
        });
      return s(I.length == f), I;
    }
    // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
    // data area of this QR Code. Function modules need to be marked off before this is called.
    drawCodewords(o) {
      if (o.length != Math.floor(a.getNumRawDataModules(this.version) / 8))
        throw new RangeError("Invalid argument");
      let c = 0;
      for (let d = this.size - 1; d >= 1; d -= 2) {
        d == 6 && (d = 5);
        for (let _ = 0; _ < this.size; _++)
          for (let m = 0; m < 2; m++) {
            const f = d - m, y = (d + 1 & 2) == 0 ? this.size - 1 - _ : _;
            !this.isFunction[y][f] && c < o.length * 8 && (this.modules[y][f] = r(o[c >>> 3], 7 - (c & 7)), c++);
          }
      }
      s(c == o.length * 8);
    }
    // XORs the codeword modules in this QR Code with the given mask pattern.
    // The function modules must be marked and the codeword bits must be drawn
    // before masking. Due to the arithmetic of XOR, calling applyMask() with
    // the same mask value a second time will undo the mask. A final well-formed
    // QR Code needs exactly one (not zero, two, etc.) mask applied.
    applyMask(o) {
      if (o < 0 || o > 7) throw new RangeError("Mask value out of range");
      for (let c = 0; c < this.size; c++)
        for (let d = 0; d < this.size; d++) {
          let _;
          switch (o) {
            case 0:
              _ = (d + c) % 2 == 0;
              break;
            case 1:
              _ = c % 2 == 0;
              break;
            case 2:
              _ = d % 3 == 0;
              break;
            case 3:
              _ = (d + c) % 3 == 0;
              break;
            case 4:
              _ = (Math.floor(d / 3) + Math.floor(c / 2)) % 2 == 0;
              break;
            case 5:
              _ = d * c % 2 + d * c % 3 == 0;
              break;
            case 6:
              _ = (d * c % 2 + d * c % 3) % 2 == 0;
              break;
            case 7:
              _ = ((d + c) % 2 + d * c % 3) % 2 == 0;
              break;
            default:
              throw new Error("Unreachable");
          }
          !this.isFunction[c][d] && _ && (this.modules[c][d] = !this.modules[c][d]);
        }
    }
    // Calculates and returns the penalty score based on state of this QR Code's current modules.
    // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
    getPenaltyScore() {
      let o = 0;
      for (let m = 0; m < this.size; m++) {
        let f = !1, p = 0, y = [0, 0, 0, 0, 0, 0, 0];
        for (let x = 0; x < this.size; x++)
          this.modules[m][x] == f ? (p++, p == 5 ? o += a.PENALTY_N1 : p > 5 && o++) : (this.finderPenaltyAddHistory(p, y), f || (o += this.finderPenaltyCountPatterns(y) * a.PENALTY_N3), f = this.modules[m][x], p = 1);
        o += this.finderPenaltyTerminateAndCount(f, p, y) * a.PENALTY_N3;
      }
      for (let m = 0; m < this.size; m++) {
        let f = !1, p = 0, y = [0, 0, 0, 0, 0, 0, 0];
        for (let x = 0; x < this.size; x++)
          this.modules[x][m] == f ? (p++, p == 5 ? o += a.PENALTY_N1 : p > 5 && o++) : (this.finderPenaltyAddHistory(p, y), f || (o += this.finderPenaltyCountPatterns(y) * a.PENALTY_N3), f = this.modules[x][m], p = 1);
        o += this.finderPenaltyTerminateAndCount(f, p, y) * a.PENALTY_N3;
      }
      for (let m = 0; m < this.size - 1; m++)
        for (let f = 0; f < this.size - 1; f++) {
          const p = this.modules[m][f];
          p == this.modules[m][f + 1] && p == this.modules[m + 1][f] && p == this.modules[m + 1][f + 1] && (o += a.PENALTY_N2);
        }
      let c = 0;
      for (const m of this.modules)
        c = m.reduce((f, p) => f + (p ? 1 : 0), c);
      const d = this.size * this.size, _ = Math.ceil(Math.abs(c * 20 - d * 10) / d) - 1;
      return s(0 <= _ && _ <= 9), o += _ * a.PENALTY_N4, s(0 <= o && o <= 2568888), o;
    }
    /*-- Private helper functions --*/
    // Returns an ascending list of positions of alignment patterns for this version number.
    // Each position is in the range [0,177), and are used on both the x and y axes.
    // This could be implemented as lookup table of 40 variable-length lists of integers.
    getAlignmentPatternPositions() {
      if (this.version == 1) return [];
      {
        const o = Math.floor(this.version / 7) + 2, c = Math.floor(
          (this.version * 8 + o * 3 + 5) / (o * 4 - 4)
        ) * 2;
        let d = [6];
        for (let _ = this.size - 7; d.length < o; _ -= c)
          d.splice(1, 0, _);
        return d;
      }
    }
    // Returns the number of data bits that can be stored in a QR Code of the given version number, after
    // all function modules are excluded. This includes remainder bits, so it might not be a multiple of 8.
    // The result is in the range [208, 29648]. This could be implemented as a 40-entry lookup table.
    static getNumRawDataModules(o) {
      if (o < a.MIN_VERSION || o > a.MAX_VERSION)
        throw new RangeError("Version number out of range");
      let c = (16 * o + 128) * o + 64;
      if (o >= 2) {
        const d = Math.floor(o / 7) + 2;
        c -= (25 * d - 10) * d - 55, o >= 7 && (c -= 36);
      }
      return s(208 <= c && c <= 29648), c;
    }
    // Returns the number of 8-bit data (i.e. not error correction) codewords contained in any
    // QR Code of the given version number and error correction level, with remainder bits discarded.
    // This stateless pure function could be implemented as a (40*4)-cell lookup table.
    static getNumDataCodewords(o, c) {
      return Math.floor(a.getNumRawDataModules(o) / 8) - a.ECC_CODEWORDS_PER_BLOCK[c.ordinal][o] * a.NUM_ERROR_CORRECTION_BLOCKS[c.ordinal][o];
    }
    // Returns a Reed-Solomon ECC generator polynomial for the given degree. This could be
    // implemented as a lookup table over all possible parameter values, instead of as an algorithm.
    static reedSolomonComputeDivisor(o) {
      if (o < 1 || o > 255)
        throw new RangeError("Degree out of range");
      let c = [];
      for (let _ = 0; _ < o - 1; _++) c.push(0);
      c.push(1);
      let d = 1;
      for (let _ = 0; _ < o; _++) {
        for (let m = 0; m < c.length; m++)
          c[m] = a.reedSolomonMultiply(c[m], d), m + 1 < c.length && (c[m] ^= c[m + 1]);
        d = a.reedSolomonMultiply(d, 2);
      }
      return c;
    }
    // Returns the Reed-Solomon error correction codeword for the given data and divisor polynomials.
    static reedSolomonComputeRemainder(o, c) {
      let d = c.map((_) => 0);
      for (const _ of o) {
        const m = _ ^ d.shift();
        d.push(0), c.forEach(
          (f, p) => d[p] ^= a.reedSolomonMultiply(f, m)
        );
      }
      return d;
    }
    // Returns the product of the two given field elements modulo GF(2^8/0x11D). The arguments and result
    // are unsigned 8-bit integers. This could be implemented as a lookup table of 256*256 entries of uint8.
    static reedSolomonMultiply(o, c) {
      if (o >>> 8 || c >>> 8)
        throw new RangeError("Byte out of range");
      let d = 0;
      for (let _ = 7; _ >= 0; _--)
        d = d << 1 ^ (d >>> 7) * 285, d ^= (c >>> _ & 1) * o;
      return s(d >>> 8 == 0), d;
    }
    // Can only be called immediately after a light run is added, and
    // returns either 0, 1, or 2. A helper function for getPenaltyScore().
    finderPenaltyCountPatterns(o) {
      const c = o[1];
      s(c <= this.size * 3);
      const d = c > 0 && o[2] == c && o[3] == c * 3 && o[4] == c && o[5] == c;
      return (d && o[0] >= c * 4 && o[6] >= c ? 1 : 0) + (d && o[6] >= c * 4 && o[0] >= c ? 1 : 0);
    }
    // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
    finderPenaltyTerminateAndCount(o, c, d) {
      return o && (this.finderPenaltyAddHistory(c, d), c = 0), c += this.size, this.finderPenaltyAddHistory(c, d), this.finderPenaltyCountPatterns(d);
    }
    // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
    finderPenaltyAddHistory(o, c) {
      c[0] == 0 && (o += this.size), c.pop(), c.unshift(o);
    }
  };
  a.MIN_VERSION = 1, a.MAX_VERSION = 40, a.PENALTY_N1 = 3, a.PENALTY_N2 = 3, a.PENALTY_N3 = 40, a.PENALTY_N4 = 10, a.ECC_CODEWORDS_PER_BLOCK = [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [
      -1,
      7,
      10,
      15,
      20,
      26,
      18,
      20,
      24,
      30,
      18,
      20,
      24,
      26,
      30,
      22,
      24,
      28,
      30,
      28,
      28,
      28,
      28,
      30,
      30,
      26,
      28,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30
    ],
    // Low
    [
      -1,
      10,
      16,
      26,
      18,
      24,
      16,
      18,
      22,
      22,
      26,
      30,
      22,
      22,
      24,
      24,
      28,
      28,
      26,
      26,
      26,
      26,
      28,
      28,
      28,
      28,
      28,
      28,
      28,
      28,
      28,
      28,
      28,
      28,
      28,
      28,
      28,
      28,
      28,
      28,
      28
    ],
    // Medium
    [
      -1,
      13,
      22,
      18,
      26,
      18,
      24,
      18,
      22,
      20,
      24,
      28,
      26,
      24,
      20,
      30,
      24,
      28,
      28,
      26,
      30,
      28,
      30,
      30,
      30,
      30,
      28,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30
    ],
    // Quartile
    [
      -1,
      17,
      28,
      22,
      16,
      22,
      28,
      26,
      26,
      24,
      28,
      24,
      28,
      22,
      24,
      24,
      30,
      28,
      28,
      26,
      28,
      30,
      24,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30
    ]
    // High
  ], a.NUM_ERROR_CORRECTION_BLOCKS = [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [
      -1,
      1,
      1,
      1,
      1,
      1,
      2,
      2,
      2,
      2,
      4,
      4,
      4,
      4,
      4,
      6,
      6,
      6,
      6,
      7,
      8,
      8,
      9,
      9,
      10,
      12,
      12,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      19,
      20,
      21,
      22,
      24,
      25
    ],
    // Low
    [
      -1,
      1,
      1,
      1,
      2,
      2,
      4,
      4,
      4,
      5,
      5,
      5,
      8,
      9,
      9,
      10,
      10,
      11,
      13,
      14,
      16,
      17,
      17,
      18,
      20,
      21,
      23,
      25,
      26,
      28,
      29,
      31,
      33,
      35,
      37,
      38,
      40,
      43,
      45,
      47,
      49
    ],
    // Medium
    [
      -1,
      1,
      1,
      2,
      2,
      4,
      4,
      6,
      6,
      8,
      8,
      8,
      10,
      12,
      16,
      12,
      17,
      16,
      18,
      21,
      20,
      23,
      23,
      25,
      27,
      29,
      34,
      34,
      35,
      38,
      40,
      43,
      45,
      48,
      51,
      53,
      56,
      59,
      62,
      65,
      68
    ],
    // Quartile
    [
      -1,
      1,
      1,
      2,
      4,
      4,
      4,
      5,
      6,
      8,
      8,
      11,
      11,
      16,
      16,
      18,
      16,
      19,
      21,
      25,
      25,
      25,
      34,
      30,
      32,
      35,
      37,
      40,
      42,
      45,
      48,
      51,
      54,
      57,
      60,
      63,
      66,
      70,
      74,
      77,
      81
    ]
    // High
  ];
  let t = a;
  e.QrCode = t;
  function i(h, o, c) {
    if (o < 0 || o > 31 || h >>> o)
      throw new RangeError("Value out of range");
    for (let d = o - 1; d >= 0; d--)
      c.push(h >>> d & 1);
  }
  function r(h, o) {
    return (h >>> o & 1) != 0;
  }
  function s(h) {
    if (!h) throw new Error("Assertion error");
  }
  const u = class u {
    /*-- Constructor (low level) and fields --*/
    // Creates a new QR Code segment with the given attributes and data.
    // The character count (numChars) must agree with the mode and the bit buffer length,
    // but the constraint isn't checked. The given bit buffer is cloned and stored.
    constructor(o, c, d) {
      if (this.mode = o, this.numChars = c, this.bitData = d, c < 0) throw new RangeError("Invalid argument");
      this.bitData = d.slice();
    }
    /*-- Static factory functions (mid level) --*/
    // Returns a segment representing the given binary data encoded in
    // byte mode. All input byte arrays are acceptable. Any text string
    // can be converted to UTF-8 bytes and encoded as a byte mode segment.
    static makeBytes(o) {
      let c = [];
      for (const d of o) i(d, 8, c);
      return new u(u.Mode.BYTE, o.length, c);
    }
    // Returns a segment representing the given string of decimal digits encoded in numeric mode.
    static makeNumeric(o) {
      if (!u.isNumeric(o))
        throw new RangeError("String contains non-numeric characters");
      let c = [];
      for (let d = 0; d < o.length; ) {
        const _ = Math.min(o.length - d, 3);
        i(parseInt(o.substring(d, d + _), 10), _ * 3 + 1, c), d += _;
      }
      return new u(u.Mode.NUMERIC, o.length, c);
    }
    // Returns a segment representing the given text string encoded in alphanumeric mode.
    // The characters allowed are: 0 to 9, A to Z (uppercase only), space,
    // dollar, percent, asterisk, plus, hyphen, period, slash, colon.
    static makeAlphanumeric(o) {
      if (!u.isAlphanumeric(o))
        throw new RangeError(
          "String contains unencodable characters in alphanumeric mode"
        );
      let c = [], d;
      for (d = 0; d + 2 <= o.length; d += 2) {
        let _ = u.ALPHANUMERIC_CHARSET.indexOf(o.charAt(d)) * 45;
        _ += u.ALPHANUMERIC_CHARSET.indexOf(o.charAt(d + 1)), i(_, 11, c);
      }
      return d < o.length && i(
        u.ALPHANUMERIC_CHARSET.indexOf(o.charAt(d)),
        6,
        c
      ), new u(u.Mode.ALPHANUMERIC, o.length, c);
    }
    // Returns a new mutable list of zero or more segments to represent the given Unicode text string.
    // The result may use various segment modes and switch modes to optimize the length of the bit stream.
    static makeSegments(o) {
      return o == "" ? [] : u.isNumeric(o) ? [u.makeNumeric(o)] : u.isAlphanumeric(o) ? [u.makeAlphanumeric(o)] : [u.makeBytes(u.toUtf8ByteArray(o))];
    }
    // Returns a segment representing an Extended Channel Interpretation
    // (ECI) designator with the given assignment value.
    static makeEci(o) {
      let c = [];
      if (o < 0)
        throw new RangeError("ECI assignment value out of range");
      if (o < 128) i(o, 8, c);
      else if (o < 16384)
        i(2, 2, c), i(o, 14, c);
      else if (o < 1e6)
        i(6, 3, c), i(o, 21, c);
      else throw new RangeError("ECI assignment value out of range");
      return new u(u.Mode.ECI, 0, c);
    }
    // Tests whether the given string can be encoded as a segment in numeric mode.
    // A string is encodable iff each character is in the range 0 to 9.
    static isNumeric(o) {
      return u.NUMERIC_REGEX.test(o);
    }
    // Tests whether the given string can be encoded as a segment in alphanumeric mode.
    // A string is encodable iff each character is in the following set: 0 to 9, A to Z
    // (uppercase only), space, dollar, percent, asterisk, plus, hyphen, period, slash, colon.
    static isAlphanumeric(o) {
      return u.ALPHANUMERIC_REGEX.test(o);
    }
    /*-- Methods --*/
    // Returns a new copy of the data bits of this segment.
    getData() {
      return this.bitData.slice();
    }
    // (Package-private) Calculates and returns the number of bits needed to encode the given segments at
    // the given version. The result is infinity if a segment has too many characters to fit its length field.
    static getTotalBits(o, c) {
      let d = 0;
      for (const _ of o) {
        const m = _.mode.numCharCountBits(c);
        if (_.numChars >= 1 << m) return 1 / 0;
        d += 4 + m + _.bitData.length;
      }
      return d;
    }
    // Returns a new array of bytes representing the given string encoded in UTF-8.
    static toUtf8ByteArray(o) {
      o = encodeURI(o);
      let c = [];
      for (let d = 0; d < o.length; d++)
        o.charAt(d) != "%" ? c.push(o.charCodeAt(d)) : (c.push(parseInt(o.substring(d + 1, d + 3), 16)), d += 2);
      return c;
    }
  };
  u.NUMERIC_REGEX = /^[0-9]*$/, u.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/, u.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
  let l = u;
  e.QrSegment = l;
})(Me || (Me = {}));
((e) => {
  ((t) => {
    const r = class r {
      // The QR Code can tolerate about 30% erroneous codewords
      /*-- Constructor and fields --*/
      constructor(l, a) {
        this.ordinal = l, this.formatBits = a;
      }
    };
    r.LOW = new r(0, 1), r.MEDIUM = new r(1, 0), r.QUARTILE = new r(2, 3), r.HIGH = new r(3, 2);
    let i = r;
    t.Ecc = i;
  })(e.QrCode || (e.QrCode = {}));
})(Me || (Me = {}));
((e) => {
  ((t) => {
    const r = class r {
      /*-- Constructor and fields --*/
      constructor(l, a) {
        this.modeBits = l, this.numBitsCharCount = a;
      }
      /*-- Method --*/
      // (Package-private) Returns the bit width of the character count field for a segment in
      // this mode in a QR Code at the given version number. The result is in the range [0, 16].
      numCharCountBits(l) {
        return this.numBitsCharCount[Math.floor((l + 7) / 17)];
      }
    };
    r.NUMERIC = new r(1, [10, 12, 14]), r.ALPHANUMERIC = new r(2, [9, 11, 13]), r.BYTE = new r(4, [8, 16, 16]), r.KANJI = new r(8, [8, 10, 12]), r.ECI = new r(7, [0, 0, 0]);
    let i = r;
    t.Mode = i;
  })(e.QrSegment || (e.QrSegment = {}));
})(Me || (Me = {}));
const vn = Me.QrCode, hd = ({
  className: e,
  data: t
}) => {
  const [i, r] = Re(() => {
    const s = vn.encodeText(t, vn.Ecc.LOW);
    let l = [];
    for (let a = 0; a < s.size; a++)
      for (let u = 0; u < s.size; u++)
        s.getModule(u, a) && l.push(`M${u},${a}h1v1h-1z`);
    return [l, s.size];
  }, [t]);
  return /* @__PURE__ */ b("svg", { viewBox: `0 0 ${r} ${r}`, stroke: "none", className: e, children: [
    /* @__PURE__ */ n("rect", { width: "100%", height: "100%", fill: "#FFFFFF" }),
    /* @__PURE__ */ n("path", { d: i.join(" "), fill: "#000000" })
  ] });
}, Qt = ae({
  isFullscreen: !1,
  toggleFullscreen() {
  }
});
function bi({ children: e, className: t, ...i }) {
  const r = B(null), s = typeof e == "function", l = _d(r);
  return /* @__PURE__ */ n(
    "div",
    {
      ...i,
      ref: r,
      className: g(Ae["qr-code"], t),
      children: /* @__PURE__ */ n(Qt.Provider, { value: l, children: s ? e(l) : e })
    }
  );
}
function yi({
  children: e,
  className: t,
  ...i
}) {
  const { isFullscreen: r } = Z(Qt);
  return /* @__PURE__ */ n(
    ce,
    {
      ...i,
      className: g(r && Ae["fullscreen-container"], t),
      children: e
    }
  );
}
const Ct = {
  visible: {
    sv: "QR-kod. Klicka för att öppna i helskärm.",
    en: "QR code. Click to open in fullscreen."
  },
  partiallyVisible: {
    sv: "QR-kod ej helt synlig. Klicka för att öppna i helskärm.",
    en: "QR code not fully visible. Click to open in fullscreen."
  },
  fullscreen: {
    sv: "QR-kod positionerad i mitten av fönstret. Klicka för att stänga helskärmsläget.",
    en: "QR code positioned in the center of the window. Click to close fullscreen."
  }
}, xi = /* @__PURE__ */ C(function({
  "aria-description": t,
  className: i,
  data: r,
  onClick: s,
  size: l = "222px",
  "sm-size": a,
  "md-size": u,
  "lg-size": h
}, o) {
  const { isFullscreen: c, toggleFullscreen: d } = Z(Qt), _ = B(null), m = V();
  pe(o, () => _.current);
  const [f, p] = Q(!1), y = md(_), x = ud(
    () => p(!0),
    3e3
  ), k = () => {
    p && p(!1), x();
  }, I = (v) => {
    k(), s == null || s(v), v.defaultPrevented || d();
  };
  let w = Ct.visible[m];
  return y ? c && (w = Ct.fullscreen[m]) : w = Ct.partiallyVisible[m], /* @__PURE__ */ n(
    M,
    {
      asChild: !0,
      className: g(Ae["qr-code__box"], i),
      maxWidth: l,
      "sm-maxWidth": a,
      "md-maxWidth": u,
      "lg-maxWidth": h,
      width: "100%",
      children: /* @__PURE__ */ n(
        ct,
        {
          onClick: I,
          className: g(
            Ae["qr-code__button"],
            f && Ae["qr-code__button--hide-cursor"]
          ),
          onMouseEnter: x,
          onMouseLeave: x.cancel,
          onMouseMove: k,
          "aria-label": w,
          "aria-description": t,
          ref: _,
          children: /* @__PURE__ */ n(hd, { data: r, className: Ae["qr-code__svg"] })
        }
      )
    }
  );
}), fd = /* @__PURE__ */ C(
  function({
    className: t,
    data: i,
    onClick: r,
    size: s,
    "sm-size": l,
    "md-size": a,
    "lg-size": u,
    ...h
  }, o) {
    return /* @__PURE__ */ n(bi, { className: t, ...h, children: /* @__PURE__ */ n(yi, { children: /* @__PURE__ */ n(
      xi,
      {
        data: i,
        onClick: r,
        ref: o,
        size: s,
        "sm-size": l,
        "md-size": a,
        "lg-size": u
      }
    ) }) });
  }
), Xt = fd;
Xt.Root = bi;
Xt.Container = yi;
Xt.Code = xi;
const pd = "_radio__input_1geri_43", gd = "_radio__label_1geri_48", Nn = {
  radio__input: pd,
  radio__label: gd
}, wi = ae(null);
function bd({
  checked: e,
  className: t,
  defaultChecked: i,
  disabled: r = !1,
  id: s,
  innerRef: l,
  inputClassName: a,
  inputProps: u = {},
  inputRef: h,
  label: o,
  labelClassName: c,
  labelProps: d = {},
  labelRef: _,
  name: m,
  onBlur: f,
  onChange: p,
  onFocus: y,
  value: x,
  ...k
}, I) {
  const w = Z(wi), v = le(
    (N) => {
      p && p(N), w != null && w.onChange && w.onChange(N);
    },
    [p, w == null ? void 0 : w.onChange]
  ), R = `radio-${X()}`, F = s ?? R;
  let q = e;
  return w && (q = w.value === x), /* @__PURE__ */ b(
    "div",
    {
      ...k,
      ref: I ?? l,
      className: t,
      onClick: (N) => {
        N.target.localName === "input" && N.target.focus(), typeof k.onClick == "function" && k.onClick(N);
      },
      children: [
        /* @__PURE__ */ n(
          "input",
          {
            ...u,
            checked: q,
            className: g(Nn.radio__input, a),
            defaultChecked: i,
            disabled: r,
            id: F,
            name: m ?? (w == null ? void 0 : w.name),
            onBlur: f,
            onChange: v,
            onFocus: y,
            ref: h,
            type: "radio",
            value: x
          }
        ),
        /* @__PURE__ */ n(
          "label",
          {
            ...d,
            htmlFor: F,
            ref: _,
            className: g(Nn.radio__label, c),
            children: o
          }
        )
      ]
    }
  );
}
const yd = /* @__PURE__ */ C(
  bd
), Cn = {
  "radio-group--row": "_radio-group--row_6ppsz_1"
};
function xd({
  children: e,
  description: t,
  label: i,
  message: r,
  name: s,
  onChange: l,
  row: a,
  secondaryLabel: u,
  supplemental: h,
  tone: o,
  value: c,
  ...d
}) {
  const _ = X(), m = `label-${_}`, f = `description-${_}`, p = `message-${_}`, y = le(
    (I) => {
      l && l(I.currentTarget.value);
    },
    [l]
  ), x = Re(
    () => ({
      name: s,
      onChange: y,
      value: c ?? ""
    }),
    [s, y, c]
  );
  let k;
  return (r || t) && (k = [t && f, r && p].filter(Boolean).join(" ")), /* @__PURE__ */ b(M, { ...d, direction: "column", gap: "0.5rem", children: [
    i && /* @__PURE__ */ b("div", { children: [
      /* @__PURE__ */ n(
        At,
        {
          id: m,
          secondaryLabel: t ? void 0 : u,
          children: i
        }
      ),
      typeof t < "u" && /* @__PURE__ */ n(qt, { id: f, children: t })
    ] }),
    h,
    /* @__PURE__ */ n(wi.Provider, { value: x, children: /* @__PURE__ */ n(
      "div",
      {
        role: "radiogroup",
        "aria-labelledby": m,
        "aria-describedby": k,
        "aria-invalid": o === "critical",
        className: g(
          Cn["radio-group"],
          a && Cn["radio-group--row"]
        ),
        children: e
      }
    ) }),
    r && /* @__PURE__ */ n(lt, { id: p, tone: o, children: r })
  ] });
}
const wd = "_item_1q1pt_1", vd = "_indicator_1q1pt_9", Nd = "_circle_1q1pt_12", Cd = "_label_1q1pt_26", Ke = {
  item: wd,
  indicator: vd,
  circle: Nd,
  "inner-circle": "_inner-circle_1q1pt_17",
  label: Cd
}, vi = ae({
  handleChange: () => {
  }
}), Zt = ae({
  isChecked: !1
});
function Jt({
  children: e,
  defaultValue: t,
  disabled: i,
  name: r,
  onBlur: s,
  onChange: l,
  onFocus: a,
  value: u,
  ...h
}) {
  const [o, c] = ge(
    u,
    t ?? "",
    ""
  ), d = o, _ = le(
    (p) => {
      c(p.target.value), l == null || l(p.target.value);
    },
    [l, c]
  ), m = X(), { focusWithinProps: f } = kn({
    onBlurWithin: s,
    onFocusWithin: a
  });
  return /* @__PURE__ */ n(
    vi.Provider,
    {
      value: {
        disabled: i,
        handleChange: _,
        name: r ?? m,
        selectedValue: d
      },
      children: /* @__PURE__ */ n("div", { ...h, ...f, role: "radiogroup", children: e })
    }
  );
}
const en = /* @__PURE__ */ C(
  function({ children: t, className: i, disabled: r, style: s, value: l }, a) {
    const {
      disabled: u,
      handleChange: h,
      name: o,
      selectedValue: c
    } = Z(vi), d = X(), _ = `${d}-control`, m = `${d}-label`, f = c === l, p = u ?? r;
    return /* @__PURE__ */ n(
      Zt.Provider,
      {
        value: {
          controlId: _,
          isChecked: f,
          labelId: m,
          value: l
        },
        children: /* @__PURE__ */ b(
          "label",
          {
            "data-disabled": p,
            className: g(Ke.item, i),
            style: s,
            children: [
              /* @__PURE__ */ n(he, { children: /* @__PURE__ */ n(
                "input",
                {
                  type: "radio",
                  "aria-labelledby": m,
                  checked: f,
                  disabled: p,
                  id: _,
                  name: o,
                  onChange: h,
                  ref: a,
                  value: l
                }
              ) }),
              typeof t == "function" ? t == null ? void 0 : t({ isChecked: f, isDisabled: p }) : t
            ]
          }
        )
      }
    );
  }
);
function tn({ className: e }) {
  const { isChecked: t } = Z(Zt);
  return /* @__PURE__ */ b(
    "svg",
    {
      "aria-hidden": !0,
      width: "1.125rem",
      height: "1.5rem",
      viewBox: "0 -3 18 24",
      className: g(Ke.indicator, e),
      children: [
        /* @__PURE__ */ n("circle", { cx: 9, cy: 9, r: 8.5, className: Ke.circle }),
        t && /* @__PURE__ */ n("circle", { cx: 9, cy: 9, r: 4, className: Ke["inner-circle"] })
      ]
    }
  );
}
function nn({ children: e, className: t }) {
  const { labelId: i } = Z(Zt);
  return /* @__PURE__ */ n("span", { className: g(Ke.label, t), id: i, children: e });
}
const ze = {
  "standard-item": "_standard-item_1n4w5_1",
  "standard-indicator": "_standard-indicator_1n4w5_4",
  "standard-label": "_standard-label_1n4w5_8",
  "prominent-item": "_prominent-item_1n4w5_12",
  "prominent-inner": "_prominent-inner_1n4w5_18",
  "prominent-inner--checked": "_prominent-inner--checked_1n4w5_26",
  "icon-container": "_icon-container_1n4w5_30"
}, Id = /* @__PURE__ */ C(
  function({
    className: t,
    defaultValue: i,
    disabled: r,
    name: s,
    onBlur: l,
    onChange: a,
    onFocus: u,
    options: h,
    value: o,
    ...c
  }, d) {
    return /* @__PURE__ */ n(de, { ...c, className: t, children: (_) => /* @__PURE__ */ n(
      Jt,
      {
        ..._,
        defaultValue: i,
        disabled: r,
        name: s,
        onBlur: l,
        onChange: a,
        onFocus: u,
        value: o,
        children: /* @__PURE__ */ n(M, { direction: "column", gap: ".3125rem", children: h.map((m, f) => /* @__PURE__ */ n(
          en,
          {
            className: ze["standard-item"],
            value: m.value,
            ref: f ? void 0 : d,
            children: /* @__PURE__ */ b(M, { align: "flex-start", gap: ".5rem", children: [
              /* @__PURE__ */ n(tn, { className: ze["standard-indicator"] }),
              /* @__PURE__ */ n(nn, { className: ze["standard-label"], children: m.label })
            ] })
          },
          m.value
        )) })
      }
    ) });
  }
), kd = /* @__PURE__ */ C(
  function({
    className: t,
    defaultValue: i,
    disabled: r,
    name: s,
    onBlur: l,
    onChange: a,
    onFocus: u,
    options: h,
    value: o,
    ...c
  }, d) {
    return /* @__PURE__ */ n(de, { ...c, className: t, children: (_) => /* @__PURE__ */ n(
      Jt,
      {
        ..._,
        defaultValue: i,
        disabled: r,
        name: s,
        onBlur: l,
        onChange: a,
        onFocus: u,
        value: o,
        children: /* @__PURE__ */ n(M, { direction: "column", gap: ".5rem", children: h.map((m, f) => /* @__PURE__ */ n(
          en,
          {
            value: m.value,
            ref: f ? void 0 : d,
            children: ({ isChecked: p }) => /* @__PURE__ */ n("div", { className: ze["prominent-item"], children: /* @__PURE__ */ b(
              M,
              {
                justify: "space-between",
                className: g(
                  ze["prominent-inner"],
                  p && ze["prominent-inner--checked"]
                ),
                gap: ".5rem",
                align: "center",
                children: [
                  /* @__PURE__ */ b(M, { align: "center", gap: ".5rem", children: [
                    /* @__PURE__ */ n(tn, {}),
                    /* @__PURE__ */ n(nn, { children: m.label })
                  ] }),
                  m.icon && /* @__PURE__ */ n(
                    M,
                    {
                      align: "center",
                      className: ze["icon-container"],
                      children: /* @__PURE__ */ n(m.icon, { size: "3em" })
                    }
                  )
                ]
              }
            ) })
          },
          m.value
        )) })
      }
    ) });
  }
), rn = yd;
rn.Root = en;
rn.Indicator = tn;
rn.Label = nn;
const sn = xd;
sn.Root = Jt;
sn.Standard = Id;
sn.Prominent = kd;
const Rd = "_icon_27bmm_1", Pd = {
  icon: Rd
};
function Se({
  action: e,
  additionalInformation: t,
  children: i,
  icon: r,
  renderTitle: s,
  title: l,
  ...a
}) {
  return /* @__PURE__ */ b(M, { ...a, direction: "column", children: [
    /* @__PURE__ */ n(E, { when: r, children: /* @__PURE__ */ n(Ni, { children: r }) }),
    /* @__PURE__ */ n(Ci, { asChild: typeof s < "u", children: (s == null ? void 0 : s(l)) ?? l }),
    /* @__PURE__ */ n(Ii, { children: i }),
    /* @__PURE__ */ n(E, { when: t, children: /* @__PURE__ */ n(ki, { children: t }) }),
    /* @__PURE__ */ n(E, { when: e, children: /* @__PURE__ */ n(Ri, { children: e }) })
  ] });
}
((e) => {
  e.Icon = Ni, e.Title = Ci, e.Content = Ii, e.AdditionalInformation = ki, e.Actions = Ri;
})(Se || (Se = {}));
function Ni({ children: e, className: t, ...i }) {
  return /* @__PURE__ */ n(ce, { mb: "1rem", ...i, className: g(Pd.icon, t), children: e });
}
function Ci(e) {
  return /* @__PURE__ */ n(
    H,
    {
      as: "span",
      mb: ".5rem",
      size: "heading-screen",
      wrap: "balance",
      ...e
    }
  );
}
function Ii(e) {
  return /* @__PURE__ */ n(ce, { ...e });
}
function ki(e) {
  return /* @__PURE__ */ n(
    mt,
    {
      p: "1rem",
      mt: "1.5rem",
      ...e,
      backgroundColor: `color-mix(in srgb, transparent, ${U("color-modifier-increase")} 4%)`
    }
  );
}
function Ri(e) {
  return /* @__PURE__ */ n(
    M,
    {
      mt: "1.5rem",
      direction: "column",
      "sm-direction": "row",
      "sm-align": "center",
      gap: "1rem",
      ...e
    }
  );
}
const Sd = "_result_1ptzx_1", zd = "_icon_1ptzx_5", $d = "_additional_1ptzx_10", It = {
  result: Sd,
  icon: zd,
  additional: $d
};
function f_({
  action: e,
  additionalInformation: t,
  children: i,
  className: r,
  icon: s,
  renderTitle: l,
  title: a,
  ...u
}) {
  return /* @__PURE__ */ n(mt, { asChild: !0, ...u, px: "1.5rem", pb: "2.5rem", pt: "2rem", "sm-px": "2.5rem", children: /* @__PURE__ */ b(M, { direction: "column", className: g(It.result, r), children: [
    /* @__PURE__ */ n(E, { when: s, children: /* @__PURE__ */ n(Se.Icon, { className: It.icon, mx: "auto", children: s }) }),
    /* @__PURE__ */ n(
      Se.Title,
      {
        asChild: typeof l < "u",
        size: "heading-section",
        children: (l == null ? void 0 : l(a)) ?? a
      }
    ),
    /* @__PURE__ */ n(Se.Content, { children: i }),
    /* @__PURE__ */ n(E, { when: t, children: /* @__PURE__ */ n(Se.AdditionalInformation, { className: It.additional, children: t }) }),
    /* @__PURE__ */ n(E, { when: e, children: /* @__PURE__ */ n(Se.Actions, { justify: "center", children: e }) })
  ] }) });
}
const Ed = "_select_1tosb_1", Md = "_select__input_1tosb_29", Fd = "_select_icon_1tosb_61", ke = {
  select: Ed,
  "select--disabled": "_select--disabled_1tosb_14",
  "select--invalid": "_select--invalid_1tosb_17",
  "select--large": "_select--large_1tosb_20",
  "select--small": "_select--small_1tosb_24",
  select__input: Md,
  "select__input--large": "_select__input--large_1tosb_44",
  "select__input--small": "_select__input--small_1tosb_47",
  select_icon: Fd,
  "select_icon--large": "_select_icon--large_1tosb_68",
  "select_icon--small": "_select_icon--small_1tosb_72"
}, Dd = "_icon_11ij7_1", Bd = {
  icon: Dd
};
function qd({ className: e, ...t }) {
  return /* @__PURE__ */ b(
    "svg",
    {
      ...t,
      "aria-hidden": !0,
      className: g(Bd.icon, e),
      width: "0.75rem",
      height: "1.5rem",
      viewBox: "0 0 12 24",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n("polyline", { points: "3,9 6,6 9,9", fill: "none", strokeWidth: "1.6" }),
        /* @__PURE__ */ n("polyline", { points: "3,15 6,18 9,15", fill: "none", strokeWidth: "1.6" })
      ]
    }
  );
}
function Ad({
  "aria-describedby": e,
  "aria-invalid": t,
  "aria-labelledby": i,
  "aria-label": r,
  "aria-required": s,
  className: l,
  children: a,
  defaultValue: u,
  disabled: h,
  id: o,
  innerRef: c,
  inputClassName: d,
  inputProps: _ = {},
  inputRef: m,
  invalid: f = !1,
  name: p,
  onBlur: y,
  onChange: x,
  onFocus: k,
  size: I,
  value: w,
  // Prevent block prop from ending up as an attribute on underlying element
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  block: v,
  ...R
}, F) {
  return /* @__PURE__ */ b(
    "div",
    {
      ...R,
      className: g(
        ke.select,
        I && ke[`select--${I}`],
        h && ke["select--disabled"],
        f && ke["select--invalid"],
        l
      ),
      ref: F ?? c,
      children: [
        /* @__PURE__ */ n(
          "select",
          {
            ..._,
            "aria-describedby": e,
            "aria-labelledby": i,
            "aria-label": r,
            "aria-invalid": f ? !0 : t,
            "aria-required": s,
            className: g(
              ke.select__input,
              I && ke[`select__input--${I}`],
              d
            ),
            defaultValue: u,
            disabled: h,
            id: o,
            name: p,
            onBlur: y,
            onChange: x,
            onFocus: k,
            ref: m,
            value: w,
            children: a
          }
        ),
        /* @__PURE__ */ n(
          qd,
          {
            className: g(
              ke.select_icon,
              I && ke[`select_icon--${I}`]
            )
          }
        )
      ]
    }
  );
}
const Ld = /* @__PURE__ */ C(Ad), Pi = /* @__PURE__ */ C(
  function({
    children: t,
    defaultValue: i,
    disabled: r = !1,
    inputClassName: s,
    inputProps: l = {},
    inputRef: a,
    name: u,
    onBlur: h,
    onChange: o,
    onChangeEvent: c,
    onFocus: d,
    size: _,
    value: m,
    ...f
  }, p) {
    const [y, x] = ge(
      m,
      i ?? "",
      ""
    );
    return /* @__PURE__ */ n(de, { ...f, ref: p, children: (k, I) => /* @__PURE__ */ n(
      Ld,
      {
        ...k,
        ...l,
        disabled: r,
        inputClassName: s,
        invalid: I.isInvalid,
        name: u,
        onBlur: h,
        onChange: (w) => {
          c == null || c(w), o == null || o(w.target.value), x(w.target.value);
        },
        onFocus: d,
        ref: a,
        size: _,
        value: m ?? y,
        children: t
      }
    ) });
  }
), Td = /* @__PURE__ */ C(function({ onChange: t, ...i }, r) {
  return /* @__PURE__ */ n(Pi, { ...i, onChangeEvent: t, ref: r });
}), Vd = Pi;
Vd.WithNativeOnChange = Td;
const jd = "_slider_5hg6d_43", Od = "_highContrast_5hg6d_47", Wd = "_horizontal_5hg6d_51", Hd = "_vertical_5hg6d_55", Gd = "_track_5hg6d_59", Ud = "_trackLine_5hg6d_65", Yd = "_thumb_5hg6d_89", Kd = "_thumbLabel_5hg6d_105", Qd = "_alwaysOff_5hg6d_105", Xd = "_dragging_5hg6d_105", Zd = "_alwaysOn_5hg6d_123", Jd = "_disabled_5hg6d_160", oe = {
  slider: jd,
  highContrast: Od,
  horizontal: Wd,
  vertical: Hd,
  track: Gd,
  trackLine: Ud,
  thumb: Yd,
  thumbLabel: Kd,
  alwaysOff: Qd,
  dragging: Xd,
  alwaysOn: Zd,
  disabled: Jd
}, eu = /* @__PURE__ */ C(
  (e, t) => /* @__PURE__ */ n(Yt, { children: /* @__PURE__ */ n(Si, { ...e, ref: t }) })
);
eu.displayName = "Slider";
const Si = C(
  ({ highContrast: e, ...t }, i) => {
    var c;
    const r = B(null), s = an(t.formatOptions), l = an(), a = Br({
      ...t,
      minValue: t.min,
      maxValue: t.max,
      numberFormatter: s
    });
    let { trackProps: u, outputProps: h } = ur(
      {
        ...t,
        minValue: t.min,
        maxValue: t.max
      },
      a,
      r
    );
    const o = (a.getThumbValue(0) - a.getThumbMinValue(0)) / (a.getThumbMaxValue(0) - a.getThumbMinValue(0)) * 100;
    return /* @__PURE__ */ n(ie, { children: /* @__PURE__ */ b(
      "div",
      {
        className: g(
          oe.slider,
          e && oe.highContrast,
          oe[a.orientation],
          t.className
        ),
        children: [
          /* @__PURE__ */ n(E, { when: t.showOutput, children: t.renderOutput ? (c = t.renderOutput) == null ? void 0 : c.call(t, a.getThumbValueLabel(0), h) : /* @__PURE__ */ n("output", { ...h, children: a.getThumbValueLabel(0) }) }),
          /* @__PURE__ */ b(
            "div",
            {
              ...u,
              ref: r,
              className: g(oe.track, a.isDisabled && oe.disabled),
              children: [
                /* @__PURE__ */ n(
                  "div",
                  {
                    className: oe.trackLine,
                    style: {
                      background: `linear-gradient(to ${a.orientation === "horizontal" ? "right" : "top"}, ${e ? tt("color-accent-accessible") : tt("color-accent")} ${o}%, ${e ? `hsl(from ${tt("color-modifier-increase")} h s l / 0.25)` : tt("color-muted-secondary-stroke")} ${o}%)`
                    }
                  }
                ),
                /* @__PURE__ */ n(
                  zi,
                  {
                    index: 0,
                    state: a,
                    trackRef: r,
                    ref: i,
                    name: t.name,
                    thumbValueVisibility: t.thumbValueVisibility,
                    "aria-label": t["aria-label"],
                    "aria-labelledby": t["aria-labelledby"],
                    "aria-describedby": t["aria-describedby"]
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ n(E, { when: t.showMinMaxLabels, children: /* @__PURE__ */ b(M, { justify: "space-between", children: [
            /* @__PURE__ */ n("span", { children: l.format(a.getThumbMinValue(0)) }),
            /* @__PURE__ */ n("span", { children: l.format(a.getThumbMaxValue(0)) })
          ] }) })
        ]
      }
    ) });
  }
);
Si.displayName = "SliderRoot";
const zi = C(
  ({ thumbValueVisibility: e = "off", ...t }, i) => {
    let { state: r, trackRef: s, index: l, name: a } = t, u = B(null);
    pe(i, () => u.current);
    let { thumbProps: h, inputProps: o, isDragging: c } = _r(
      {
        index: l,
        trackRef: s,
        inputRef: u,
        name: a,
        "aria-label": t["aria-label"]
      },
      r
    ), { focusProps: d, isFocusVisible: _ } = zn();
    return /* @__PURE__ */ b(
      "div",
      {
        ...h,
        className: g(
          oe.thumb,
          _ && oe.focus,
          c && oe.dragging
        ),
        children: [
          /* @__PURE__ */ n(
            "div",
            {
              className: g(
                oe.thumbLabel,
                e === "always-on" && oe.alwaysOn,
                e === "off" && oe.alwaysOff
              ),
              "aria-hidden": e === "off",
              children: r.getThumbValueLabel(0)
            }
          ),
          /* @__PURE__ */ n(mr, { children: /* @__PURE__ */ n(
            "input",
            {
              ref: u,
              ...$n(d, o),
              "aria-label": t["aria-label"],
              "aria-describedby": t["aria-describedby"],
              "aria-labelledby": t["aria-labelledby"]
            }
          ) })
        ]
      }
    );
  }
);
zi.displayName = "Thumb";
const Be = {
  "step-indicator": "_step-indicator_gr1g8_43",
  "step-indicator__header": "_step-indicator__header_gr1g8_48",
  "step-indicator__label": "_step-indicator__label_gr1g8_54",
  "step-indicator__state": "_step-indicator__state_gr1g8_58",
  "step-indicator__progress-bar": "_step-indicator__progress-bar_gr1g8_70",
  "step-indicator__progress-fill": "_step-indicator__progress-fill_gr1g8_77"
}, p_ = /* @__PURE__ */ C(
  function({ className: t, currentStep: i, id: r, steps: s }, l) {
    const a = V(), h = `${X()}-title`, o = s.length, c = B(null), d = s[i - 1], _ = Math.max(
      0,
      Math.min(100, i / o * 100)
    );
    return pe(l, () => ({
      focus() {
        var m;
        (m = c.current) == null || m.focus();
      }
    })), /* @__PURE__ */ b(
      "div",
      {
        tabIndex: -1,
        ref: c,
        id: r,
        "aria-labelledby": h,
        role: "meter",
        "aria-valuemin": 1,
        "aria-valuemax": o,
        "aria-valuenow": i,
        "aria-valuetext": a === "sv" ? `Steg ${i} av ${o}` : `Step ${i} of ${o}`,
        className: g(Be["step-indicator"], t),
        children: [
          /* @__PURE__ */ b("div", { className: Be["step-indicator__header"], children: [
            /* @__PURE__ */ n(
              H,
              {
                as: "span",
                size: "paragraph",
                className: Be["step-indicator__label"],
                id: h,
                children: d
              }
            ),
            /* @__PURE__ */ b("span", { className: Be["step-indicator__state"], children: [
              i,
              " / ",
              o
            ] })
          ] }),
          /* @__PURE__ */ n("div", { className: Be["step-indicator__progress-bar"], children: /* @__PURE__ */ n(
            "div",
            {
              className: Be["step-indicator__progress-fill"],
              style: { width: `${_}%` }
            }
          ) })
        ]
      }
    );
  }
);
function tu(e, t) {
  switch (t.type) {
    case "set":
    case "increment":
    case "decrement": {
      let i;
      if (t.type === "set")
        i = t.step;
      else {
        const r = t.type === "increment" ? 1 : -1;
        i = Math.min(
          Math.max(e.currentStep + r, 1),
          e.totalSteps
        );
      }
      return i === e.currentStep ? e : {
        ...e,
        currentStep: i,
        canGoBack: i > 1,
        canGoForward: i < e.totalSteps,
        isTouched: !0
      };
    }
    default:
      return e;
  }
}
function nu(e, t) {
  return {
    currentStep: t,
    totalSteps: e,
    canGoBack: t > 1,
    canGoForward: t < e,
    isTouched: !1
  };
}
function g_({
  totalSteps: e,
  initialStep: t = 1,
  currentStep: i
}) {
  const [r, s] = In(
    tu,
    nu(e, i ?? t)
  );
  return W(() => {
    i && s({ type: "set", step: i });
  }, [i, s]), [
    r,
    {
      /**
       * Go to previous step, if possible.
       */
      prev: () => s({ type: "decrement" }),
      /**
       * Go to next step, if possible.
       */
      next: () => s({ type: "increment" })
    }
  ];
}
const iu = "_root_i6j57_1", ru = "_label_i6j57_5", su = "_thumb_i6j57_9", ou = "_focused_i6j57_17", au = "_pressed_i6j57_22", lu = "_thumb__circle_i6j57_22", cu = "_thumb__rect_i6j57_26", du = "_checked_i6j57_30", Ce = {
  root: iu,
  label: ru,
  thumb: su,
  focused: ou,
  pressed: au,
  thumb__circle: lu,
  thumb__rect: cu,
  checked: du
}, $i = /* @__PURE__ */ C(
  function(t, i) {
    const {
      checked: r,
      children: s,
      defaultChecked: l,
      disabled: a,
      name: u,
      onChange: h,
      className: o
    } = t, c = {
      "aria-hidden": t["aria-hidden"],
      "aria-label": t["aria-label"],
      "aria-labelledby": t["aria-labelledby"],
      "aria-describedby": t["aria-describedby"],
      role: t.role,
      id: t.id,
      style: t.style
    }, d = B(null), _ = qr({
      onChange: h,
      // React ARIA-specific naming conventions
      defaultSelected: l,
      isDisabled: a,
      isSelected: r
    }), {
      inputProps: m,
      isDisabled: f,
      isSelected: p
    } = hr(t, _, d), { isFocusVisible: y, focusProps: x } = zn(), [k, I] = Q(!1), { pressProps: w } = fr({
      isDisabled: f,
      onPressStart(R) {
        R.pointerType !== "keyboard" && I(!0);
      },
      onPressEnd(R) {
        R.pointerType !== "keyboard" && I(!1);
      }
    }), { keyboardProps: v } = pr({
      onKeyDown(R) {
        R.key === "Enter" && _.toggle();
      }
    });
    return pe(i, () => d.current ?? {}), /* @__PURE__ */ b(
      "label",
      {
        ...c,
        ...w,
        className: g(
          Ce.root,
          y && Ce.focused,
          k && Ce.pressed,
          f && Ce.disabled,
          p && Ce.checked,
          o
        ),
        children: [
          /* @__PURE__ */ n(he, { children: /* @__PURE__ */ n(
            "input",
            {
              name: u,
              ...$n(m, x, v),
              ref: d
            }
          ) }),
          s
        ]
      }
    );
  }
);
function Ei({
  children: e,
  className: t,
  ...i
}) {
  return /* @__PURE__ */ n("span", { ...i, className: g(Ce.label, t), children: e });
}
function Mi({ className: e }) {
  return /* @__PURE__ */ b(
    "svg",
    {
      "aria-hidden": !0,
      viewBox: "0 0 40 24",
      width: 40,
      height: 24,
      className: g(Ce.thumb, e),
      children: [
        /* @__PURE__ */ n(
          "rect",
          {
            x: 0,
            y: 0,
            width: 40,
            height: 24,
            rx: 12,
            className: Ce.thumb__rect
          }
        ),
        /* @__PURE__ */ n("circle", { cx: 12, cy: 12, r: 10, className: Ce.thumb__circle })
      ]
    }
  );
}
function uu({ children: e, ...t }) {
  return /* @__PURE__ */ n($i, { ...t, children: /* @__PURE__ */ b(M, { align: "center", gap: "0.75rem", justify: "space-between", children: [
    /* @__PURE__ */ n(Ei, { children: e }),
    /* @__PURE__ */ n(Mi, {})
  ] }) });
}
const on = uu;
on.Root = $i;
on.Label = Ei;
on.Thumb = Mi;
const _u = "_ascending_15yva_47", mu = "_none_15yva_48", hu = "_descending_15yva_48", fe = {
  "table-root": "_table-root_15yva_1",
  "table-caption": "_table-caption_15yva_2",
  "table-body": "_table-body_15yva_3",
  "table-foot": "_table-foot_15yva_4",
  "table-head": "_table-head_15yva_5",
  "table-row": "_table-row_15yva_6",
  "table-header": "_table-header_15yva_7",
  "table-data": "_table-data_15yva_8",
  "sort-indicator": "_sort-indicator_15yva_39",
  ascending: _u,
  none: mu,
  descending: hu
}, Fi = C(
  ({ children: e, className: t, ...i }, r) => /* @__PURE__ */ n("tbody", { ref: r, className: g(fe["table-body"], t), ...i, children: e })
);
Fi.displayName = "TableBody";
const Di = C(
  ({ children: e, className: t, ...i }, r) => /* @__PURE__ */ n(
    "caption",
    {
      ref: r,
      className: g(fe["table-caption"], t),
      ...i,
      children: e
    }
  )
);
Di.displayName = "TableCaption";
const Bi = C(
  ({ children: e, className: t, ...i }, r) => /* @__PURE__ */ n("td", { ref: r, className: g(fe["table-data"], t), ...i, children: e })
);
Bi.displayName = "TableData";
const qi = C(
  ({ children: e, className: t, ...i }, r) => /* @__PURE__ */ n("tfoot", { ref: r, className: g(fe["table-foot"], t), ...i, children: e })
);
qi.displayName = "TableFoot";
const Ai = C(
  ({ children: e, className: t, ...i }, r) => /* @__PURE__ */ n("thead", { ref: r, className: g(fe["table-head"], t), ...i, children: e })
);
Ai.displayName = "TableHead";
const Li = C(
  ({ children: e, className: t, ...i }, r) => /* @__PURE__ */ n(
    "th",
    {
      ref: r,
      className: g(fe["table-header"], t),
      ...i,
      children: e
    }
  )
);
Li.displayName = "TableHeader";
const Ti = C(
  ({ children: e, className: t, ...i }, r) => /* @__PURE__ */ n("table", { ref: r, className: g(fe["table-root"], t), ...i, children: e })
);
Ti.displayName = "TableRoot";
const Vi = C(
  ({ children: e, className: t, ...i }, r) => /* @__PURE__ */ n("tr", { ref: r, className: g(fe["table-row"], t), ...i, children: e })
);
Vi.displayName = "TableRow";
const b_ = ({ direction: e, className: t }) => /* @__PURE__ */ b(
  "svg",
  {
    className: g(
      fe["sort-indicator"],
      e ? fe[e] : "",
      t
    ),
    width: "16",
    height: "16",
    viewBox: "0 0 100 100",
    children: [
      /* @__PURE__ */ n("polygon", { points: "25,40 50,10 75,40" }),
      /* @__PURE__ */ n("polygon", { points: "25,60 50,90 75,60" })
    ]
  }
), y_ = {
  Body: Fi,
  Caption: Di,
  Data: Bi,
  Foot: qi,
  Head: Ai,
  Header: Li,
  Root: Ti,
  Row: Vi
}, fu = "_textarea_190ww_1", rt = {
  textarea: fu,
  "textarea--resizeable": "_textarea--resizeable_190ww_29",
  "textarea--resizeable-both": "_textarea--resizeable-both_190ww_29",
  "textarea--resizeable-vertical": "_textarea--resizeable-vertical_190ww_32",
  "textarea--resizeable-horizontal": "_textarea--resizeable-horizontal_190ww_35",
  "textarea--invalid": "_textarea--invalid_190ww_38"
};
function pu({
  invalid: e = !1,
  className: t,
  resizeable: i = !1,
  innerRef: r,
  // Prevent block prop from ending up as an attribute on underlying element
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  block: s,
  ...l
}, a) {
  return /* @__PURE__ */ n(
    "textarea",
    {
      ...l,
      ref: a ?? r,
      className: g(
        rt.textarea,
        e && rt["textarea--invalid"],
        i === !0 && rt["textarea--resizeable"],
        typeof i == "string" && rt[`textarea--resizeable-${i}`],
        t
      )
    }
  );
}
const gu = /* @__PURE__ */ C(pu), ji = /* @__PURE__ */ C(
  function({
    defaultValue: t,
    disabled: i = !1,
    inputClassName: r,
    inputMode: s,
    inputProps: l = {},
    inputRef: a,
    label: u,
    maxLength: h,
    name: o,
    onBlur: c,
    onChange: d,
    onChangeEvent: _,
    onFocus: m,
    placeholder: f,
    prefix: p,
    prefixAriaLabel: y,
    resizable: x,
    size: k,
    suffix: I,
    suffixAriaLabel: w,
    type: v,
    textarea: R = !1,
    value: F,
    ...q
  }, N) {
    const [$, P] = ge(
      F,
      t ?? "",
      ""
    ), S = {
      ...l,
      className: r,
      disabled: i,
      inputMode: s,
      maxLength: h ?? (l == null ? void 0 : l.maxLength),
      name: o,
      onChange(T) {
        _ == null || _(T), d == null || d(T.target.value), P(T.target.value);
      },
      placeholder: f,
      ref: a,
      value: $
    };
    let A = {}, z = _t;
    (p || I) && (A = { disabled: i }, z = gi);
    let L = u;
    return u && (L = /* @__PURE__ */ b(ie, { children: [
      u,
      /* @__PURE__ */ n(E, { when: y, children: /* @__PURE__ */ n(he, { children: y }) }),
      /* @__PURE__ */ n(E, { when: w, children: /* @__PURE__ */ n(he, { children: w }) })
    ] })), /* @__PURE__ */ n(de, { ...q, label: L, ref: N, children: (T, G) => R ? /* @__PURE__ */ n(
      gu,
      {
        ...T,
        ...S,
        invalid: G.isInvalid,
        onBlur: c,
        onFocus: m,
        resizeable: x
      }
    ) : /* @__PURE__ */ b(z, { ...A, children: [
      /* @__PURE__ */ n(E, { when: p, children: /* @__PURE__ */ n(ut, { children: p }) }),
      /* @__PURE__ */ n(
        Sc,
        {
          ...T,
          ...S,
          invalid: G.isInvalid,
          onBlur: c,
          onFocus: m,
          size: k,
          type: v
        }
      ),
      /* @__PURE__ */ n(E, { when: I, children: /* @__PURE__ */ n(ut, { children: I }) })
    ] }) });
  }
), bu = /* @__PURE__ */ C(function({ onChange: t, ...i }, r) {
  return /* @__PURE__ */ n(ji, { ...i, onChangeEvent: t, ref: r });
}), yu = ji;
yu.WithNativeOnChange = bu;
export {
  Fu as Accordion,
  Qr as AccordionContent,
  Xr as AccordionItem,
  Jr as AccordionRoot,
  ts as AccordionTrigger,
  qu as ArrowLink,
  u_ as AutoFocus,
  Au as Badge,
  s_ as Base,
  Xu as Body,
  ce as Box,
  Un as Button,
  Lu as ButtonLink,
  Tu as Callout,
  Zu as Caption,
  mt as Card,
  ht as Checkbox,
  Jn as CheckboxGroup,
  $e as Collapsible,
  ro as CollapsibleContent,
  eo as CollapsibleRoot,
  to as CollapsibleTrigger,
  ju as ComboBox,
  mn as Countdown,
  hn as Currency,
  Ou as DatePicker,
  Wu as DateRangePicker,
  Vu as DeprecatedFeedbackCallout,
  qt as Description,
  o_ as DescriptionList,
  a_ as DescriptionListItem,
  e_ as Display,
  l_ as DynamicCalendarIcon,
  c_ as ExclamationSpinner,
  pc as FileUploader,
  Jl as FileUploaderDropError,
  d_ as FileUploaderItem,
  ui as FileUploaderRemoveError,
  Ju as Fineprint,
  M as Flex,
  de as FormField,
  Eo as Grid,
  t_ as H1,
  n_ as H2,
  i_ as H3,
  Ku as HeadingBody,
  Gu as HeadingScreen,
  Uu as HeadingSection,
  Yu as HeadingSubsection,
  Du as I18nProvider,
  kc as InformationCard,
  Sc as Input,
  gi as InputGroup,
  ut as InputGroupLabel,
  At as Label,
  Qu as Lead,
  ta as Link,
  xn as List,
  St as ListItemProminent,
  __ as ListItemProminentPlaceholder,
  lt as Message,
  Ne as Modal,
  wl as ModalBody,
  ci as ModalClose,
  Cl as ModalContent,
  Il as ModalFooter,
  Sl as ModalHeader,
  Ml as ModalRoot,
  di as ModalTitle,
  Fl as ModalTrigger,
  m_ as NumberField,
  qc as NumberInput,
  h_ as NumericStepper,
  r_ as Paragraph,
  ct as PlainButton,
  yc as PlainLink,
  Ue as Popover,
  Hu as Prose,
  Xt as QRCode,
  rn as Radio,
  sn as RadioGroup,
  f_ as ResultCard,
  Ld as Select,
  Vd as SelectField,
  E as Show,
  it as Skeleton,
  eu as Slider,
  b_ as SortIndicator,
  Bu as Spacer,
  Lt as Spinner,
  Do as Stack,
  p_ as StepIndicator,
  on as Switch,
  Ei as SwitchLabel,
  $i as SwitchRoot,
  Mi as SwitchThumb,
  y_ as Table,
  H as Text,
  yu as TextField,
  gu as Textarea,
  he as VisuallyHidden,
  g as cx,
  Dt as focusRingClassName,
  Aa as useCountdown,
  vo as useFieldAriaProps,
  Ta as useFormatCountdown,
  V as useLocale,
  ti as useNumberFormatter,
  g_ as useStepIndicatorState
};
//# sourceMappingURL=index.es.js.map
